function _M0DTPB4Json4Null() {}
_M0DTPB4Json4Null.prototype.$tag = 0;
const _M0DTPB4Json4Null__ = new _M0DTPB4Json4Null();
function _M0DTPB4Json4True() {}
_M0DTPB4Json4True.prototype.$tag = 1;
const _M0DTPB4Json4True__ = new _M0DTPB4Json4True();
function _M0DTPB4Json5False() {}
_M0DTPB4Json5False.prototype.$tag = 2;
const _M0DTPB4Json5False__ = new _M0DTPB4Json5False();
function _M0DTPB4Json6Number(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPB4Json6Number.prototype.$tag = 3;
function _M0DTPB4Json6String(param0) {
  this._0 = param0;
}
_M0DTPB4Json6String.prototype.$tag = 4;
function _M0DTPB4Json5Array(param0) {
  this._0 = param0;
}
_M0DTPB4Json5Array.prototype.$tag = 5;
function _M0DTPB4Json6Object(param0) {
  this._0 = param0;
}
_M0DTPB4Json6Object.prototype.$tag = 6;
const $reinterpret_view = new DataView(new ArrayBuffer(8));
function $i64_reinterpret_f64(a) {
  $reinterpret_view.setBigUint64(0, BigInt.asUintN(64, a), false);
  return $reinterpret_view.getFloat64(0, false);
}
function _M0TPC28internal7strconv9FloatInfo(param0, param1, param2) {
  this.mantissa_bits = param0;
  this.exponent_bits = param1;
  this.bias = param2;
}
function _M0TP411moonbitlang5async8internal9coroutine9Scheduler(param0, param1, param2, param3) {
  this.coro_id = param0;
  this.curr_coro = param1;
  this.blocking = param2;
  this.run_later = param3;
}
class $PanicError extends Error {}
function $panic() {
  throw new $PanicError();
}
function _M0TPB9ArrayViewGRP411moonbitlang5async8internal9coroutine9CoroutineE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function $bound_check(arr, index) {
  if (index < 0 || index >= arr.length) throw new Error("Index out of bounds");
}
function _M0TPB13StringBuilder(param0) {
  this.val = param0;
}
function _M0TPC16string10StringView(param0, param1, param2) {
  this.str = param0;
  this.start = param1;
  this.end = param2;
}
function $compare_int(a, b) {
  return (a >= b) - (a <= b);
}
const _M0FPB12random__seed = () => {
  if (globalThis.crypto?.getRandomValues) {
    const array = new Uint32Array(1);
    globalThis.crypto.getRandomValues(array);
    return array[0] | 0; // Convert to signed 32
  } else {
    return Math.floor(Math.random() * 0x100000000) | 0; // Fallback to Math.random
  }
};
function _M0TPB6Hasher(param0) {
  this.acc = param0;
}
const _M0FPB19int__to__string__js = (x, radix) => {
  return x.toString(radix);
};
function _M0TPB4IterGRP411moonbitlang5async8internal9coroutine9CoroutineE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function _M0TPB4IterGcE(param0, param1) {
  this.f = param0;
  this.size_hint = param1;
}
function $makebytes(a, b) {
  const arr = new Uint8Array(a);
  if (b !== 0) {
    arr.fill(b);
  }
  return arr;
}
function _M0TPB8MutLocalGiE(param0) {
  this.val = param0;
}
function $make_array_len_and_init(a, b) {
  const arr = new Array(a);
  arr.fill(b);
  return arr;
}
const _M0MPB7JSArray4push = (arr, val) => { arr.push(val); };
function _M0TPB3MapGsRPB4JsonE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB5EntryGsRPB4JsonE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB5EntryGssE(param0, param1, param2, param3, param4, param5) {
  this.prev = param0;
  this.next = param1;
  this.psl = param2;
  this.hash = param3;
  this.key = param4;
  this.value = param5;
}
function _M0TPB8MutLocalGORPB5EntryGssEE(param0) {
  this.val = param0;
}
const _M0MPB7JSArray3pop = (arr) => arr.pop();
function _M0TPB9ArrayViewGsE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0TPC13set3SetGRP411moonbitlang5async8internal9coroutine9CoroutineE(param0, param1, param2, param3, param4, param5, param6) {
  this.entries = param0;
  this.size = param1;
  this.capacity = param2;
  this.capacity_mask = param3;
  this.grow_at = param4;
  this.head = param5;
  this.tail = param6;
}
function _M0TPB8MutLocalGORPC13set5EntryGRP411moonbitlang5async8internal9coroutine9CoroutineEE(param0) {
  this.val = param0;
}
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC15error5Error51moonbitlang_2fasync_2fjs__async_2eJsError_2eJsError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error51moonbitlang_2fasync_2fjs__async_2eJsError_2eJsError.prototype.$tag = 8;
function _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar.prototype.$tag = 7;
function _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof() {}
_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof.prototype.$tag = 6;
const _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__ = new _M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof();
function _M0DTPC15error5Error54moonbitlang_2fcore_2fjson_2eParseError_2eInvalidNumber(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC15error5Error54moonbitlang_2fcore_2fjson_2eParseError_2eInvalidNumber.prototype.$tag = 5;
function _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eInvalidIdentEscape(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eInvalidIdentEscape.prototype.$tag = 4;
function _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded() {}
_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded.prototype.$tag = 3;
const _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__ = new _M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded();
function _M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled() {}
_M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled.prototype.$tag = 2;
const _M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled__ = new _M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled();
function _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError.prototype.$tag = 1;
function _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(param0) {
  this._0 = param0;
}
_M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGlRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGlRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGdRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGdRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TPC28internal7strconv6Number(param0, param1, param2, param3) {
  this.exponent = param0;
  this.mantissa = param1;
  this.negative = param2;
  this.many_digits = param3;
}
function _M0DTPC16result6ResultGdRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGdRPC15error5ErrorE2Ok.prototype.$tag = 1;
function $i64_clz(a) {
  a = BigInt.asUintN(64, a);
  if (a === 0n) return 64;
  const hi = Number(a >> 32n);
  if (hi !== 0) {
    return Math.clz32(hi);
  }
  return 32 + Math.clz32(Number(a & 0xffffffffn));
}
function _M0DTPC16result6ResultGlRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGlRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0TPC28internal7strconv7Decimal(param0, param1, param2, param3, param4) {
  this.digits = param0;
  this.digits_num = param1;
  this.decimal_point = param2;
  this.negative = param3;
  this.truncated = param4;
}
function _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok.prototype.$tag = 1;
function $f64_convert_i64_u(a) {
  return Number(a);
}
function _M0DTPC16option6OptionGdE4None() {}
_M0DTPC16option6OptionGdE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGdE4None__ = new _M0DTPC16option6OptionGdE4None();
function _M0DTPC16option6OptionGdE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGdE4Some.prototype.$tag = 1;
function _M0TPC14json8Position(param0, param1) {
  this.line = param0;
  this.column = param1;
}
function _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGuRPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGuRPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGuRPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0TPC14json12ParseContext(param0, param1, param2, param3) {
  this.offset = param0;
  this.input = param1;
  this.end_offset = param2;
  this.remaining_available_depth = param3;
}
function $f64_convert_i64(a) {
  return Number(BigInt.asIntN(64, a));
}
function _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok.prototype.$tag = 1;
function _M0DTPC14json5Token4Null() {}
_M0DTPC14json5Token4Null.prototype.$tag = 0;
const _M0DTPC14json5Token4Null__ = new _M0DTPC14json5Token4Null();
function _M0DTPC14json5Token4True() {}
_M0DTPC14json5Token4True.prototype.$tag = 1;
const _M0DTPC14json5Token4True__ = new _M0DTPC14json5Token4True();
function _M0DTPC14json5Token5False() {}
_M0DTPC14json5Token5False.prototype.$tag = 2;
const _M0DTPC14json5Token5False__ = new _M0DTPC14json5Token5False();
function _M0DTPC14json5Token6Number(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json5Token6Number.prototype.$tag = 3;
function _M0DTPC14json5Token6String(param0) {
  this._0 = param0;
}
_M0DTPC14json5Token6String.prototype.$tag = 4;
function _M0DTPC14json5Token6LBrace() {}
_M0DTPC14json5Token6LBrace.prototype.$tag = 5;
const _M0DTPC14json5Token6LBrace__ = new _M0DTPC14json5Token6LBrace();
function _M0DTPC14json5Token6RBrace() {}
_M0DTPC14json5Token6RBrace.prototype.$tag = 6;
const _M0DTPC14json5Token6RBrace__ = new _M0DTPC14json5Token6RBrace();
function _M0DTPC14json5Token8LBracket() {}
_M0DTPC14json5Token8LBracket.prototype.$tag = 7;
const _M0DTPC14json5Token8LBracket__ = new _M0DTPC14json5Token8LBracket();
function _M0DTPC14json5Token8RBracket() {}
_M0DTPC14json5Token8RBracket.prototype.$tag = 8;
const _M0DTPC14json5Token8RBracket__ = new _M0DTPC14json5Token8RBracket();
function _M0DTPC14json5Token5Comma() {}
_M0DTPC14json5Token5Comma.prototype.$tag = 9;
const _M0DTPC14json5Token5Comma__ = new _M0DTPC14json5Token5Comma();
function _M0TPB9ArrayViewGUsRPB4JsonEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC14json10WriteFrame5Array(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json10WriteFrame5Array.prototype.$tag = 0;
function _M0DTPC14json10WriteFrame6Object(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json10WriteFrame6Object.prototype.$tag = 1;
function _M0DTPC14json8JsonPath4Root() {}
_M0DTPC14json8JsonPath4Root.prototype.$tag = 0;
const _M0DTPC14json8JsonPath4Root__ = new _M0DTPC14json8JsonPath4Root();
function _M0DTPC14json8JsonPath3Key(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json8JsonPath3Key.prototype.$tag = 1;
function _M0DTPC14json8JsonPath5Index(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTPC14json8JsonPath5Index.prototype.$tag = 2;
function _M0DTPC16result6ResultGRPB4JsonRPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB4JsonRPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB4JsonRPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0TPB9ArrayViewGUssEE(param0, param1, param2) {
  this.buf = param0;
  this.start = param1;
  this.end = param2;
}
function _M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE2Ok.prototype.$tag = 1;
function _M0TPC13ref3RefGRP310Haoxincode8moonbash7website8AppStateE(param0) {
  this.val = param0;
}
function _M0TPC15deque5DequeGRP411moonbitlang5async8internal9coroutine9CoroutineE(param0, param1, param2) {
  this.buf = param0;
  this.len = param1;
  this.head = param2;
}
function _M0DTP411moonbitlang5async8internal9coroutine5State4Done() {}
_M0DTP411moonbitlang5async8internal9coroutine5State4Done.prototype.$tag = 0;
const _M0DTP411moonbitlang5async8internal9coroutine5State4Done__ = new _M0DTP411moonbitlang5async8internal9coroutine5State4Done();
function _M0DTP411moonbitlang5async8internal9coroutine5State4Fail(param0) {
  this._0 = param0;
}
_M0DTP411moonbitlang5async8internal9coroutine5State4Fail.prototype.$tag = 1;
function _M0DTP411moonbitlang5async8internal9coroutine5State7Running() {}
_M0DTP411moonbitlang5async8internal9coroutine5State7Running.prototype.$tag = 2;
const _M0DTP411moonbitlang5async8internal9coroutine5State7Running__ = new _M0DTP411moonbitlang5async8internal9coroutine5State7Running();
function _M0DTP411moonbitlang5async8internal9coroutine5State7Suspend(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine5State7Suspend.prototype.$tag = 3;
function _M0DTPC16result6ResultGOuRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOuRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State18_2adefer__try_2f66(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State18_2adefer__try_2f66.prototype.$tag = 0;
function _M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State8State__1(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State8State__1.prototype.$tag = 1;
function _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__0(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__0.prototype.$tag = 0;
function _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State11_2atry_2f78(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State11_2atry_2f78.prototype.$tag = 1;
function _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__2(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__2.prototype.$tag = 2;
function _M0TP411moonbitlang5async8internal9coroutine9Coroutine(param0, param1, param2, param3, param4, param5) {
  this.coro_id = param0;
  this.state = param1;
  this.shielded = param2;
  this.cancelled = param3;
  this.ready = param4;
  this.downstream = param5;
}
function _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE19_2adefer__try_2f138(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE19_2adefer__try_2f138.prototype.$tag = 0;
function _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE8State__1(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE8State__1.prototype.$tag = 1;
const _M0FP411moonbitlang5async8internal11event__loop12set__timeout = (duration, f) => setTimeout(f, duration);
const _M0MP411moonbitlang5async8internal11event__loop5Timer6cancel = (timer) => clearTimeout(timer);
function _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State19_2adefer__try_2f160(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State19_2adefer__try_2f160.prototype.$tag = 0;
function _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State8State__1(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State8State__1.prototype.$tag = 1;
const _M0MP311moonbitlang5async9js__async15AbortController5abort = (controller) => controller.abort();
const _M0MP311moonbitlang5async9js__async7JsValue4then = (p, resolve, reject) => p.then(resolve, reject);
function _M0DTPC16result6ResultGOsRPC15error5ErrorE3Err(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOsRPC15error5ErrorE3Err.prototype.$tag = 0;
function _M0DTPC16result6ResultGOsRPC15error5ErrorE2Ok(param0) {
  this._0 = param0;
}
_M0DTPC16result6ResultGOsRPC15error5ErrorE2Ok.prototype.$tag = 1;
function _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83.prototype.$tag = 0;
function _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1.prototype.$tag = 1;
function _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE11_2atry_2f84(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE11_2atry_2f84.prototype.$tag = 2;
function _M0TP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL6WaiterGsE(param0, param1, param2) {
  this.coro = param0;
  this.ret = param1;
  this.err = param2;
}
const _M0MP311moonbitlang5async9js__async11AbortSignal9on__abort = (signal, f) => signal.addEventListener('abort', f, { once: true });
const _M0MP311moonbitlang5async9js__async7JsValue12abort__error = () => {
   const err = new Error()
   err.name = 'AbortError'
   return err
 };
const _M0MP311moonbitlang5async9js__async7JsValue12new__promise = (f) => new Promise(f);
function _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE12_2atry_2f130(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE12_2atry_2f130.prototype.$tag = 0;
function _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE8State__1(param0, param1) {
  this._0 = param0;
  this._1 = param1;
}
_M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE8State__1.prototype.$tag = 1;
const _M0MP311moonbitlang5async9js__async7JsValue10to__string = (v) => v.toString();
const _M0FP24tiye9dom_2dffi6window = () => window;
const _M0FP24tiye9dom_2dffi12set__timeout = (f, ms) => setTimeout(f, ms);
const _M0MP24tiye9dom_2dffi4Node5style = (self) => self.style;
const _M0MP24tiye9dom_2dffi19CSSStyleDeclaration13set__property = (self, name, value) => { self[name] = value };
const _M0MP24tiye9dom_2dffi6Window14local__storage = (self) => self.localStorage;
const _M0MP24tiye9dom_2dffi12LocalStorage13js__get__item = (self, key) => self.getItem(key);
const _M0MP24tiye9dom_2dffi9JsObscure7is__nil = (self) => self == null;
const _M0MP24tiye9dom_2dffi12LocalStorage9set__item = (self, key, value) => { self.setItem(key, value) };
const _M0MP24tiye9dom_2dffi7Element21reinterpret__as__node = (self) => self;
const _M0MP24tiye9dom_2dffi7Element16set__inner__html = (self, html) => { self.innerHTML = html };
const _M0MP24tiye9dom_2dffi7Element16set__inner__text = (self, text) => { self.innerText = text };
const _M0MP24tiye9dom_2dffi7Element14set__attribute = (self, name, value) => { self.setAttribute(name, value) };
const _M0MP24tiye9dom_2dffi7Element17remove__attribute = (self, name) => { self.removeAttribute(name) };
const _M0MP24tiye9dom_2dffi7Element20set__data__attribute = (self, name, value) => { self.dataset[name] = value };
const _M0MP24tiye9dom_2dffi7Element13append__child = (self, child) => { self.appendChild(child) };
const _M0MP24tiye9dom_2dffi16HtmlInputElement14set__onkeydown = (self, f) => { self.onkeydown = f };
const _M0MP24tiye9dom_2dffi7Element37reinterpret__as__html__input__element = (self) => self;
const _M0MP24tiye9dom_2dffi16HtmlInputElement5value = (self) => self.value;
const _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value = (self, value) => { self.value = value };
const _M0MP24tiye9dom_2dffi7Element12set__onclick = (self, f) => { self.onclick = f };
const _M0MP24tiye9dom_2dffi13KeyboardEvent3key = (self) => self.key;
const _M0MP24tiye9dom_2dffi13KeyboardEvent16prevent__default = (self) => self.preventDefault();
const _M0MP24tiye9dom_2dffi6Window8document = (self) => self.document;
const _M0FP24tiye9dom_2dffi24js__get__element__by__id = (doc, id) => doc.getElementById(id);
function _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4None() {}
_M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4None__ = new _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4None();
function _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4Some.prototype.$tag = 1;
const _M0MP24tiye9dom_2dffi8Document15create__element = (self, name) => self.createElement(name);
const _M0FP310Haoxincode8moonbash7website27element__scroll__to__bottom = (element) => {
   element.scrollTop = element.scrollHeight;
 };
const _M0FP310Haoxincode8moonbash7website16throw__js__error = (message) => { throw new Error(message) };
function _M0TP310Haoxincode8moonbash7website7DomRefs(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, param16, param17, param18, param19) {
  this.shell = param0;
  this.title = param1;
  this.github_link = param2;
  this.docs_link = param3;
  this.output = param4;
  this.input_row = param5;
  this.input = param6;
  this.location = param7;
  this.demo_panel = param8;
  this.tabs = param9;
  this.verification_tab = param10;
  this.showcase_tab = param11;
  this.demo_state = param12;
  this.demo_summary = param13;
  this.demo_progress = param14;
  this.demo_last = param15;
  this.demo_bar_fill = param16;
  this.run_button = param17;
  this.replay_button = param18;
  this.stop_button = param19;
}
const _M0FP310Haoxincode8moonbash7website26get__runtime__config__json = () => globalThis.__moonbash_demo_config_json ?? "{}";
const _M0FP310Haoxincode8moonbash7website18html__input__focus = (input) => input.focus();
function _M0TP310Haoxincode8moonbash7website8DemoStep(param0, param1, param2, param3, param4, param5, param6, param7, param8) {
  this.kind = param0;
  this.group = param1;
  this.label = param2;
  this.text = param3;
  this.command = param4;
  this.expect_exit_code = param5;
  this.expect_stdout_includes = param6;
  this.expect_stderr_includes = param7;
  this.delay_ms = param8;
}
function _M0TP310Haoxincode8moonbash7website8DemoMode(param0, param1, param2, param3, param4, param5, param6) {
  this.key = param0;
  this.title = param1;
  this.summary = param2;
  this.intro = param3;
  this.autoplay = param4;
  this.initial_delay_ms = param5;
  this.steps = param6;
}
const _M0FP310Haoxincode8moonbash7website21create__bash__runtime = (configJson) => {
   const libs = globalThis.__moonbash_demo_runtime_libs;
   if (!libs || typeof libs.Bash !== "function" || typeof libs.defineCommand !== "function") {
     throw new Error("moonbash website runtime libraries are not configured");
   }
   const config = JSON.parse(configJson || "{}");
   const Bash = libs.Bash;
   const defineCommand = libs.defineCommand;
   const aboutCmd = defineCommand("about", async () => ({
     stdout: String(config.aboutText ?? ""),
     stderr: "",
     exitCode: 0,
   }));
   const installCmd = defineCommand("install", async () => ({
     stdout: String(config.installText ?? ""),
     stderr: "",
     exitCode: 0,
   }));
   const githubCmd = defineCommand("github", async () => ({
     stdout: String(config.githubText ?? ""),
     stderr: "",
     exitCode: 0,
   }));
   return new Bash({
     cwd: String(config.cwd ?? "/home/user"),
     env: config.env ?? {},
     files: config.files ?? {},
     customCommands: [aboutCmd, installCmd, githubCmd],
   });
 };
function _M0TP310Haoxincode8moonbash7website10ShellState(param0, param1, param2) {
  this.bash = param0;
  this.cwd = param1;
  this.env = param2;
}
function _M0TP310Haoxincode8moonbash7website8AppState(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15) {
  this.config = param0;
  this.dom = param1;
  this.demo_modes = param2;
  this.current_mode_idx = param3;
  this.shell = param4;
  this.history = param5;
  this.history_index = param6;
  this.draft_command = param7;
  this.command_running = param8;
  this.verification_running = param9;
  this.verification_run_id = param10;
  this.verification_completed = param11;
  this.verification_passed = param12;
  this.verification_failed = param13;
  this.verification_status = param14;
  this.verification_last_message = param15;
}
function _M0TP310Haoxincode8moonbash7website13WebsiteConfig(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13) {
  this.version = param0;
  this.github_url = param1;
  this.docs_url = param2;
  this.welcome_text = param3;
  this.showcase_intro = param4;
  this.initial_command = param5;
  this.verification_title = param6;
  this.showcase_title = param7;
  this.default_mode = param8;
  this.verification_auto_start = param9;
  this.verification_initial_delay_ms = param10;
  this.command_names = param11;
  this.env = param12;
  this.cwd = param13;
}
const _M0FP310Haoxincode8moonbash7website29html__input__selection__start = (input) => input.selectionStart ?? input.value.length;
const _M0FP310Haoxincode8moonbash7website34html__input__set__selection__range = (input, start, end) => input.setSelectionRange(start, end);
function _M0TP310Haoxincode8moonbash7website8DirEntry(param0, param1) {
  this.name = param0;
  this.type_ = param1;
}
const _M0MP310Haoxincode8moonbash7website11BashRuntime13readdir__json = (self, path) => {
   try {
     return JSON.stringify(self.getFs().readdir(path));
   } catch (_error) {
     return "[]";
   }
 };
const _M0FP310Haoxincode8moonbash7website17string__lowercase = (value) => value.toLowerCase();
function _M0TP310Haoxincode8moonbash7website10ExecResult(param0, param1, param2, param3) {
  this.stdout = param0;
  this.stderr = param1;
  this.exit_code = param2;
  this.env = param3;
}
const _M0FP310Haoxincode8moonbash7website26html__input__set__disabled = (input, disabled) => { input.disabled = disabled };
const _M0MP310Haoxincode8moonbash7website11BashRuntime10exec__json = async (self, script, cwd, envJson) => {
   const env = envJson && envJson.length > 0 ? JSON.parse(envJson) : {};
   try {
     const result = await self.exec(script, { cwd, env });
     return JSON.stringify(result);
   } catch (error) {
     const message = error && error.message ? error.message : String(error);
     return JSON.stringify({
       stdout: "",
       stderr: message,
       exitCode: 1,
       env,
     });
   }
 };
function _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State8State__0(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State8State__0.prototype.$tag = 0;
function _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State12_2atry_2f418(param0, param1, param2) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
}
_M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State12_2atry_2f418.prototype.$tag = 1;
function _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None() {}
_M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None__ = new _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None();
function _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4Some.prototype.$tag = 1;
function _M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4None() {}
_M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4None__ = new _M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4None();
function _M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4Some.prototype.$tag = 1;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__0(param0, param1, param2, param3) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__0.prototype.$tag = 0;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State9_2afor__1(param0, param1, param2, param3, param4, param5, param6, param7) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
  this._5 = param5;
  this._6 = param6;
  this._7 = param7;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State9_2afor__1.prototype.$tag = 1;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State17_2acontinue_2f447(param0, param1, param2, param3, param4, param5, param6, param7) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
  this._5 = param5;
  this._6 = param6;
  this._7 = param7;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State17_2acontinue_2f447.prototype.$tag = 2;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__3(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
  this._5 = param5;
  this._6 = param6;
  this._7 = param7;
  this._8 = param8;
  this._9 = param9;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__3.prototype.$tag = 3;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State12_2atry_2f456(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
  this._5 = param5;
  this._6 = param6;
  this._7 = param7;
  this._8 = param8;
  this._9 = param9;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State12_2atry_2f456.prototype.$tag = 4;
function _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__5(param0, param1, param2, param3, param4, param5, param6, param7, param8, param9) {
  this._0 = param0;
  this._1 = param1;
  this._2 = param2;
  this._3 = param3;
  this._4 = param4;
  this._5 = param5;
  this._6 = param6;
  this._7 = param7;
  this._8 = param8;
  this._9 = param9;
}
_M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__5.prototype.$tag = 5;
function _M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4None() {}
_M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4None.prototype.$tag = 0;
const _M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4None__ = new _M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4None();
function _M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4Some(param0) {
  this._0 = param0;
}
_M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4Some.prototype.$tag = 1;
const _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger = { method_0: _M0IPB13StringBuilderPB6Logger13write__string, method_1: _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE, method_2: _M0IPB13StringBuilderPB6Logger11write__view, method_3: _M0IPB13StringBuilderPB6Logger11write__char, method_4: _M0IP016_24default__implPB6Logger5writeGRPB13StringBuilderE };
function _M0FP15Error10to__string(_e) {
  switch (_e.$tag) {
    case 8: {
      return _M0IP016_24default__implPB4Show10to__stringGRP311moonbitlang5async9js__async7JsErrorE(_e);
    }
    case 1: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json15JsonDecodeErrorE(_e);
    }
    case 5: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 0: {
      return _M0IP016_24default__implPB4Show10to__stringGRPB7FailureE(_e);
    }
    case 6: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 7: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 4: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    case 3: {
      return _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(_e);
    }
    default: {
      return _M0IP016_24default__implPB4Show10to__stringGRP411moonbitlang5async8internal9coroutine9CancelledE(_e);
    }
  }
}
const _M0MPC16string6String9trim__endN7_2abindS5954 = "\t\n\r ";
const _M0MPC16string6String4trimN7_2abindS5977 = "\t\n\r ";
const _M0FPB4null = _M0DTPB4Json4Null__;
const _M0MPB4Iter4nextN6constrS8638GRP411moonbitlang5async8internal9coroutine9CoroutineE = 0;
const _M0MPB4Iter4nextN6constrS8639GRP411moonbitlang5async8internal9coroutine9CoroutineE = 0;
const _M0MPB4Iter4nextN6constrS8638GcE = 0;
const _M0MPB4Iter4nextN6constrS8639GcE = 0;
const _M0MPB4Iter3newN6constrS8646GRP411moonbitlang5async8internal9coroutine9CoroutineE = 0;
const _M0MPB4Iter3newN6constrS8646GcE = 0;
const _M0FPC16double14not__a__number = $i64_reinterpret_f64(9221120237041090561n);
const _M0FPC16double8infinity = $i64_reinterpret_f64(9218868437227405312n);
const _M0FPC16double13neg__infinity = $i64_reinterpret_f64(18442240474082181120n);
const _M0FPC28internal7strconv14base__err__str = "invalid base";
const _M0FPC28internal7strconv15range__err__str = "value out of range";
const _M0FPC28internal7strconv16syntax__err__str = "invalid syntax";
const _M0FPC28internal7strconv17min__19digit__int = 1000000000000000000n;
const _M0FPC28internal7strconv17parse__scientificN8exp__numS241 = 0n;
const _M0FPC28internal7strconv13parse__numberN11exp__numberS222 = 0n;
const _M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658 = "";
const _M0FPC28internal7strconv12double__info = new _M0TPC28internal7strconv9FloatInfo(52, 11, -1023);
const _M0FPC28internal7strconv25min__exponent__fast__path = 18446744073709551594n;
const _M0FPC28internal7strconv25max__exponent__fast__path = 22n;
const _M0FPC28internal7strconv36max__exponent__disguised__fast__path = 37n;
const _M0FPC28internal7strconv25max__mantissa__fast__path = 9007199254740992n;
const _M0FPC28internal7strconv6powtab = [1, 3, 6, 9, 13, 16, 19, 23, 26, 29, 33, 36, 39, 43, 46, 49, 53, 56, 59];
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1049 = { _0: 0, _1: "" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1050 = { _0: 1, _1: "5" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1051 = { _0: 1, _1: "25" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1052 = { _0: 1, _1: "125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1053 = { _0: 2, _1: "625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1054 = { _0: 2, _1: "3125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1055 = { _0: 2, _1: "15625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1056 = { _0: 3, _1: "78125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1057 = { _0: 3, _1: "390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1058 = { _0: 3, _1: "1953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1059 = { _0: 4, _1: "9765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1060 = { _0: 4, _1: "48828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1061 = { _0: 4, _1: "244140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1062 = { _0: 4, _1: "1220703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1063 = { _0: 5, _1: "6103515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1064 = { _0: 5, _1: "30517578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1065 = { _0: 5, _1: "152587890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1066 = { _0: 6, _1: "762939453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1067 = { _0: 6, _1: "3814697265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1068 = { _0: 6, _1: "19073486328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1069 = { _0: 7, _1: "95367431640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1070 = { _0: 7, _1: "476837158203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1071 = { _0: 7, _1: "2384185791015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1072 = { _0: 7, _1: "11920928955078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1073 = { _0: 8, _1: "59604644775390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1074 = { _0: 8, _1: "298023223876953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1075 = { _0: 8, _1: "1490116119384765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1076 = { _0: 9, _1: "7450580596923828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1077 = { _0: 9, _1: "37252902984619140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1078 = { _0: 9, _1: "186264514923095703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1079 = { _0: 10, _1: "931322574615478515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1080 = { _0: 10, _1: "4656612873077392578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1081 = { _0: 10, _1: "23283064365386962890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1082 = { _0: 10, _1: "116415321826934814453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1083 = { _0: 11, _1: "582076609134674072265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1084 = { _0: 11, _1: "2910383045673370361328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1085 = { _0: 11, _1: "14551915228366851806640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1086 = { _0: 12, _1: "72759576141834259033203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1087 = { _0: 12, _1: "363797880709171295166015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1088 = { _0: 12, _1: "1818989403545856475830078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1089 = { _0: 13, _1: "9094947017729282379150390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1090 = { _0: 13, _1: "45474735088646411895751953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1091 = { _0: 13, _1: "227373675443232059478759765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1092 = { _0: 13, _1: "1136868377216160297393798828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1093 = { _0: 14, _1: "5684341886080801486968994140625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1094 = { _0: 14, _1: "28421709430404007434844970703125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1095 = { _0: 14, _1: "142108547152020037174224853515625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1096 = { _0: 15, _1: "710542735760100185871124267578125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1097 = { _0: 15, _1: "3552713678800500929355621337890625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1098 = { _0: 15, _1: "17763568394002504646778106689453125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1099 = { _0: 16, _1: "88817841970012523233890533447265625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1100 = { _0: 16, _1: "444089209850062616169452667236328125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1101 = { _0: 16, _1: "2220446049250313080847263336181640625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1102 = { _0: 16, _1: "11102230246251565404236316680908203125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1103 = { _0: 17, _1: "55511151231257827021181583404541015625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1104 = { _0: 17, _1: "277555756156289135105907917022705078125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1105 = { _0: 17, _1: "1387778780781445675529539585113525390625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1106 = { _0: 18, _1: "6938893903907228377647697925567626953125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1107 = { _0: 18, _1: "34694469519536141888238489627838134765625" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1108 = { _0: 18, _1: "173472347597680709441192448139190673828125" };
const _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1109 = { _0: 19, _1: "867361737988403547205962240695953369140625" };
const _M0FPC28internal7strconv19left__shift__cheats = [_M0FPC28internal7strconv19left__shift__cheatsN5tupleS1049, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1050, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1051, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1052, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1053, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1054, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1055, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1056, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1057, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1058, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1059, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1060, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1061, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1062, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1063, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1064, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1065, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1066, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1067, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1068, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1069, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1070, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1071, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1072, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1073, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1074, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1075, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1076, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1077, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1078, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1079, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1080, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1081, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1082, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1083, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1084, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1085, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1086, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1087, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1088, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1089, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1090, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1091, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1092, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1093, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1094, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1095, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1096, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1097, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1098, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1099, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1100, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1101, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1102, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1103, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1104, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1105, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1106, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1107, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1108, _M0FPC28internal7strconv19left__shift__cheatsN5tupleS1109];
const _M0FPC28internal7strconv10int__pow10 = [1n, 10n, 100n, 1000n, 10000n, 100000n, 1000000n, 10000000n, 100000000n, 1000000000n, 10000000000n, 100000000000n, 1000000000000n, 10000000000000n, 100000000000000n, 1000000000000000n];
const _M0FPC28internal7strconv5table = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1e+12, 1e+13, 1e+14, 1e+15, 1e+16, 1e+17, 1e+18, 1e+19, 1e+20, 1e+21, 1e+22, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const _M0FPC28internal7strconv12checked__mulN6constrS1190 = 0n;
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1120 = ".";
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1121 = "e";
const _M0MPC14json12ParseContext16lex__number__endN7_2abindS1122 = "E";
const _M0IPC14json8JsonPathPB4Show6outputN7_2abindS1456 = "~/";
const _M0FP310Haoxincode8moonbash7website17apply__completionN7_2abindS357 = "    ";
const _M0FP310Haoxincode8moonbash7website14evaluate__stepN7_2abindS446 = "; ";
const _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einnerN6constrS591 = 0;
const _M0FPB18brute__force__findN6constrS8649 = 0;
const _M0FPB28boyer__moore__horspool__findN6constrS8648 = 0;
const _M0FP411moonbitlang5async8internal9coroutine9scheduler = new _M0TP411moonbitlang5async8internal9coroutine9Scheduler(0, undefined, 0, _M0MPC15deque5Deque11new_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(0));
const _M0FPB4seed = _M0FPB12random__seed();
const _M0FP310Haoxincode8moonbash7website13handle__enterN6constrS602 = true;
const _M0FP310Haoxincode8moonbash7website26create__availability__stepN6constrS592 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS593 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS594 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS595 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS596 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS597 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS598 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS599 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS600 = 0;
const _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS601 = 0;
function _M0FPC15abort5abortGRPC16string10StringViewE(msg) {
  return $panic();
}
function _M0FPC15abort5abortGuE(msg) {
  $panic();
}
function _M0FPC15abort5abortGOiE(msg) {
  return $panic();
}
function _M0MPB6Logger13write__objectGRPC14json8JsonPathE(self, obj) {
  _M0IPC14json8JsonPathPB4Show6output(obj, self);
}
function _M0MPB6Logger13write__objectGsE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGsE(obj, self);
}
function _M0MPB6Logger13write__objectGiE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGiE(obj, self);
}
function _M0IPB7FailurePB4Show6output(_x_4786, _x_4787) {
  const _Failure = _x_4786;
  const _$42$arg_4788 = _Failure._0;
  _x_4787.method_table.method_0(_x_4787.self, "Failure(");
  _M0MPB6Logger13write__objectGsE(_x_4787, _$42$arg_4788);
  _x_4787.method_table.method_0(_x_4787.self, ")");
}
function _M0MPB6Hasher8consume4(self, input) {
  const _p = (self.acc >>> 0) + ((Math.imul(input, -1028477379) | 0) >>> 0) | 0;
  const _p$2 = 17;
  self.acc = Math.imul(_p << _p$2 | (_p >>> (32 - _p$2 | 0) | 0), 668265263) | 0;
}
function _M0MPB6Hasher13combine__uint(self, value) {
  self.acc = (self.acc >>> 0) + (4 >>> 0) | 0;
  _M0MPB6Hasher8consume4(self, value);
}
function _M0MPB18UninitializedArray11sub_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    end$2 = _Some;
  }
  if (start >= 0 && (start <= end$2 && end$2 <= len)) {
    const _bind = end$2 - start | 0;
    return new _M0TPB9ArrayViewGRP411moonbitlang5async8internal9coroutine9CoroutineE(self, start, start + _bind | 0);
  } else {
    return _M0FPC15abort5abortGRPC16string10StringViewE("View start index out of bounds");
  }
}
function _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGRP411moonbitlang5async8internal9coroutine9CoroutineEE(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp = len - 1 | 0;
    while (true) {
      const i = _tmp;
      if (i >= 0) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function _M0MPB18UninitializedArray12unsafe__blitGRP411moonbitlang5async8internal9coroutine9CoroutineE(dst, dst_offset, src, src_offset, len) {
  _M0MPC15array10FixedArray12unsafe__blitGRPB17UnsafeMaybeUninitGRP411moonbitlang5async8internal9coroutine9CoroutineEE(dst, dst_offset, src, src_offset, len);
}
function _M0MPB13StringBuilder21StringBuilder_2einner(size_hint) {
  return new _M0TPB13StringBuilder("");
}
function _M0IPB13StringBuilderPB6Logger11write__char(self, ch) {
  self.val = `${self.val}${String.fromCodePoint(ch)}`;
}
function _M0MPC16uint166UInt1622is__leading__surrogate(self) {
  return _M0IP016_24default__implPB7Compare6op__geGkE(self, 55296) && _M0IP016_24default__implPB7Compare6op__leGkE(self, 56319);
}
function _M0MPC16uint166UInt1623is__trailing__surrogate(self) {
  return _M0IP016_24default__implPB7Compare6op__geGkE(self, 56320) && _M0IP016_24default__implPB7Compare6op__leGkE(self, 57343);
}
function _M0FPB32code__point__of__surrogate__pair(leading, trailing) {
  return (((Math.imul(leading - 55296 | 0, 1024) | 0) + trailing | 0) - 56320 | 0) + 65536 | 0;
}
function _M0MPC16string6String16unsafe__char__at(self, index) {
  const c1 = self.charCodeAt(index);
  if (_M0MPC16uint166UInt1622is__leading__surrogate(c1)) {
    const c2 = self.charCodeAt(index + 1 | 0);
    return _M0FPB32code__point__of__surrogate__pair(c1, c2);
  } else {
    return c1;
  }
}
function _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488(i) {
  if (i < 10) {
    const _p = 48;
    const _p$2 = (i + _p | 0) & 255;
    return _p$2;
  } else {
    const _p = 97;
    const _p$2 = (i + _p | 0) & 255;
    const _p$3 = 10;
    const _p$4 = (_p$2 - _p$3 | 0) & 255;
    return _p$4;
  }
}
function _M0MPC14byte4Byte7to__hex(b) {
  const _self = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _p = 16;
  _M0IPB13StringBuilderPB6Logger11write__char(_self, _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488((b / _p | 0) & 255));
  const _p$2 = 16;
  _M0IPB13StringBuilderPB6Logger11write__char(_self, _M0MPC14byte4Byte7to__hexN14to__hex__digitS3488((b % _p$2 | 0) & 255));
  const _p$3 = _self;
  return _p$3.val;
}
function _M0MPC16string10StringView11sub_2einner(self, start, end) {
  const str_len = self.str.length;
  let abs_end;
  if (end === undefined) {
    abs_end = self.end;
  } else {
    const _Some = end;
    const _end = _Some;
    abs_end = _end < 0 ? self.end + _end | 0 : self.start + _end | 0;
  }
  const abs_start = start < 0 ? self.end + start | 0 : self.start + start | 0;
  if (abs_start >= self.start && (abs_start <= abs_end && abs_end <= self.end)) {
    if (abs_start < str_len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.str.charCodeAt(abs_start))) {
      } else {
        $panic();
      }
    }
    if (abs_end < str_len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.str.charCodeAt(abs_end))) {
      } else {
        $panic();
      }
    }
    return new _M0TPC16string10StringView(self.str, abs_start, abs_end);
  } else {
    return $panic();
  }
}
function _M0MPB13StringBuilder13write__objectGdE(self, obj) {
  _M0IP016_24default__implPB4Show6outputGdE(obj, { self: self, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
}
function _M0IPB13StringBuilderPB6Logger13write__string(self, str) {
  self.val = `${self.val}${str}`;
}
function _M0MPB6Hasher7combineGsE(self, value) {
  _M0IPC16string6StringPB4Hash13hash__combine(value, self);
}
function _M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(x, y) {
  return !_M0IPC16string10StringViewPB2Eq5equal(x, y);
}
function _M0IP016_24default__implPB7Compare6op__leGkE(x, y) {
  return $compare_int(x, y) <= 0;
}
function _M0IP016_24default__implPB7Compare6op__geGkE(x, y) {
  return $compare_int(x, y) >= 0;
}
function _M0MPB6Hasher9avalanche(self) {
  let acc = self.acc;
  acc = acc ^ (acc >>> 15 | 0);
  acc = Math.imul(acc, -2048144777) | 0;
  acc = acc ^ (acc >>> 13 | 0);
  acc = Math.imul(acc, -1028477379) | 0;
  acc = acc ^ (acc >>> 16 | 0);
  return acc;
}
function _M0MPB6Hasher8finalize(self) {
  return _M0MPB6Hasher9avalanche(self);
}
function _M0MPB6Hasher11new_2einner(seed) {
  return new _M0TPB6Hasher((seed >>> 0) + (374761393 >>> 0) | 0);
}
function _M0MPB6Hasher3new(seed$46$opt) {
  let seed;
  if (seed$46$opt === undefined) {
    seed = _M0FPB4seed;
  } else {
    const _Some = seed$46$opt;
    seed = _Some;
  }
  return _M0MPB6Hasher11new_2einner(seed);
}
function _M0IP016_24default__implPB4Hash4hashGsE(self) {
  const h = _M0MPB6Hasher3new(undefined);
  _M0MPB6Hasher7combineGsE(h, self);
  return _M0MPB6Hasher8finalize(h);
}
function _M0IP016_24default__implPB6Logger5writeGRPB13StringBuilderE(self, show) {
  show.method_table.method_0(show.self, { self: self, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
}
function _M0MPC16string6String11sub_2einner(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    if (start$2 < len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.charCodeAt(start$2))) {
      } else {
        $panic();
      }
    }
    if (end$2 < len) {
      if (!_M0MPC16uint166UInt1623is__trailing__surrogate(self.charCodeAt(end$2))) {
      } else {
        $panic();
      }
    }
    return new _M0TPC16string10StringView(self, start$2, end$2);
  } else {
    return $panic();
  }
}
function _M0IP016_24default__implPB6Logger16write__substringGRPB13StringBuilderE(self, value, start, len) {
  _M0IPB13StringBuilderPB6Logger11write__view(self, _M0MPC16string6String11sub_2einner(value, start, start + len | 0));
}
function _M0IP016_24default__implPB4Show6outputGdE(self, logger) {
  logger.method_table.method_0(logger.self, _M0IPC16double6DoublePB4Show10to__string(self));
}
function _M0IP016_24default__implPB4Show6outputGsE(self, logger) {
  logger.method_table.method_0(logger.self, self);
}
function _M0IP016_24default__implPB4Show6outputGiE(self, logger) {
  logger.method_table.method_0(logger.self, _M0IPC13int3IntPB4Show10to__string(self));
}
function _M0IP016_24default__implPB4Show10to__stringGRPC14json15JsonDecodeErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC14json15JsonDecodeErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPB7FailureE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPB7FailurePB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP411moonbitlang5async8internal9coroutine9CancelledE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const _p = { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger };
  _p.method_table.method_0(_p.self, "Cancelled");
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRPC14json10ParseErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IPC14json10ParseErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0IP016_24default__implPB4Show10to__stringGRP311moonbitlang5async9js__async7JsErrorE(self) {
  const logger = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0IP311moonbitlang5async9js__async7JsErrorPB4Show6output(self, { self: logger, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger });
  return logger.val;
}
function _M0MPB4Iter4nextGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  const _func = self.f;
  const result = _func();
  const _bind = self.size_hint;
  if (result === undefined) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GRP411moonbitlang5async8internal9coroutine9CoroutineE;
  } else {
    if (_bind === undefined) {
    } else {
      const _Some = _bind;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GRP411moonbitlang5async8internal9coroutine9CoroutineE;
    }
  }
  return result;
}
function _M0MPB4Iter4nextGcE(self) {
  const _func = self.f;
  const result = _func();
  const _bind = self.size_hint;
  if (result === -1) {
    self.size_hint = _M0MPB4Iter4nextN6constrS8639GcE;
  } else {
    if (_bind === undefined) {
    } else {
      const _Some = _bind;
      const _n = _Some;
      self.size_hint = _n > 0 ? _n - 1 | 0 : _M0MPB4Iter4nextN6constrS8638GcE;
    }
  }
  return result;
}
function _M0MPC13int3Int18to__string_2einner(self, radix) {
  return _M0FPB19int__to__string__js(self, radix);
}
function _M0MPB4Iter3newGRP411moonbitlang5async8internal9coroutine9CoroutineE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GRP411moonbitlang5async8internal9coroutine9CoroutineE;
  }
  return new _M0TPB4IterGRP411moonbitlang5async8internal9coroutine9CoroutineE(f, size_hint$2);
}
function _M0MPB4Iter3newGcE(f, size_hint) {
  let size_hint$2;
  if (size_hint === undefined) {
    size_hint$2 = undefined;
  } else {
    const _Some = size_hint;
    const _n = _Some;
    size_hint$2 = _n > 0 ? _n : _M0MPB4Iter3newN6constrS8646GcE;
  }
  return new _M0TPB4IterGcE(f, size_hint$2);
}
function _M0MPC16string10StringView12view_2einner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.end - self.start | 0;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= (self.end - self.start | 0)) ? new _M0TPC16string10StringView(self.str, self.start + start_offset | 0, self.start + end_offset$2 | 0) : _M0FPC15abort5abortGRPC16string10StringViewE("Invalid index for View");
}
function _M0MPC16string10StringView9to__owned(self) {
  return self.str.substring(self.start, self.end);
}
function _M0MPC16string10StringView4iter(self) {
  const start = self.start;
  const end = self.end;
  const index = new _M0TPB8MutLocalGiE(start);
  return _M0MPB4Iter3newGcE(() => {
    if (index.val < end) {
      const c1 = self.str.charCodeAt(index.val);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index.val + 1 | 0) < self.end) {
        const c2 = self.str.charCodeAt(index.val + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          index.val = index.val + 2 | 0;
          return _M0FPB32code__point__of__surrogate__pair(c1, c2);
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  }, undefined);
}
function _M0IPC16string10StringViewPB2Eq5equal(self, other) {
  const len = self.end - self.start | 0;
  if (len === (other.end - other.start | 0)) {
    if (self.str === other.str && self.start === other.start) {
      return true;
    }
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        const _p = self.str.charCodeAt(self.start + i | 0);
        const _p$2 = other.str.charCodeAt(other.start + i | 0);
        if (_p === _p$2) {
        } else {
          return false;
        }
        _tmp = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return true;
  } else {
    return false;
  }
}
function _M0MPC16string6String12view_2einner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= self.length) ? new _M0TPC16string10StringView(self, start_offset, end_offset$2) : _M0FPC15abort5abortGRPC16string10StringViewE("Invalid index for View");
}
function _M0MPC16string6String4view(self, start_offset$46$opt, end_offset) {
  let start_offset;
  if (start_offset$46$opt === undefined) {
    start_offset = 0;
  } else {
    const _Some = start_offset$46$opt;
    start_offset = _Some;
  }
  return _M0MPC16string6String12view_2einner(self, start_offset, end_offset);
}
function _M0MPC16string6String24char__length__eq_2einner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp = start_offset;
  let _tmp$2 = 0;
  while (true) {
    const index = _tmp;
    const count = _tmp$2;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index + 1 | 0) < end_offset$2) {
        const c2 = self.charCodeAt(index + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          _tmp = index + 2 | 0;
          _tmp$2 = count + 1 | 0;
          continue;
        } else {
          _M0FPC15abort5abortGuE("invalid surrogate pair");
        }
      }
      _tmp = index + 1 | 0;
      _tmp$2 = count + 1 | 0;
      continue;
    } else {
      return count === len && index === end_offset$2;
    }
  }
}
function _M0MPC16string6String24char__length__ge_2einner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp = start_offset;
  let _tmp$2 = 0;
  while (true) {
    const index = _tmp;
    const count = _tmp$2;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index + 1 | 0) < end_offset$2) {
        const c2 = self.charCodeAt(index + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          _tmp = index + 2 | 0;
          _tmp$2 = count + 1 | 0;
          continue;
        } else {
          _M0FPC15abort5abortGuE("invalid surrogate pair");
        }
      }
      _tmp = index + 1 | 0;
      _tmp$2 = count + 1 | 0;
      continue;
    } else {
      return count >= len;
    }
  }
}
function _M0MPC16string6String31offset__of__nth__char__backward(self, n, start_offset, end_offset) {
  let _tmp = end_offset;
  let _tmp$2 = 0;
  while (true) {
    const utf16_offset = _tmp;
    const char_count = _tmp$2;
    if ((utf16_offset - 1 | 0) >= start_offset && char_count < n) {
      const c = self.charCodeAt(utf16_offset - 1 | 0);
      if (_M0MPC16uint166UInt1623is__trailing__surrogate(c)) {
        _tmp = utf16_offset - 2 | 0;
        _tmp$2 = char_count + 1 | 0;
        continue;
      } else {
        _tmp = utf16_offset - 1 | 0;
        _tmp$2 = char_count + 1 | 0;
        continue;
      }
    } else {
      return char_count < n || utf16_offset < start_offset ? undefined : utf16_offset;
    }
  }
}
function _M0MPC16string6String30offset__of__nth__char__forward(self, n, start_offset, end_offset) {
  if (start_offset >= 0 && start_offset <= end_offset) {
    let _tmp = start_offset;
    let _tmp$2 = 0;
    while (true) {
      const utf16_offset = _tmp;
      const char_count = _tmp$2;
      if (utf16_offset < end_offset && char_count < n) {
        const c = self.charCodeAt(utf16_offset);
        if (_M0MPC16uint166UInt1622is__leading__surrogate(c)) {
          _tmp = utf16_offset + 2 | 0;
          _tmp$2 = char_count + 1 | 0;
          continue;
        } else {
          _tmp = utf16_offset + 1 | 0;
          _tmp$2 = char_count + 1 | 0;
          continue;
        }
      } else {
        return char_count < n || utf16_offset >= end_offset ? undefined : utf16_offset;
      }
    }
  } else {
    return _M0FPC15abort5abortGOiE("Invalid start index");
  }
}
function _M0MPC16string6String29offset__of__nth__char_2einner(self, i, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return i >= 0 ? _M0MPC16string6String30offset__of__nth__char__forward(self, i, start_offset, end_offset$2) : _M0MPC16string6String31offset__of__nth__char__backward(self, -i | 0, start_offset, end_offset$2);
}
function _M0IPB13StringBuilderPB6Logger11write__view(self, str) {
  self.val = `${self.val}${_M0MPC16string10StringView9to__owned(str)}`;
}
function _M0FPB28boyer__moore__horspool__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const skip_table = $make_array_len_and_init(256, needle_len);
      const _bind = needle_len - 1 | 0;
      let _tmp = 0;
      while (true) {
        const i = _tmp;
        if (i < _bind) {
          const _tmp$2 = needle.str.charCodeAt(needle.start + i | 0) & 255;
          $bound_check(skip_table, _tmp$2);
          skip_table[_tmp$2] = (needle_len - 1 | 0) - i | 0;
          _tmp = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$2 = 0;
      while (true) {
        const i = _tmp$2;
        if (i <= (haystack_len - needle_len | 0)) {
          const _bind$2 = needle_len - 1 | 0;
          let _tmp$3 = 0;
          while (true) {
            const j = _tmp$3;
            if (j <= _bind$2) {
              const _p = i + j | 0;
              const _p$2 = haystack.str.charCodeAt(haystack.start + _p | 0);
              const _p$3 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$2 !== _p$3) {
                break;
              }
              _tmp$3 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          const _p = (i + needle_len | 0) - 1 | 0;
          const _tmp$4 = haystack.str.charCodeAt(haystack.start + _p | 0) & 255;
          $bound_check(skip_table, _tmp$4);
          _tmp$2 = i + skip_table[_tmp$4] | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return _M0FPB28boyer__moore__horspool__findN6constrS8648;
  }
}
function _M0FPB18brute__force__find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const _p = 0;
      const needle_first = needle.str.charCodeAt(needle.start + _p | 0);
      const forward_len = haystack_len - needle_len | 0;
      let _tmp = 0;
      while (true) {
        const i = _tmp;
        if (i <= forward_len) {
          const _p$2 = haystack.str.charCodeAt(haystack.start + i | 0);
          if (_p$2 !== needle_first) {
            _tmp = i + 1 | 0;
            continue;
          }
          let _tmp$2 = 1;
          while (true) {
            const j = _tmp$2;
            if (j < needle_len) {
              const _p$3 = i + j | 0;
              const _p$4 = haystack.str.charCodeAt(haystack.start + _p$3 | 0);
              const _p$5 = needle.str.charCodeAt(needle.start + j | 0);
              if (_p$4 !== _p$5) {
                break;
              }
              _tmp$2 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          _tmp = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return _M0FPB18brute__force__findN6constrS8649;
  }
}
function _M0MPC16string10StringView4find(self, str) {
  return (str.end - str.start | 0) <= 4 ? _M0FPB18brute__force__find(self, str) : _M0FPB28boyer__moore__horspool__find(self, str);
}
function _M0MPC16string6String6repeat(self, n) {
  if (n < 0) {
    return _M0FPC15abort5abortGRPC16string10StringViewE("negative repeat count");
  } else {
    if (n === 0) {
      return "";
    } else {
      if (n === 1) {
        return self;
      } else {
        const len = self.length;
        const total = Math.imul(len, n) | 0;
        if (len === 0 || (total / n | 0) === len) {
          const buf = _M0MPB13StringBuilder21StringBuilder_2einner(total);
          const str = self;
          let _tmp = 0;
          while (true) {
            const _ = _tmp;
            if (_ < n) {
              _M0IPB13StringBuilderPB6Logger13write__string(buf, str);
              _tmp = _ + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return buf.val;
        } else {
          return _M0FPC15abort5abortGRPC16string10StringViewE("repeat result too large");
        }
      }
    }
  }
}
function _M0MPC16string10StringView11has__prefix(self, str) {
  const _bind = _M0MPC16string10StringView4find(self, str);
  if (_bind === undefined) {
    return false;
  } else {
    const _Some = _bind;
    const _i = _Some;
    return _i === 0;
  }
}
function _M0MPC16string6String11has__prefix(self, str) {
  return _M0MPC16string10StringView11has__prefix(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC15array5Array4pushGsE(self, value) {
  _M0MPB7JSArray4push(self, value);
}
function _M0MPC16string10StringView8contains(self, str) {
  const _bind = _M0MPC16string10StringView4find(self, str);
  return !(_bind === undefined);
}
function _M0MPC16string6String8contains(self, str) {
  return _M0MPC16string10StringView8contains(new _M0TPC16string10StringView(self, 0, self.length), str);
}
function _M0MPC16string10StringView14contains__char(self, c) {
  const len = self.end - self.start | 0;
  if (len > 0) {
    const c$2 = c;
    if (c$2 <= 65535) {
      let _tmp = 0;
      while (true) {
        const i = _tmp;
        if (i < len) {
          if (self.str.charCodeAt(self.start + i | 0) === c$2) {
            return true;
          }
          _tmp = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      if (len >= 2) {
        const adj = c$2 - 65536 | 0;
        const high = 55296 + (adj >> 10) | 0;
        const low = 56320 + (adj & 1023) | 0;
        let _tmp = 0;
        while (true) {
          const i = _tmp;
          if (i < (len - 1 | 0)) {
            if (self.str.charCodeAt(self.start + i | 0) === high) {
              const _p = i + 1 | 0;
              if (self.str.charCodeAt(self.start + _p | 0) === low) {
                return true;
              }
              _tmp = i + 2 | 0;
              continue;
            }
            _tmp = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        return false;
      }
    }
    return false;
  } else {
    return false;
  }
}
function _M0MPC16string10StringView13contains__any(self, chars) {
  if (_M0MPC16string6String24char__length__eq_2einner(chars.str, 0, chars.start, chars.end)) {
    return false;
  } else {
    if (_M0MPC16string6String24char__length__eq_2einner(chars.str, 1, chars.start, chars.end)) {
      const _c = _M0MPC16string6String16unsafe__char__at(chars.str, _M0MPC16string6String29offset__of__nth__char_2einner(chars.str, 0, chars.start, chars.end));
      return _M0MPC16string10StringView14contains__char(self, _c);
    } else {
      const _it = _M0MPC16string10StringView4iter(self);
      while (true) {
        const _bind = _M0MPB4Iter4nextGcE(_it);
        if (_bind === -1) {
          return false;
        } else {
          const _Some = _bind;
          const _c = _Some;
          if (_M0MPC16string10StringView14contains__char(chars, _c)) {
            return true;
          }
          continue;
        }
      }
    }
  }
}
function _M0MPC16string6String13contains__any(self, chars) {
  return _M0MPC16string10StringView13contains__any(new _M0TPC16string10StringView(self, 0, self.length), chars);
}
function _M0MPC16string10StringView19trim__start_2einner(self, chars) {
  let _tmp = self;
  while (true) {
    const x = _tmp;
    if (_M0MPC16string6String24char__length__eq_2einner(x.str, 0, x.start, x.end)) {
      return x;
    } else {
      const _c = _M0MPC16string6String16unsafe__char__at(x.str, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, 0, x.start, x.end));
      const _tmp$2 = x.str;
      const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(x.str, 1, x.start, x.end);
      let _tmp$3;
      if (_bind === undefined) {
        _tmp$3 = x.end;
      } else {
        const _Some = _bind;
        _tmp$3 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp$2, _tmp$3, x.end);
      if (_M0MPC16string10StringView14contains__char(chars, _c)) {
        _tmp = _x;
        continue;
      } else {
        return x;
      }
    }
  }
}
function _M0MPC16string10StringView17trim__end_2einner(self, chars) {
  let _tmp = self;
  while (true) {
    const x = _tmp;
    if (_M0MPC16string6String24char__length__eq_2einner(x.str, 0, x.start, x.end)) {
      return x;
    } else {
      const _c = _M0MPC16string6String16unsafe__char__at(x.str, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, -1, x.start, x.end));
      const _x = new _M0TPC16string10StringView(x.str, x.start, _M0MPC16string6String29offset__of__nth__char_2einner(x.str, -1, x.start, x.end));
      if (_M0MPC16string10StringView14contains__char(chars, _c)) {
        _tmp = _x;
        continue;
      } else {
        return x;
      }
    }
  }
}
function _M0MPC16string6String17trim__end_2einner(self, chars) {
  return _M0MPC16string10StringView17trim__end_2einner(new _M0TPC16string10StringView(self, 0, self.length), chars);
}
function _M0MPC16string6String9trim__end(self, chars$46$opt) {
  let chars;
  if (chars$46$opt === undefined) {
    chars = new _M0TPC16string10StringView(_M0MPC16string6String9trim__endN7_2abindS5954, 0, _M0MPC16string6String9trim__endN7_2abindS5954.length);
  } else {
    const _Some = chars$46$opt;
    chars = _Some;
  }
  return _M0MPC16string6String17trim__end_2einner(self, chars);
}
function _M0MPC16string10StringView12trim_2einner(self, chars) {
  return _M0MPC16string10StringView17trim__end_2einner(_M0MPC16string10StringView19trim__start_2einner(self, chars), chars);
}
function _M0MPC16string6String12trim_2einner(self, chars) {
  return _M0MPC16string10StringView12trim_2einner(new _M0TPC16string10StringView(self, 0, self.length), chars);
}
function _M0MPC16string6String4trim(self, chars$46$opt) {
  let chars;
  if (chars$46$opt === undefined) {
    chars = new _M0TPC16string10StringView(_M0MPC16string6String4trimN7_2abindS5977, 0, _M0MPC16string6String4trimN7_2abindS5977.length);
  } else {
    const _Some = chars$46$opt;
    chars = _Some;
  }
  return _M0MPC16string6String12trim_2einner(self, chars);
}
function _M0MPC16string10StringView9is__empty(self) {
  return (self.end - self.start | 0) === 0;
}
function _M0MPC16string6String4iter(self) {
  const len = self.length;
  const index = new _M0TPB8MutLocalGiE(0);
  return _M0MPB4Iter3newGcE(() => {
    if (index.val < len) {
      const c1 = self.charCodeAt(index.val);
      if (_M0MPC16uint166UInt1622is__leading__surrogate(c1) && (index.val + 1 | 0) < len) {
        const c2 = self.charCodeAt(index.val + 1 | 0);
        if (_M0MPC16uint166UInt1623is__trailing__surrogate(c2)) {
          const c = _M0FPB32code__point__of__surrogate__pair(c1, c2);
          index.val = index.val + 2 | 0;
          return c;
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  }, undefined);
}
function _M0MPC16string10StringView9get__char(self, idx) {
  if (idx >= 0 && idx < (self.end - self.start | 0)) {
    const c = self.str.charCodeAt(self.start + idx | 0);
    if (_M0MPC16uint166UInt1622is__leading__surrogate(c)) {
      if ((idx + 1 | 0) < (self.end - self.start | 0)) {
        const _p = idx + 1 | 0;
        const next = self.str.charCodeAt(self.start + _p | 0);
        return _M0MPC16uint166UInt1623is__trailing__surrogate(next) ? _M0FPB32code__point__of__surrogate__pair(c, next) : -1;
      } else {
        return -1;
      }
    } else {
      return _M0MPC16uint166UInt1623is__trailing__surrogate(c) ? -1 : c;
    }
  } else {
    return -1;
  }
}
function _M0IPC16string6StringPB12ToStringView16to__string__view(self) {
  return new _M0TPC16string10StringView(self, 0, self.length);
}
function _M0IPC13int3IntPB4Show10to__string(self) {
  return _M0MPC13int3Int18to__string_2einner(self, 10);
}
function _M0MPC16option6Option3mapGRPC16string10StringViewsE(self, f) {
  if (self === undefined) {
    return undefined;
  } else {
    const _Some = self;
    const _t = _Some;
    return f(_t);
  }
}
function _M0MPC13int3Int20next__power__of__two(self) {
  if (self >= 0) {
    if (self <= 1) {
      return 1;
    }
    if (self > 1073741824) {
      return 1073741824;
    }
    return (2147483647 >> (Math.clz32(self - 1 | 0) - 1 | 0)) + 1 | 0;
  } else {
    return $panic();
  }
}
function _M0FPB8new__mapGsRPB4JsonE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind = capacity$2 - 1 | 0;
  const _bind$2 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$3 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$4 = undefined;
  return new _M0TPB3MapGsRPB4JsonE(_bind$3, 0, capacity$2, _bind, _bind$2, _bind$4, -1);
}
function _M0FPB21capacity__for__length(length) {
  let capacity = _M0MPC13int3Int20next__power__of__two(length);
  const _p = capacity;
  if (length > ((Math.imul(_p, 13) | 0) / 16 | 0)) {
    capacity = Math.imul(capacity, 2) | 0;
  }
  return capacity;
}
function _M0MPB3Map20add__entry__to__tailGsRPB4JsonE(self, idx, entry) {
  const _bind = self.tail;
  if (_bind === -1) {
    self.head = entry;
  } else {
    const _tmp = self.entries;
    $bound_check(_tmp, _bind);
    const _p = _tmp[_bind];
    let _tmp$2;
    if (_p === undefined) {
      _tmp$2 = $panic();
    } else {
      const _p$2 = _p;
      _tmp$2 = _p$2;
    }
    _tmp$2.next = entry;
  }
  self.tail = idx;
  const _tmp = self.entries;
  $bound_check(_tmp, idx);
  _tmp[idx] = entry;
  self.size = self.size + 1 | 0;
}
function _M0MPB3Map10set__entryGsRPB4JsonE(self, entry, new_idx) {
  const _tmp = self.entries;
  $bound_check(_tmp, new_idx);
  _tmp[new_idx] = entry;
  const _bind = entry.next;
  if (_bind === undefined) {
    self.tail = new_idx;
    return;
  } else {
    const _Some = _bind;
    const _next = _Some;
    _next.prev = new_idx;
    return;
  }
}
function _M0MPB3Map10push__awayGsRPB4JsonE(self, idx, entry) {
  let _tmp = entry.psl + 1 | 0;
  let _tmp$2 = idx + 1 & self.capacity_mask;
  let _tmp$3 = entry;
  while (true) {
    const psl = _tmp;
    const idx$2 = _tmp$2;
    const entry$2 = _tmp$3;
    const _tmp$4 = self.entries;
    $bound_check(_tmp$4, idx$2);
    const _bind = _tmp$4[idx$2];
    if (_bind === undefined) {
      entry$2.psl = psl;
      _M0MPB3Map10set__entryGsRPB4JsonE(self, entry$2, idx$2);
      return;
    } else {
      const _Some = _bind;
      const _curr_entry = _Some;
      if (psl > _curr_entry.psl) {
        entry$2.psl = psl;
        _M0MPB3Map10set__entryGsRPB4JsonE(self, entry$2, idx$2);
        _tmp = _curr_entry.psl + 1 | 0;
        _tmp$2 = idx$2 + 1 & self.capacity_mask;
        _tmp$3 = _curr_entry;
        continue;
      } else {
        _tmp = psl + 1 | 0;
        _tmp$2 = idx$2 + 1 & self.capacity_mask;
        continue;
      }
    }
  }
}
function _M0MPB3Map15set__with__hashGsRPB4JsonE(self, key, value, hash) {
  let _tmp = 0;
  let _tmp$2 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp;
    const idx = _tmp$2;
    const _tmp$3 = self.entries;
    $bound_check(_tmp$3, idx);
    const _bind = _tmp$3[idx];
    if (_bind === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGsRPB4JsonE(self);
        _tmp = 0;
        _tmp$2 = hash & self.capacity_mask;
        continue;
      }
      const _bind$2 = self.tail;
      const _bind$3 = undefined;
      const entry = new _M0TPB5EntryGsRPB4JsonE(_bind$2, _bind$3, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsRPB4JsonE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGsRPB4JsonE(self);
          _tmp = 0;
          _tmp$2 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsRPB4JsonE(self, idx, _curr_entry);
        const _bind$2 = self.tail;
        const _bind$3 = undefined;
        const entry = new _M0TPB5EntryGsRPB4JsonE(_bind$2, _bind$3, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsRPB4JsonE(self, idx, entry);
        return undefined;
      }
      _tmp = psl + 1 | 0;
      _tmp$2 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map15set__with__hashGssE(self, key, value, hash) {
  let _tmp = 0;
  let _tmp$2 = hash & self.capacity_mask;
  while (true) {
    const psl = _tmp;
    const idx = _tmp$2;
    const _tmp$3 = self.entries;
    $bound_check(_tmp$3, idx);
    const _bind = _tmp$3[idx];
    if (_bind === undefined) {
      if (self.size >= self.grow_at) {
        _M0MPB3Map4growGssE(self);
        _tmp = 0;
        _tmp$2 = hash & self.capacity_mask;
        continue;
      }
      const _bind$2 = self.tail;
      const _bind$3 = undefined;
      const entry = new _M0TPB5EntryGssE(_bind$2, _bind$3, psl, hash, key, value);
      _M0MPB3Map20add__entry__to__tailGsRPB4JsonE(self, idx, entry);
      return undefined;
    } else {
      const _Some = _bind;
      const _curr_entry = _Some;
      if (_curr_entry.hash === hash && _curr_entry.key === key) {
        _curr_entry.value = value;
        return undefined;
      }
      if (psl > _curr_entry.psl) {
        if (self.size >= self.grow_at) {
          _M0MPB3Map4growGssE(self);
          _tmp = 0;
          _tmp$2 = hash & self.capacity_mask;
          continue;
        }
        _M0MPB3Map10push__awayGsRPB4JsonE(self, idx, _curr_entry);
        const _bind$2 = self.tail;
        const _bind$3 = undefined;
        const entry = new _M0TPB5EntryGssE(_bind$2, _bind$3, psl, hash, key, value);
        _M0MPB3Map20add__entry__to__tailGsRPB4JsonE(self, idx, entry);
        return undefined;
      }
      _tmp = psl + 1 | 0;
      _tmp$2 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map4growGsRPB4JsonE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p = self.capacity;
  self.grow_at = (Math.imul(_p, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp = old_head;
  while (true) {
    const x = _tmp;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGsRPB4JsonE(self, _key, _value, _hash);
      _tmp = _next;
      continue;
    }
  }
}
function _M0MPB3Map4growGssE(self) {
  const old_head = self.head;
  const new_capacity = self.capacity << 1;
  self.entries = $make_array_len_and_init(new_capacity, undefined);
  self.capacity = new_capacity;
  self.capacity_mask = new_capacity - 1 | 0;
  const _p = self.capacity;
  self.grow_at = (Math.imul(_p, 13) | 0) / 16 | 0;
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
  let _tmp = old_head;
  while (true) {
    const x = _tmp;
    if (x === undefined) {
      return;
    } else {
      const _Some = x;
      const _x = _Some;
      const _next = _x.next;
      const _key = _x.key;
      const _value = _x.value;
      const _hash = _x.hash;
      _M0MPB3Map15set__with__hashGssE(self, _key, _value, _hash);
      _tmp = _next;
      continue;
    }
  }
}
function _M0MPB3Map3setGsRPB4JsonE(self, key, value) {
  _M0MPB3Map15set__with__hashGsRPB4JsonE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3setGssE(self, key, value) {
  _M0MPB3Map15set__with__hashGssE(self, key, value, _M0IP016_24default__implPB4Hash4hashGsE(key));
}
function _M0MPB3Map3MapGsRPB4JsonE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p ? _capacity : _p;
  }
  const m = _M0FPB8new__mapGsRPB4JsonE(capacity$2);
  const _bind = arr.end - arr.start | 0;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGsRPB4JsonE(m, e._0, e._1);
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3MapGssE(arr, capacity) {
  const length = arr.end - arr.start | 0;
  let capacity$2;
  if (capacity === undefined) {
    capacity$2 = length === 0 ? 8 : _M0FPB21capacity__for__length(length);
  } else {
    const _Some = capacity;
    const _capacity = _Some;
    const _p = _M0FPB21capacity__for__length(length);
    capacity$2 = _capacity > _p ? _capacity : _p;
  }
  const m = _M0FPB8new__mapGsRPB4JsonE(capacity$2);
  const _bind = arr.end - arr.start | 0;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const e = arr.buf[arr.start + _ | 0];
      _M0MPB3Map3setGssE(m, e._0, e._1);
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return m;
}
function _M0MPB3Map3getGsRPB4JsonE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp = 0;
  let _tmp$2 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp;
    const idx = _tmp$2;
    const _tmp$3 = self.entries;
    $bound_check(_tmp$3, idx);
    const _bind = _tmp$3[idx];
    if (_bind === undefined) {
      return undefined;
    } else {
      const _Some = _bind;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp = i + 1 | 0;
      _tmp$2 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPB3Map3getGssE(self, key) {
  const hash = _M0IP016_24default__implPB4Hash4hashGsE(key);
  let _tmp = 0;
  let _tmp$2 = hash & self.capacity_mask;
  while (true) {
    const i = _tmp;
    const idx = _tmp$2;
    const _tmp$3 = self.entries;
    $bound_check(_tmp$3, idx);
    const _bind = _tmp$3[idx];
    if (_bind === undefined) {
      return undefined;
    } else {
      const _Some = _bind;
      const _entry = _Some;
      if (_entry.hash === hash && _entry.key === key) {
        return _entry.value;
      }
      if (i > _entry.psl) {
        return undefined;
      }
      _tmp = i + 1 | 0;
      _tmp$2 = idx + 1 & self.capacity_mask;
      continue;
    }
  }
}
function _M0MPC15array10FixedArray12fill_2einnerGORPC13set5EntryGRP411moonbitlang5async8internal9coroutine9CoroutineEE(self, value, start, end) {
  const array_length = self.length;
  if (array_length > 0) {
    if (start >= 0 && start < array_length) {
      let length;
      if (end === undefined) {
        length = array_length - start | 0;
      } else {
        const _Some = end;
        const _e = _Some;
        length = _e >= start && _e <= array_length ? _e - start | 0 : $panic();
      }
      self.fill(value, start, start + length);
      return;
    } else {
      $panic();
      return;
    }
  } else {
    return;
  }
}
function _M0MPB3Map4iterGssE(self) {
  const curr_entry = new _M0TPB8MutLocalGORPB5EntryGssEE(self.head);
  const len = self.size;
  const remaining = new _M0TPB8MutLocalGiE(len);
  return _M0MPB4Iter3newGRP411moonbitlang5async8internal9coroutine9CoroutineE(() => {
    _L: {
      if (remaining.val > 0) {
        const _bind = curr_entry.val;
        if (_bind === undefined) {
          break _L;
        } else {
          const _Some = _bind;
          const _x = _Some;
          const _key = _x.key;
          const _value = _x.value;
          const _next = _x.next;
          curr_entry.val = _next;
          remaining.val = remaining.val - 1 | 0;
          return { _0: _key, _1: _value };
        }
      } else {
        break _L;
      }
    }
    return undefined;
  }, len);
}
function _M0MPB3Map5iter2GssE(self) {
  return _M0MPB3Map4iterGssE(self);
}
function _M0MPB5Iter24nextGssE(self) {
  return _M0MPB4Iter4nextGRP411moonbitlang5async8internal9coroutine9CoroutineE(self);
}
function _M0MPB6Hasher15combine__string(self, value) {
  const _bind = value.length;
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < _bind) {
      _M0MPB6Hasher13combine__uint(self, value.charCodeAt(i));
      _tmp = i + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0IPC16string6StringPB4Hash13hash__combine(self, hasher) {
  _M0MPB6Hasher15combine__string(hasher, self);
}
function _M0MPC16double6Double7to__int(self) {
  return self !== self ? 0 : self >= 2147483647 ? 2147483647 : self <= -2147483648 ? -2147483648 : self | 0;
}
function _M0IPC16double6DoublePB4Show10to__string(self) {
  return String(self);
}
function _M0MPC14char4Char7to__hex(char) {
  const code = char;
  return code >= 0 && code <= 255 ? _M0MPC14byte4Byte7to__hex(code & 255) : code <= 65535 ? `${_M0MPC14byte4Byte7to__hex(code >> 8 & 255)}${_M0MPC14byte4Byte7to__hex(code & 255)}` : `${_M0MPC14byte4Byte7to__hex(code >> 16 & 255)}${_M0MPC14byte4Byte7to__hex(code >> 8 & 255)}${_M0MPC14byte4Byte7to__hex(code & 255)}`;
}
function _M0MPC14char4Char11is__control(self) {
  return self >= 0 && self <= 31 ? true : self >= 127 && self <= 159;
}
function _M0MPC14char4Char13is__printable(self) {
  if (_M0MPC14char4Char11is__control(self)) {
    return false;
  }
  const self$2 = self;
  _L: {
    _L$2: {
      if (self$2 >= 57344 && self$2 <= 63743) {
        break _L$2;
      } else {
        if (self$2 >= 983040 && self$2 <= 1048573) {
          break _L$2;
        } else {
          if (self$2 >= 1048576 && self$2 <= 1114109) {
            break _L$2;
          }
        }
      }
      break _L;
    }
    return false;
  }
  _L$2: {
    _L$3: {
      if (self$2 === 173) {
        break _L$3;
      } else {
        if (self$2 >= 1536 && self$2 <= 1541) {
          break _L$3;
        } else {
          if (self$2 === 1564) {
            break _L$3;
          } else {
            if (self$2 === 1757) {
              break _L$3;
            } else {
              if (self$2 === 1807) {
                break _L$3;
              } else {
                if (self$2 >= 2192 && self$2 <= 2193) {
                  break _L$3;
                } else {
                  if (self$2 === 2274) {
                    break _L$3;
                  } else {
                    if (self$2 === 6158) {
                      break _L$3;
                    } else {
                      if (self$2 >= 8203 && self$2 <= 8207) {
                        break _L$3;
                      } else {
                        if (self$2 >= 8234 && self$2 <= 8238) {
                          break _L$3;
                        } else {
                          if (self$2 >= 8288 && self$2 <= 8292) {
                            break _L$3;
                          } else {
                            if (self$2 >= 8294 && self$2 <= 8303) {
                              break _L$3;
                            } else {
                              if (self$2 === 65279) {
                                break _L$3;
                              } else {
                                if (self$2 >= 65529 && self$2 <= 65531) {
                                  break _L$3;
                                } else {
                                  if (self$2 === 69821) {
                                    break _L$3;
                                  } else {
                                    if (self$2 === 69837) {
                                      break _L$3;
                                    } else {
                                      if (self$2 >= 78896 && self$2 <= 78911) {
                                        break _L$3;
                                      } else {
                                        if (self$2 >= 113824 && self$2 <= 113827) {
                                          break _L$3;
                                        } else {
                                          if (self$2 >= 119155 && self$2 <= 119162) {
                                            break _L$3;
                                          } else {
                                            if (self$2 === 917505) {
                                              break _L$3;
                                            } else {
                                              if (self$2 >= 917536 && self$2 <= 917631) {
                                                break _L$3;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L$2;
    }
    return false;
  }
  if (55296 <= self$2 && self$2 <= 57343) {
    return false;
  }
  if (self$2 === 8232 || self$2 === 8233) {
    return false;
  }
  _L$3: {
    _L$4: {
      if (self$2 >= 64976 && self$2 <= 65007) {
        break _L$4;
      } else {
        if (self$2 >= 65534 && self$2 <= 65535) {
          break _L$4;
        } else {
          if (self$2 >= 131070 && self$2 <= 131071) {
            break _L$4;
          } else {
            if (self$2 >= 196606 && self$2 <= 196607) {
              break _L$4;
            } else {
              if (self$2 >= 262142 && self$2 <= 262143) {
                break _L$4;
              } else {
                if (self$2 >= 327678 && self$2 <= 327679) {
                  break _L$4;
                } else {
                  if (self$2 >= 393214 && self$2 <= 393215) {
                    break _L$4;
                  } else {
                    if (self$2 >= 458750 && self$2 <= 458751) {
                      break _L$4;
                    } else {
                      if (self$2 >= 524286 && self$2 <= 524287) {
                        break _L$4;
                      } else {
                        if (self$2 >= 589822 && self$2 <= 589823) {
                          break _L$4;
                        } else {
                          if (self$2 >= 655358 && self$2 <= 655359) {
                            break _L$4;
                          } else {
                            if (self$2 >= 720894 && self$2 <= 720895) {
                              break _L$4;
                            } else {
                              if (self$2 >= 786430 && self$2 <= 786431) {
                                break _L$4;
                              } else {
                                if (self$2 >= 851966 && self$2 <= 851967) {
                                  break _L$4;
                                } else {
                                  if (self$2 >= 917502 && self$2 <= 917503) {
                                    break _L$4;
                                  } else {
                                    if (self$2 >= 983038 && self$2 <= 983039) {
                                      break _L$4;
                                    } else {
                                      if (self$2 >= 1048574 && self$2 <= 1048575) {
                                        break _L$4;
                                      } else {
                                        if (self$2 >= 1114110 && self$2 <= 1114111) {
                                          break _L$4;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L$3;
    }
    return false;
  }
  return true;
}
function _M0MPC14char4Char18escape__to_2einner(self, logger, quote) {
  if (quote) {
    logger.method_table.method_3(logger.self, 39);
  }
  _L: {
    _L$2: {
      if (self === 39) {
        break _L$2;
      } else {
        if (self === 92) {
          break _L$2;
        } else {
          if (self === 10) {
            logger.method_table.method_0(logger.self, "\\n");
          } else {
            if (self === 13) {
              logger.method_table.method_0(logger.self, "\\r");
            } else {
              if (self === 8) {
                logger.method_table.method_0(logger.self, "\\b");
              } else {
                if (self === 9) {
                  logger.method_table.method_0(logger.self, "\\t");
                } else {
                  if (self >= 32 && self <= 126) {
                    logger.method_table.method_3(logger.self, self);
                  } else {
                    if (!_M0MPC14char4Char13is__printable(self)) {
                      logger.method_table.method_0(logger.self, "\\u{");
                      logger.method_table.method_0(logger.self, _M0MPC14char4Char7to__hex(self));
                      logger.method_table.method_3(logger.self, 125);
                    } else {
                      logger.method_table.method_3(logger.self, self);
                    }
                  }
                }
              }
            }
          }
        }
      }
      break _L;
    }
    logger.method_table.method_3(logger.self, 92);
    logger.method_table.method_3(logger.self, self);
  }
  if (quote) {
    logger.method_table.method_3(logger.self, 39);
    return;
  } else {
    return;
  }
}
function _M0MPC14char4Char14escape_2einner(self, quote) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  _M0MPC14char4Char18escape__to_2einner(self, { self: buf, method_table: _M0FP092moonbitlang_2fcore_2fbuiltin_2fStringBuilder_24as_24_40moonbitlang_2fcore_2fbuiltin_2eLogger }, quote);
  return buf.val;
}
function _M0MPC15array9ArrayView4joinGsE(self, separator) {
  if ((self.end - self.start | 0) === 0) {
    return "";
  } else {
    const _hd = self.buf[self.start];
    const _x_buf = self.buf;
    const _x_start = 1 + self.start | 0;
    const _x_end = self.end;
    const hd = _M0IPC16string6StringPB12ToStringView16to__string__view(_hd);
    const _bind = _x_end - _x_start | 0;
    let size_hint;
    let _tmp = 0;
    let _tmp$2 = hd.end - hd.start | 0;
    while (true) {
      const _ = _tmp;
      const size_hint$2 = _tmp$2;
      if (_ < _bind) {
        const s = _x_buf[_x_start + _ | 0];
        _tmp = _ + 1 | 0;
        const _p = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
        _tmp$2 = (size_hint$2 + (_p.end - _p.start | 0) | 0) + (separator.end - separator.start | 0) | 0;
        continue;
      } else {
        size_hint = size_hint$2;
        break;
      }
    }
    const size_hint$2 = size_hint << 1;
    const buf = _M0MPB13StringBuilder21StringBuilder_2einner(size_hint$2);
    _M0IPB13StringBuilderPB6Logger11write__view(buf, hd);
    if (_M0MPC16string6String24char__length__eq_2einner(separator.str, 0, separator.start, separator.end)) {
      const _bind$2 = _x_end - _x_start | 0;
      let _tmp$3 = 0;
      while (true) {
        const _ = _tmp$3;
        if (_ < _bind$2) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$3 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      const _bind$2 = _x_end - _x_start | 0;
      let _tmp$3 = 0;
      while (true) {
        const _ = _tmp$3;
        if (_ < _bind$2) {
          const s = _x_buf[_x_start + _ | 0];
          const s$2 = _M0IPC16string6StringPB12ToStringView16to__string__view(s);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, separator);
          _M0IPB13StringBuilderPB6Logger11write__view(buf, s$2);
          _tmp$3 = _ + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    return buf.val;
  }
}
function _M0MPC15array5Array11unsafe__popGRPC14json10WriteFrameE(self) {
  return _M0MPB7JSArray3pop(self);
}
function _M0MPC15array5Array3popGRPC14json10WriteFrameE(self) {
  if (self.length === 0) {
    return undefined;
  } else {
    const v = _M0MPC15array5Array11unsafe__popGRPC14json10WriteFrameE(self);
    return v;
  }
}
function _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function _M0MPC15array5Array4joinGsE(self, separator) {
  return _M0MPC15array9ArrayView4joinGsE(new _M0TPB9ArrayViewGsE(self, 0, self.length), separator);
}
function _M0IPC15error5ErrorPB4Show10to__string(self) {
  return _M0FP15Error10to__string(self);
}
function _M0FPC13set8new__setGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity) {
  const capacity$2 = _M0MPC13int3Int20next__power__of__two(capacity);
  const _bind = capacity$2 - 1 | 0;
  const _bind$2 = (Math.imul(capacity$2, 13) | 0) / 16 | 0;
  const _bind$3 = $make_array_len_and_init(capacity$2, undefined);
  const _bind$4 = undefined;
  return new _M0TPC13set3SetGRP411moonbitlang5async8internal9coroutine9CoroutineE(_bind$3, 0, capacity$2, _bind, _bind$2, _bind$4, -1);
}
function _M0MPC13set3Set5clearGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  _M0MPC15array10FixedArray12fill_2einnerGORPC13set5EntryGRP411moonbitlang5async8internal9coroutine9CoroutineEE(self.entries, undefined, 0, undefined);
  self.size = 0;
  self.head = undefined;
  self.tail = -1;
}
function _M0MPC13set3Set4iterGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  const curr_entry = new _M0TPB8MutLocalGORPC13set5EntryGRP411moonbitlang5async8internal9coroutine9CoroutineEE(self.head);
  const len = self.size;
  const remaining = new _M0TPB8MutLocalGiE(len);
  return _M0MPB4Iter3newGRP411moonbitlang5async8internal9coroutine9CoroutineE(() => {
    _L: {
      if (remaining.val > 0) {
        const _bind = curr_entry.val;
        if (_bind === undefined) {
          break _L;
        } else {
          const _Some = _bind;
          const _x = _Some;
          const _key = _x.key;
          const _next = _x.next;
          curr_entry.val = _next;
          remaining.val = remaining.val - 1 | 0;
          return _key;
        }
      } else {
        break _L;
      }
    }
    return undefined;
  }, len);
}
function _M0MPC13set3Set11new_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity) {
  return _M0FPC13set8new__setGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity);
}
function _M0MPC13set3Set3newGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity$46$opt) {
  let capacity;
  if (capacity$46$opt === undefined) {
    capacity = 8;
  } else {
    const _Some = capacity$46$opt;
    capacity = _Some;
  }
  return _M0MPC13set3Set11new_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity);
}
function _M0FPC28internal7strconv9base__errGUiRPC16string10StringViewbEE() {
  return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv14base__err__str));
}
function _M0FPC28internal7strconv25check__and__consume__base(view, base) {
  if (base === 0) {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp = view.str;
                    const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$2;
                    if (_bind === undefined) {
                      _tmp$2 = view.end;
                    } else {
                      const _Some = _bind;
                      _tmp$2 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp, _tmp$2, view.end);
                    rest$3 = _x$3;
                    break _L$4;
                  }
                  case 88: {
                    const _tmp$3 = view.str;
                    const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$4;
                    if (_bind$2 === undefined) {
                      _tmp$4 = view.end;
                    } else {
                      const _Some = _bind$2;
                      _tmp$4 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, view.end);
                    rest$3 = _x$4;
                    break _L$4;
                  }
                  case 111: {
                    const _tmp$5 = view.str;
                    const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$6;
                    if (_bind$3 === undefined) {
                      _tmp$6 = view.end;
                    } else {
                      const _Some = _bind$3;
                      _tmp$6 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$5, _tmp$6, view.end);
                    rest$2 = _x$5;
                    break _L$3;
                  }
                  case 79: {
                    const _tmp$7 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$8;
                    if (_bind$4 === undefined) {
                      _tmp$8 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$8 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$7, _tmp$8, view.end);
                    rest$2 = _x$6;
                    break _L$3;
                  }
                  case 98: {
                    const _tmp$9 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$10;
                    if (_bind$5 === undefined) {
                      _tmp$10 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$10 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$9, _tmp$10, view.end);
                    rest = _x$7;
                    break _L$2;
                  }
                  case 66: {
                    const _tmp$11 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$12;
                    if (_bind$6 === undefined) {
                      _tmp$12 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$12 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$11, _tmp$12, view.end);
                    rest = _x$8;
                    break _L$2;
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 10, _1: view, _2: false });
  } else {
    _L: {
      let rest;
      _L$2: {
        let rest$2;
        _L$3: {
          let rest$3;
          _L$4: {
            if (_M0MPC16string6String24char__length__ge_2einner(view.str, 2, view.start, view.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 0, view.start, view.end));
              if (_x === 48) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(view.str, _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 1, view.start, view.end));
                switch (_x$2) {
                  case 120: {
                    const _tmp = view.str;
                    const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$2;
                    if (_bind === undefined) {
                      _tmp$2 = view.end;
                    } else {
                      const _Some = _bind;
                      _tmp$2 = _Some;
                    }
                    const _x$3 = new _M0TPC16string10StringView(_tmp, _tmp$2, view.end);
                    if (base === 16) {
                      rest$3 = _x$3;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 88: {
                    const _tmp$3 = view.str;
                    const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$4;
                    if (_bind$2 === undefined) {
                      _tmp$4 = view.end;
                    } else {
                      const _Some = _bind$2;
                      _tmp$4 = _Some;
                    }
                    const _x$4 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, view.end);
                    if (base === 16) {
                      rest$3 = _x$4;
                      break _L$4;
                    } else {
                      break _L;
                    }
                  }
                  case 111: {
                    const _tmp$5 = view.str;
                    const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$6;
                    if (_bind$3 === undefined) {
                      _tmp$6 = view.end;
                    } else {
                      const _Some = _bind$3;
                      _tmp$6 = _Some;
                    }
                    const _x$5 = new _M0TPC16string10StringView(_tmp$5, _tmp$6, view.end);
                    if (base === 8) {
                      rest$2 = _x$5;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 79: {
                    const _tmp$7 = view.str;
                    const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$8;
                    if (_bind$4 === undefined) {
                      _tmp$8 = view.end;
                    } else {
                      const _Some = _bind$4;
                      _tmp$8 = _Some;
                    }
                    const _x$6 = new _M0TPC16string10StringView(_tmp$7, _tmp$8, view.end);
                    if (base === 8) {
                      rest$2 = _x$6;
                      break _L$3;
                    } else {
                      break _L;
                    }
                  }
                  case 98: {
                    const _tmp$9 = view.str;
                    const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$10;
                    if (_bind$5 === undefined) {
                      _tmp$10 = view.end;
                    } else {
                      const _Some = _bind$5;
                      _tmp$10 = _Some;
                    }
                    const _x$7 = new _M0TPC16string10StringView(_tmp$9, _tmp$10, view.end);
                    if (base === 2) {
                      rest = _x$7;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  case 66: {
                    const _tmp$11 = view.str;
                    const _bind$6 = _M0MPC16string6String29offset__of__nth__char_2einner(view.str, 2, view.start, view.end);
                    let _tmp$12;
                    if (_bind$6 === undefined) {
                      _tmp$12 = view.end;
                    } else {
                      const _Some = _bind$6;
                      _tmp$12 = _Some;
                    }
                    const _x$8 = new _M0TPC16string10StringView(_tmp$11, _tmp$12, view.end);
                    if (base === 2) {
                      rest = _x$8;
                      break _L$2;
                    } else {
                      break _L;
                    }
                  }
                  default: {
                    break _L;
                  }
                }
              } else {
                break _L;
              }
            } else {
              break _L;
            }
          }
          return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 16, _1: rest$3, _2: true });
        }
        return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 8, _1: rest$2, _2: true });
      }
      return new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: 2, _1: rest, _2: true });
    }
    return base >= 2 && base <= 36 ? new _M0DTPC16result6ResultGUiRPC16string10StringViewbERPC15error5ErrorE2Ok({ _0: base, _1: view, _2: false }) : _M0FPC28internal7strconv9base__errGUiRPC16string10StringViewbEE();
  }
}
function _M0FPC28internal7strconv10range__errGuE() {
  return new _M0DTPC16result6ResultGuRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv15range__err__str));
}
function _M0FPC28internal7strconv11syntax__errGiE() {
  return new _M0DTPC16result6ResultGiRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGuE() {
  return new _M0DTPC16result6ResultGuRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGlE() {
  return new _M0DTPC16result6ResultGlRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGdE() {
  return new _M0DTPC16result6ResultGdRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0FPC28internal7strconv11syntax__errGORPC28internal7strconv6NumberE() {
  return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPB7FailureE3Err(new _M0DTPC15error5Error48moonbitlang_2fcore_2fbuiltin_2eFailure_2eFailure(_M0FPC28internal7strconv16syntax__err__str));
}
function _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(self, init, f) {
  let ret = init;
  let len = 0;
  let str = self;
  while (true) {
    const _bind = str;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind.str, 1, _bind.start, _bind.end)) {
      const _ch = _M0MPC16string6String16unsafe__char__at(_bind.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 0, _bind.start, _bind.end));
      const _tmp = _bind.str;
      const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 1, _bind.start, _bind.end);
      let _tmp$2;
      if (_bind$2 === undefined) {
        _tmp$2 = _bind.end;
      } else {
        const _Some = _bind$2;
        _tmp$2 = _Some;
      }
      const _x = new _M0TPC16string10StringView(_tmp, _tmp$2, _bind.end);
      if (_ch >= 48 && _ch <= 57) {
        len = len + 1 | 0;
        ret = f(_ch - 48 | 0, ret);
      } else {
        if (_ch !== 95) {
          break;
        }
      }
      str = _x;
      continue;
    } else {
      break;
    }
  }
  return { _0: str, _1: ret, _2: len };
}
function _M0FPC28internal7strconv13parse__digits(s, x) {
  return _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(s, x, (digit, acc) => BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(digit >>> 0))));
}
function _M0FPC28internal7strconv20try__parse__19digits(s, x) {
  let x$2 = x;
  let len = 0;
  let _tmp = s;
  while (true) {
    const s$2 = _tmp;
    let s$3;
    _L: {
      if (_M0MPC16string6String24char__length__ge_2einner(s$2.str, 1, s$2.start, s$2.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 0, s$2.start, s$2.end));
        if (_x >= 48 && _x <= 57) {
          const _tmp$2 = s$2.str;
          const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
          let _tmp$3;
          if (_bind === undefined) {
            _tmp$3 = s$2.end;
          } else {
            const _Some = _bind;
            _tmp$3 = _Some;
          }
          const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, s$2.end);
          if (BigInt.asUintN(64, x$2) < BigInt.asUintN(64, _M0FPC28internal7strconv17min__19digit__int)) {
            len = len + 1 | 0;
            x$2 = BigInt.asUintN(64, BigInt.asUintN(64, x$2 * 10n) + BigInt.asUintN(64, BigInt((_x - 48 | 0) >>> 0)));
            _tmp = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        } else {
          if (_x === 95) {
            const _tmp$2 = s$2.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(s$2.str, 1, s$2.start, s$2.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = s$2.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, s$2.end);
            _tmp = _x$2;
            continue;
          } else {
            s$3 = s$2;
            break _L;
          }
        }
      } else {
        s$3 = s$2;
        break _L;
      }
    }
    return { _0: s$3, _1: x$2, _2: len };
  }
}
function _M0FPC28internal7strconv17parse__scientific(s) {
  let s$2 = s;
  let neg_exp = false;
  let rest;
  let ch;
  _L: {
    _L$2: {
      const _bind = s$2;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind.str, 1, _bind.start, _bind.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 0, _bind.start, _bind.end));
        switch (_x) {
          case 43: {
            const _tmp = _bind.str;
            const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 1, _bind.start, _bind.end);
            let _tmp$2;
            if (_bind$2 === undefined) {
              _tmp$2 = _bind.end;
            } else {
              const _Some = _bind$2;
              _tmp$2 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, _bind.end);
            rest = _x$2;
            ch = _x;
            break _L$2;
          }
          case 45: {
            const _tmp$3 = _bind.str;
            const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 1, _bind.start, _bind.end);
            let _tmp$4;
            if (_bind$3 === undefined) {
              _tmp$4 = _bind.end;
            } else {
              const _Some = _bind$3;
              _tmp$4 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, _bind.end);
            rest = _x$3;
            ch = _x;
            break _L$2;
          }
        }
      }
      break _L;
    }
    neg_exp = ch === 45;
    s$2 = rest;
  }
  _L$2: {
    const _bind = s$2;
    if (_M0MPC16string6String24char__length__ge_2einner(_bind.str, 1, _bind.start, _bind.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_bind.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 0, _bind.start, _bind.end));
      if (_x >= 48 && _x <= 57) {
        const _bind$2 = _M0EPC16string10StringViewPC28internal7strconv12fold__digitsGmE(s$2, _M0FPC28internal7strconv17parse__scientificN8exp__numS241, (digit, exp_num) => BigInt.asIntN(64, exp_num) < BigInt.asIntN(64, 65536n) ? BigInt.asUintN(64, BigInt.asUintN(64, 10n * exp_num) + BigInt.asUintN(64, BigInt(digit))) : exp_num);
        const _s = _bind$2._0;
        const _exp_num = _bind$2._1;
        return neg_exp ? { _0: _s, _1: BigInt.asUintN(64, -_exp_num) } : { _0: _s, _1: _exp_num };
      } else {
        break _L$2;
      }
    } else {
      break _L$2;
    }
  }
  return undefined;
}
function _M0FPC28internal7strconv13parse__number(s) {
  let s$2;
  let negative;
  _L: {
    let rest;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
        switch (_x) {
          case 45: {
            const _tmp = s.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$2;
            if (_bind === undefined) {
              _tmp$2 = s.end;
            } else {
              const _Some = _bind;
              _tmp$2 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, s.end);
            s$2 = _x$2;
            negative = true;
            break _L;
          }
          case 43: {
            const _tmp$3 = s.str;
            const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 1, s.start, s.end);
            let _tmp$4;
            if (_bind$2 === undefined) {
              _tmp$4 = s.end;
            } else {
              const _Some = _bind$2;
              _tmp$4 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, s.end);
            rest = _x$3;
            break _L$2;
          }
          default: {
            rest = s;
            break _L$2;
          }
        }
      } else {
        rest = s;
        break _L$2;
      }
    }
    s$2 = rest;
    negative = false;
    break _L;
  }
  if (_M0MPC16string10StringView9is__empty(s$2)) {
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
  }
  const _bind = _M0FPC28internal7strconv13parse__digits(s$2, 0n);
  const _s = _bind._0;
  const _mantissa = _bind._1;
  const _consumed = _bind._2;
  let mantissa = _mantissa;
  let s$3 = _s;
  let n_digits = _consumed;
  let n_after_dot = 0;
  let exponent = 0n;
  const _bind$2 = s$3;
  if (_M0MPC16string6String24char__length__ge_2einner(_bind$2.str, 1, _bind$2.start, _bind$2.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(_bind$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$2.str, 0, _bind$2.start, _bind$2.end));
    if (_x === 46) {
      const _tmp = _bind$2.str;
      const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$2.str, 1, _bind$2.start, _bind$2.end);
      let _tmp$2;
      if (_bind$3 === undefined) {
        _tmp$2 = _bind$2.end;
      } else {
        const _Some = _bind$3;
        _tmp$2 = _Some;
      }
      const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, _bind$2.end);
      s$3 = _x$2;
      const _bind$4 = _M0FPC28internal7strconv13parse__digits(s$3, mantissa);
      const _new_s = _bind$4._0;
      const _new_mantissa = _bind$4._1;
      const _consumed_digit = _bind$4._2;
      s$3 = _new_s;
      mantissa = _new_mantissa;
      n_after_dot = _consumed_digit;
      exponent = BigInt.asUintN(64, -BigInt.asUintN(64, BigInt(n_after_dot)));
    }
  }
  n_digits = n_digits + n_after_dot | 0;
  if (n_digits === 0) {
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
  }
  let rest;
  _L$2: {
    _L$3: {
      const _bind$3 = s$3;
      if (_M0MPC16string6String24char__length__ge_2einner(_bind$3.str, 1, _bind$3.start, _bind$3.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(_bind$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind$3.str, 0, _bind$3.start, _bind$3.end));
        switch (_x) {
          case 101: {
            const _tmp = _bind$3.str;
            const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$3.str, 1, _bind$3.start, _bind$3.end);
            let _tmp$2;
            if (_bind$4 === undefined) {
              _tmp$2 = _bind$3.end;
            } else {
              const _Some = _bind$4;
              _tmp$2 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, _bind$3.end);
            rest = _x$2;
            break _L$3;
          }
          case 69: {
            const _tmp$3 = _bind$3.str;
            const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind$3.str, 1, _bind$3.start, _bind$3.end);
            let _tmp$4;
            if (_bind$5 === undefined) {
              _tmp$4 = _bind$3.end;
            } else {
              const _Some = _bind$5;
              _tmp$4 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, _bind$3.end);
            rest = _x$3;
            break _L$3;
          }
        }
      }
      break _L$2;
    }
    const _bind$3 = _M0FPC28internal7strconv17parse__scientific(rest);
    let _bind$4;
    if (_bind$3 === undefined) {
      return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
    } else {
      const _Some = _bind$3;
      _bind$4 = _Some;
    }
    const _new_s = _bind$4._0;
    const _exp_number = _bind$4._1;
    s$3 = _new_s;
    exponent = BigInt.asUintN(64, exponent + _exp_number);
  }
  const _bind$3 = s$3;
  if (_M0MPC16string6String24char__length__eq_2einner(_bind$3.str, 0, _bind$3.start, _bind$3.end)) {
    if (n_digits <= 19) {
      return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(new _M0TPC28internal7strconv6Number(exponent, mantissa, negative, false));
    }
    n_digits = n_digits - 19 | 0;
    let many_digits = false;
    let _tmp = s;
    while (true) {
      const s$4 = _tmp;
      _L$3: {
        let rest$2;
        let ch;
        _L$4: {
          if (_M0MPC16string6String24char__length__ge_2einner(s$4.str, 1, s$4.start, s$4.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(s$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 0, s$4.start, s$4.end));
            switch (_x) {
              case 48: {
                const _tmp$2 = s$4.str;
                const _bind$4 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$3;
                if (_bind$4 === undefined) {
                  _tmp$3 = s$4.end;
                } else {
                  const _Some = _bind$4;
                  _tmp$3 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, s$4.end);
                rest$2 = _x$2;
                ch = _x;
                break _L$4;
              }
              case 46: {
                const _tmp$4 = s$4.str;
                const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(s$4.str, 1, s$4.start, s$4.end);
                let _tmp$5;
                if (_bind$5 === undefined) {
                  _tmp$5 = s$4.end;
                } else {
                  const _Some = _bind$5;
                  _tmp$5 = _Some;
                }
                const _x$3 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, s$4.end);
                rest$2 = _x$3;
                ch = _x;
                break _L$4;
              }
              default: {
                break _L$3;
              }
            }
          } else {
            break _L$3;
          }
        }
        n_digits = n_digits - ((ch - 46 | 0) / 2 | 0) | 0;
        _tmp = rest$2;
        continue;
      }
      break;
    }
    let mantissa$2 = mantissa;
    if (n_digits > 0) {
      many_digits = true;
      mantissa$2 = 0n;
      const _bind$4 = _M0FPC28internal7strconv20try__parse__19digits(s, mantissa$2);
      const _s$2 = _bind$4._0;
      const _new_mantissa = _bind$4._1;
      const _consumed_digit = _bind$4._2;
      mantissa$2 = _new_mantissa;
      let _tmp$2;
      if (BigInt.asUintN(64, mantissa$2) >= BigInt.asUintN(64, _M0FPC28internal7strconv17min__19digit__int)) {
        _tmp$2 = _consumed_digit;
      } else {
        if (_M0MPC16string6String24char__length__ge_2einner(_s$2.str, 1, _s$2.start, _s$2.end)) {
          const _tmp$3 = _s$2.str;
          const _bind$5 = _M0MPC16string6String29offset__of__nth__char_2einner(_s$2.str, 1, _s$2.start, _s$2.end);
          let _tmp$4;
          if (_bind$5 === undefined) {
            _tmp$4 = _s$2.end;
          } else {
            const _Some = _bind$5;
            _tmp$4 = _Some;
          }
          const _x = new _M0TPC16string10StringView(_tmp$3, _tmp$4, _s$2.end);
          const _bind$6 = _M0FPC28internal7strconv20try__parse__19digits(_x, mantissa$2);
          const _new_mantissa$2 = _bind$6._1;
          const _consumed_digit$2 = _bind$6._2;
          mantissa$2 = _new_mantissa$2;
          _tmp$2 = _consumed_digit$2;
        } else {
          return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(undefined);
        }
      }
      exponent = BigInt.asUintN(64, BigInt(_tmp$2));
      exponent = BigInt.asUintN(64, exponent + _M0FPC28internal7strconv13parse__numberN11exp__numberS222);
    }
    return new _M0DTPC16result6ResultGORPC28internal7strconv6NumberRPC15error5ErrorE2Ok(new _M0TPC28internal7strconv6Number(exponent, mantissa$2, negative, many_digits));
  } else {
    return _M0FPC28internal7strconv11syntax__errGORPC28internal7strconv6NumberE();
  }
}
function _M0FPC28internal7strconv15parse__inf__nan(rest) {
  let pos;
  let rest$2;
  _L: {
    let rest$3;
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(rest.str, 1, rest.start, rest.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 0, rest.start, rest.end));
        switch (_x) {
          case 45: {
            const _tmp = rest.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$2;
            if (_bind === undefined) {
              _tmp$2 = rest.end;
            } else {
              const _Some = _bind;
              _tmp$2 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, rest.end);
            pos = false;
            rest$2 = _x$2;
            break _L;
          }
          case 43: {
            const _tmp$3 = rest.str;
            const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(rest.str, 1, rest.start, rest.end);
            let _tmp$4;
            if (_bind$2 === undefined) {
              _tmp$4 = rest.end;
            } else {
              const _Some = _bind$2;
              _tmp$4 = _Some;
            }
            const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, rest.end);
            rest$3 = _x$3;
            break _L$2;
          }
          default: {
            rest$3 = rest;
            break _L$2;
          }
        }
      } else {
        rest$3 = rest;
        break _L$2;
      }
    }
    pos = true;
    rest$2 = rest$3;
    break _L;
  }
  const _data = rest$2.str;
  const _start = rest$2.start;
  const _end = _start + (rest$2.end - rest$2.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L$2: {
    _L$3: {
      if ((_cursor + 2 | 0) < _end) {
        _L$4: {
          _L$5: {
            const _p = _cursor;
            const next_char = _data.charCodeAt(_p);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$4;
                }
              } else {
                if (next_char > 77) {
                  break _L$5;
                } else {
                  break _L$2;
                }
              }
            } else {
              if (next_char > 104) {
                if (next_char < 110) {
                  if (next_char < 106) {
                    break _L$4;
                  } else {
                    break _L$2;
                  }
                } else {
                  if (next_char > 110) {
                    break _L$2;
                  } else {
                    break _L$5;
                  }
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$6: {
            const _p = _cursor;
            const next_char = _data.charCodeAt(_p);
            _cursor = _cursor + 1 | 0;
            if (next_char < 66) {
              if (next_char < 65) {
                break _L$2;
              } else {
                break _L$6;
              }
            } else {
              if (next_char > 96) {
                if (next_char < 98) {
                  break _L$6;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          _L$7: {
            const _p = _cursor;
            const next_char = _data.charCodeAt(_p);
            _cursor = _cursor + 1 | 0;
            if (next_char < 79) {
              if (next_char < 78) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 109) {
                if (next_char < 111) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if (_cursor < _end) {
            break _L$2;
          } else {
            accept_state = 0;
            match_end = _cursor;
            break _L$2;
          }
        }
        _L$5: {
          const _p = _cursor;
          const next_char = _data.charCodeAt(_p);
          _cursor = _cursor + 1 | 0;
          if (next_char < 79) {
            if (next_char < 78) {
              break _L$2;
            } else {
              break _L$5;
            }
          } else {
            if (next_char > 109) {
              if (next_char < 111) {
                break _L$5;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        _L$6: {
          const _p = _cursor;
          const next_char = _data.charCodeAt(_p);
          _cursor = _cursor + 1 | 0;
          if (next_char < 71) {
            if (next_char < 70) {
              break _L$2;
            } else {
              break _L$6;
            }
          } else {
            if (next_char > 101) {
              if (next_char < 103) {
                break _L$6;
              } else {
                break _L$2;
              }
            } else {
              break _L$2;
            }
          }
        }
        if (_cursor < _end) {
          _L$7: {
            const _p = _cursor;
            const next_char = _data.charCodeAt(_p);
            _cursor = _cursor + 1 | 0;
            if (next_char < 74) {
              if (next_char < 73) {
                break _L$2;
              } else {
                break _L$7;
              }
            } else {
              if (next_char > 104) {
                if (next_char < 106) {
                  break _L$7;
                } else {
                  break _L$2;
                }
              } else {
                break _L$2;
              }
            }
          }
          if ((_cursor + 3 | 0) < _end) {
            _L$8: {
              const _p = _cursor;
              const next_char = _data.charCodeAt(_p);
              _cursor = _cursor + 1 | 0;
              if (next_char < 79) {
                if (next_char < 78) {
                  break _L$2;
                } else {
                  break _L$8;
                }
              } else {
                if (next_char > 109) {
                  if (next_char < 111) {
                    break _L$8;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$9: {
              const _p = _cursor;
              const next_char = _data.charCodeAt(_p);
              _cursor = _cursor + 1 | 0;
              if (next_char < 74) {
                if (next_char < 73) {
                  break _L$2;
                } else {
                  break _L$9;
                }
              } else {
                if (next_char > 104) {
                  if (next_char < 106) {
                    break _L$9;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$10: {
              const _p = _cursor;
              const next_char = _data.charCodeAt(_p);
              _cursor = _cursor + 1 | 0;
              if (next_char < 85) {
                if (next_char < 84) {
                  break _L$2;
                } else {
                  break _L$10;
                }
              } else {
                if (next_char > 115) {
                  if (next_char < 117) {
                    break _L$10;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            _L$11: {
              const _p = _cursor;
              const next_char = _data.charCodeAt(_p);
              _cursor = _cursor + 1 | 0;
              if (next_char < 90) {
                if (next_char < 89) {
                  break _L$2;
                } else {
                  break _L$11;
                }
              } else {
                if (next_char > 120) {
                  if (next_char < 122) {
                    break _L$11;
                  } else {
                    break _L$2;
                  }
                } else {
                  break _L$2;
                }
              }
            }
            if (_cursor < _end) {
              break _L$2;
            } else {
              break _L$3;
            }
          } else {
            break _L$2;
          }
        } else {
          break _L$3;
        }
      } else {
        break _L$2;
      }
    }
    accept_state = 1;
    match_end = _cursor;
    break _L$2;
  }
  switch (accept_state) {
    case 0: {
      return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double14not__a__number);
    }
    case 1: {
      return pos ? new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double8infinity) : new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_M0FPC16double13neg__infinity);
    }
    default: {
      return _M0FPC28internal7strconv11syntax__errGdE();
    }
  }
}
function _M0FPC28internal7strconv12checked__mul(a, b) {
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 0n) || BigInt.asUintN(64, b) === BigInt.asUintN(64, 0n)) {
    return _M0FPC28internal7strconv12checked__mulN6constrS1190;
  }
  if (BigInt.asUintN(64, a) === BigInt.asUintN(64, 1n)) {
    return b;
  }
  if (BigInt.asUintN(64, b) === BigInt.asUintN(64, 1n)) {
    return a;
  }
  if ($i64_clz(b) === 0 || $i64_clz(a) === 0) {
    return undefined;
  }
  if (b === 0n) {
    $panic();
  }
  const quotient = BigInt.asUintN(64, BigInt.asUintN(64, 18446744073709551615n) / BigInt.asUintN(64, b));
  if (BigInt.asUintN(64, a) > BigInt.asUintN(64, quotient)) {
    return undefined;
  }
  return BigInt.asUintN(64, a * b);
}
function _M0FPC28internal7strconv19overflow__threshold(base, neg) {
  if (!neg) {
    if (base === 10) {
      return 922337203685477581n;
    } else {
      if (base === 16) {
        return 576460752303423488n;
      } else {
        const _tmp = BigInt.asUintN(64, BigInt(base));
        if (_tmp === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775807n) / BigInt.asIntN(64, _tmp)) + 1n);
      }
    }
  } else {
    if (base === 10) {
      return 17524406870024074036n;
    } else {
      if (base === 16) {
        return 17870283321406128128n;
      } else {
        const _tmp = BigInt.asUintN(64, BigInt(base));
        if (_tmp === 0n) {
          $panic();
        }
        return BigInt.asUintN(64, BigInt.asIntN(64, 9223372036854775808n) / BigInt.asIntN(64, _tmp));
      }
    }
  }
}
function _M0FPC28internal7strconv20parse__int64_2einner(str, base) {
  if (_M0IP016_24default__implPB2Eq10not__equalGRPC16string10StringViewE(str, new _M0TPC16string10StringView(_M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658, 0, _M0FPC28internal7strconv20parse__int64_2einnerN7_2abindS658.length))) {
    let neg;
    let rest;
    _L: {
      let rest$2;
      _L$2: {
        const _bind = _M0MPC16string10StringView12view_2einner(str, 0, undefined);
        if (_M0MPC16string6String24char__length__ge_2einner(_bind.str, 1, _bind.start, _bind.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(_bind.str, _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 0, _bind.start, _bind.end));
          switch (_x) {
            case 43: {
              const _tmp = _bind.str;
              const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 1, _bind.start, _bind.end);
              let _tmp$2;
              if (_bind$2 === undefined) {
                _tmp$2 = _bind.end;
              } else {
                const _Some = _bind$2;
                _tmp$2 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, _bind.end);
              neg = false;
              rest = _x$2;
              break _L;
            }
            case 45: {
              const _tmp$3 = _bind.str;
              const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(_bind.str, 1, _bind.start, _bind.end);
              let _tmp$4;
              if (_bind$3 === undefined) {
                _tmp$4 = _bind.end;
              } else {
                const _Some = _bind$3;
                _tmp$4 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, _bind.end);
              neg = true;
              rest = _x$3;
              break _L;
            }
            default: {
              rest$2 = _bind;
              break _L$2;
            }
          }
        } else {
          rest$2 = _bind;
          break _L$2;
        }
      }
      neg = false;
      rest = rest$2;
      break _L;
    }
    const _bind = _M0FPC28internal7strconv25check__and__consume__base(rest, base);
    let _bind$2;
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _bind$2 = _ok._0;
    } else {
      return _bind;
    }
    const _num_base = _bind$2._0;
    const _rest = _bind$2._1;
    const _allow_underscore = _bind$2._2;
    const overflow_threshold = _M0FPC28internal7strconv19overflow__threshold(_num_base, neg);
    let has_digit;
    if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 1, _rest.start, _rest.end)) {
      const _x = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 0, _rest.start, _rest.end));
      if (_x >= 48 && _x <= 57) {
        has_digit = true;
      } else {
        if (_x >= 97 && _x <= 122) {
          has_digit = true;
        } else {
          if (_x >= 65 && _x <= 90) {
            has_digit = true;
          } else {
            if (_M0MPC16string6String24char__length__ge_2einner(_rest.str, 2, _rest.start, _rest.end)) {
              if (_x === 95) {
                const _x$2 = _M0MPC16string6String16unsafe__char__at(_rest.str, _M0MPC16string6String29offset__of__nth__char_2einner(_rest.str, 1, _rest.start, _rest.end));
                has_digit = _x$2 >= 48 && _x$2 <= 57 ? true : _x$2 >= 97 && _x$2 <= 122 ? true : _x$2 >= 65 && _x$2 <= 90;
              } else {
                has_digit = false;
              }
            } else {
              has_digit = false;
            }
          }
        }
      }
    } else {
      has_digit = false;
    }
    if (has_digit) {
      let _tmp;
      let _tmp$2 = _rest;
      let _tmp$3 = 0n;
      let _tmp$4 = _allow_underscore;
      while (true) {
        const rest$2 = _tmp$2;
        const acc = _tmp$3;
        const allow_underscore = _tmp$4;
        let acc$2;
        let rest$3;
        let c;
        _L$2: {
          _L$3: {
            if (_M0MPC16string6String24char__length__eq_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
              const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
              if (_x === 95) {
                const _bind$3 = _M0FPC28internal7strconv11syntax__errGuE();
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _ok._0;
                } else {
                  return _bind$3;
                }
              } else {
                const _tmp$5 = rest$2.str;
                const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                let _tmp$6;
                if (_bind$3 === undefined) {
                  _tmp$6 = rest$2.end;
                } else {
                  const _Some = _bind$3;
                  _tmp$6 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$5, _tmp$6, rest$2.end);
                acc$2 = acc;
                rest$3 = _x$2;
                c = _x;
                break _L$3;
              }
            } else {
              if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
                const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
                if (_x === 95) {
                  if (allow_underscore === false) {
                    const _bind$3 = _M0FPC28internal7strconv11syntax__errGuE();
                    if (_bind$3.$tag === 1) {
                      const _ok = _bind$3;
                      _ok._0;
                    } else {
                      return _bind$3;
                    }
                  } else {
                    const _tmp$5 = rest$2.str;
                    const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                    let _tmp$6;
                    if (_bind$3 === undefined) {
                      _tmp$6 = rest$2.end;
                    } else {
                      const _Some = _bind$3;
                      _tmp$6 = _Some;
                    }
                    const _x$2 = new _M0TPC16string10StringView(_tmp$5, _tmp$6, rest$2.end);
                    _tmp$2 = _x$2;
                    _tmp$4 = false;
                    continue;
                  }
                } else {
                  const _tmp$5 = rest$2.str;
                  const _bind$3 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
                  let _tmp$6;
                  if (_bind$3 === undefined) {
                    _tmp$6 = rest$2.end;
                  } else {
                    const _Some = _bind$3;
                    _tmp$6 = _Some;
                  }
                  const _x$2 = new _M0TPC16string10StringView(_tmp$5, _tmp$6, rest$2.end);
                  acc$2 = acc;
                  rest$3 = _x$2;
                  c = _x;
                  break _L$3;
                }
              } else {
                _tmp = acc;
                break;
              }
            }
            break _L$2;
          }
          const c$2 = c;
          let d;
          if (c$2 >= 48 && c$2 <= 57) {
            d = c$2 - 48 | 0;
          } else {
            if (c$2 >= 97 && c$2 <= 122) {
              d = c$2 + -87 | 0;
            } else {
              if (c$2 >= 65 && c$2 <= 90) {
                d = c$2 + -55 | 0;
              } else {
                const _bind$3 = _M0FPC28internal7strconv11syntax__errGiE();
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  d = _ok._0;
                } else {
                  return _bind$3;
                }
              }
            }
          }
          if (d < _num_base) {
            if (neg) {
              if (BigInt.asIntN(64, acc$2) >= BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) - BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) <= BigInt.asIntN(64, acc$2)) {
                  _tmp$2 = rest$3;
                  _tmp$3 = next_acc;
                  _tmp$4 = true;
                  continue;
                } else {
                  const _bind$3 = _M0FPC28internal7strconv10range__errGuE();
                  if (_bind$3.$tag === 1) {
                    const _ok = _bind$3;
                    _ok._0;
                  } else {
                    return _bind$3;
                  }
                }
              } else {
                const _bind$3 = _M0FPC28internal7strconv10range__errGuE();
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _ok._0;
                } else {
                  return _bind$3;
                }
              }
            } else {
              if (BigInt.asIntN(64, acc$2) < BigInt.asIntN(64, overflow_threshold)) {
                const next_acc = BigInt.asUintN(64, BigInt.asUintN(64, acc$2 * BigInt.asUintN(64, BigInt(_num_base))) + BigInt.asUintN(64, BigInt(d)));
                if (BigInt.asIntN(64, next_acc) >= BigInt.asIntN(64, acc$2)) {
                  _tmp$2 = rest$3;
                  _tmp$3 = next_acc;
                  _tmp$4 = true;
                  continue;
                } else {
                  const _bind$3 = _M0FPC28internal7strconv10range__errGuE();
                  if (_bind$3.$tag === 1) {
                    const _ok = _bind$3;
                    _ok._0;
                  } else {
                    return _bind$3;
                  }
                }
              } else {
                const _bind$3 = _M0FPC28internal7strconv10range__errGuE();
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _ok._0;
                } else {
                  return _bind$3;
                }
              }
            }
          } else {
            const _bind$3 = _M0FPC28internal7strconv11syntax__errGuE();
            if (_bind$3.$tag === 1) {
              const _ok = _bind$3;
              _ok._0;
            } else {
              return _bind$3;
            }
          }
        }
        continue;
      }
      return new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(_tmp);
    } else {
      return _M0FPC28internal7strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGlE();
  }
}
function _M0FPC28internal7strconv17check__underscore(str) {
  let rest;
  if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
    const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
    switch (_x) {
      case 43: {
        const _tmp = str.str;
        const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$2;
        if (_bind === undefined) {
          _tmp$2 = str.end;
        } else {
          const _Some = _bind;
          _tmp$2 = _Some;
        }
        const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, str.end);
        rest = _x$2;
        break;
      }
      case 45: {
        const _tmp$3 = str.str;
        const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
        let _tmp$4;
        if (_bind$2 === undefined) {
          _tmp$4 = str.end;
        } else {
          const _Some = _bind$2;
          _tmp$4 = _Some;
        }
        const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, str.end);
        rest = _x$3;
        break;
      }
      default: {
        rest = str;
      }
    }
  } else {
    rest = str;
  }
  let rest$2;
  let allow_underscore;
  let hex;
  _L: {
    const _data = rest.str;
    const _start = rest.start;
    const _end = _start + (rest.end - rest.start | 0) | 0;
    let _cursor = _start;
    let accept_state = -1;
    let match_end = -1;
    _L$2: {
      if ((_cursor + 1 | 0) < _end) {
        const _p = _cursor;
        if (_data.charCodeAt(_p) === 48) {
          _cursor = _cursor + 1 | 0;
          _L$3: {
            _L$4: {
              _L$5: {
                const _p$2 = _cursor;
                const next_char = _data.charCodeAt(_p$2);
                _cursor = _cursor + 1 | 0;
                if (next_char < 89) {
                  if (next_char < 79) {
                    if (next_char === 66) {
                      break _L$3;
                    } else {
                      break _L$2;
                    }
                  } else {
                    if (next_char > 79) {
                      if (next_char < 88) {
                        break _L$2;
                      } else {
                        break _L$5;
                      }
                    } else {
                      break _L$4;
                    }
                  }
                } else {
                  if (next_char > 97) {
                    if (next_char < 112) {
                      if (next_char < 99) {
                        break _L$3;
                      } else {
                        if (next_char > 110) {
                          break _L$4;
                        } else {
                          break _L$2;
                        }
                      }
                    } else {
                      if (next_char > 119) {
                        if (next_char < 121) {
                          break _L$5;
                        } else {
                          break _L$2;
                        }
                      } else {
                        break _L$2;
                      }
                    }
                  } else {
                    break _L$2;
                  }
                }
              }
              accept_state = 2;
              match_end = _cursor;
              break _L$2;
            }
            accept_state = 1;
            match_end = _cursor;
            break _L$2;
          }
          accept_state = 0;
          match_end = _cursor;
          break _L$2;
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    switch (accept_state) {
      case 2: {
        const rest$3 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$3;
        allow_underscore = true;
        hex = true;
        break _L;
      }
      case 1: {
        const rest$4 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$4;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      case 0: {
        const rest$5 = _M0MPC16string6String4view(_data, match_end, _end);
        rest$2 = rest$5;
        allow_underscore = true;
        hex = false;
        break _L;
      }
      default: {
        rest$2 = rest;
        allow_underscore = false;
        hex = false;
        break _L;
      }
    }
  }
  let _tmp = rest$2;
  let _tmp$2 = allow_underscore;
  let _tmp$3 = false;
  while (true) {
    const rest$3 = _tmp;
    const allow_underscore$2 = _tmp$2;
    const follow_underscore = _tmp$3;
    let rest$4;
    let c;
    let follow_underscore$2;
    _L$2: {
      if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 0, rest$3.start, rest$3.end)) {
        return true;
      } else {
        if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 1, rest$3.start, rest$3.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            return false;
          } else {
            const _tmp$4 = rest$3.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$5;
            if (_bind === undefined) {
              _tmp$5 = rest$3.end;
            } else {
              const _Some = _bind;
              _tmp$5 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, rest$3.end);
            rest$4 = _x$2;
            c = _x;
            follow_underscore$2 = follow_underscore;
            break _L$2;
          }
        } else {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            if (allow_underscore$2 === false) {
              return false;
            } else {
              const _tmp$4 = rest$3.str;
              const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
              let _tmp$5;
              if (_bind === undefined) {
                _tmp$5 = rest$3.end;
              } else {
                const _Some = _bind;
                _tmp$5 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, rest$3.end);
              _tmp = _x$2;
              _tmp$2 = false;
              _tmp$3 = true;
              continue;
            }
          } else {
            const _tmp$4 = rest$3.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$5;
            if (_bind === undefined) {
              _tmp$5 = rest$3.end;
            } else {
              const _Some = _bind;
              _tmp$5 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, rest$3.end);
            rest$4 = _x$2;
            c = _x;
            follow_underscore$2 = follow_underscore;
            break _L$2;
          }
        }
      }
    }
    if (c >= 48 && c <= 57 ? true : hex && (c >= 97 && c <= 102 ? true : c >= 65 && c <= 70)) {
      _tmp = rest$4;
      _tmp$2 = true;
      _tmp$3 = false;
      continue;
    } else {
      if (follow_underscore$2) {
        return false;
      } else {
        _tmp = rest$4;
        _tmp$2 = false;
        _tmp$3 = false;
        continue;
      }
    }
  }
}
function _M0MPC28internal7strconv7Decimal9new__priv() {
  return new _M0TPC28internal7strconv7Decimal($makebytes(800, 0), 0, 0, false, false);
}
function _M0MPC28internal7strconv7Decimal4trim(self) {
  while (true) {
    let _tmp;
    if (self.digits_num > 0) {
      const _tmp$2 = self.digits;
      const _tmp$3 = self.digits_num - 1 | 0;
      $bound_check(_tmp$2, _tmp$3);
      const _p = _tmp$2[_tmp$3];
      const _p$2 = 0;
      _tmp = _p === _p$2;
    } else {
      _tmp = false;
    }
    if (_tmp) {
      self.digits_num = self.digits_num - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.digits_num === 0) {
    self.decimal_point = 0;
    return;
  } else {
    return;
  }
}
function _M0FPC28internal7strconv26parse__decimal__from__view(str) {
  const d = _M0MPC28internal7strconv7Decimal9new__priv();
  let has_dp = false;
  let has_digits = false;
  let rest;
  _L: {
    _L$2: {
      if (_M0MPC16string6String24char__length__ge_2einner(str.str, 1, str.start, str.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(str.str, _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 0, str.start, str.end));
        switch (_x) {
          case 45: {
            const _tmp = str.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$2;
            if (_bind === undefined) {
              _tmp$2 = str.end;
            } else {
              const _Some = _bind;
              _tmp$2 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp, _tmp$2, str.end);
            d.negative = true;
            rest = _x$2;
            break;
          }
          case 43: {
            const _tmp$3 = str.str;
            const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(str.str, 1, str.start, str.end);
            let _tmp$4;
            if (_bind$2 === undefined) {
              _tmp$4 = str.end;
            } else {
              const _Some = _bind$2;
              _tmp$4 = _Some;
            }
            rest = new _M0TPC16string10StringView(_tmp$3, _tmp$4, str.end);
            break;
          }
          default: {
            break _L$2;
          }
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    rest = str;
  }
  let rest$2;
  let _tmp = rest;
  while (true) {
    const rest$3 = _tmp;
    let rest$4;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(rest$3.str, 1, rest$3.start, rest$3.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$3.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 0, rest$3.start, rest$3.end));
          if (_x === 95) {
            const _tmp$2 = rest$3.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = rest$3.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, rest$3.end);
            _tmp = _x$2;
            continue;
          } else {
            if (_x === 46) {
              const _tmp$2 = rest$3.str;
              const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
              let _tmp$3;
              if (_bind === undefined) {
                _tmp$3 = rest$3.end;
              } else {
                const _Some = _bind;
                _tmp$3 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, rest$3.end);
              if (!has_dp) {
                has_dp = true;
                d.decimal_point = d.digits_num;
                _tmp = _x$2;
                continue;
              } else {
                const _bind$2 = _M0FPC28internal7strconv11syntax__errGuE();
                if (_bind$2.$tag === 1) {
                  const _ok = _bind$2;
                  _ok._0;
                } else {
                  return _bind$2;
                }
              }
            } else {
              if (_x >= 48 && _x <= 57) {
                const _tmp$2 = rest$3.str;
                const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$3.str, 1, rest$3.start, rest$3.end);
                let _tmp$3;
                if (_bind === undefined) {
                  _tmp$3 = rest$3.end;
                } else {
                  const _Some = _bind;
                  _tmp$3 = _Some;
                }
                const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, rest$3.end);
                has_digits = true;
                if (_x === 48 && d.digits_num === 0) {
                  d.decimal_point = d.decimal_point - 1 | 0;
                  _tmp = _x$2;
                  continue;
                }
                if (d.digits_num < d.digits.length) {
                  const _tmp$4 = d.digits;
                  const _tmp$5 = d.digits_num;
                  $bound_check(_tmp$4, _tmp$5);
                  _tmp$4[_tmp$5] = (_x - 48 | 0) & 255;
                  d.digits_num = d.digits_num + 1 | 0;
                } else {
                  if (_x !== 48) {
                    d.truncated = true;
                  }
                }
                _tmp = _x$2;
                continue;
              } else {
                rest$4 = rest$3;
                break _L$3;
              }
            }
          }
        } else {
          rest$4 = rest$3;
          break _L$3;
        }
        break _L$2;
      }
      rest$2 = rest$4;
      break;
    }
    continue;
  }
  if (has_digits) {
    if (!has_dp) {
      d.decimal_point = d.digits_num;
    }
    let rest$3;
    let rest$4;
    _L$2: {
      _L$3: {
        if (_M0MPC16string6String24char__length__ge_2einner(rest$2.str, 1, rest$2.start, rest$2.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(rest$2.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 0, rest$2.start, rest$2.end));
          switch (_x) {
            case 101: {
              const _tmp$2 = rest$2.str;
              const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$3;
              if (_bind === undefined) {
                _tmp$3 = rest$2.end;
              } else {
                const _Some = _bind;
                _tmp$3 = _Some;
              }
              const _x$2 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, rest$2.end);
              rest$4 = _x$2;
              break _L$3;
            }
            case 69: {
              const _tmp$4 = rest$2.str;
              const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$5;
              if (_bind$2 === undefined) {
                _tmp$5 = rest$2.end;
              } else {
                const _Some = _bind$2;
                _tmp$5 = _Some;
              }
              const _x$3 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, rest$2.end);
              rest$4 = _x$3;
              break _L$3;
            }
            default: {
              rest$3 = rest$2;
            }
          }
        } else {
          rest$3 = rest$2;
        }
        break _L$2;
      }
      let exp_sign = 1;
      let rest$5;
      if (_M0MPC16string6String24char__length__ge_2einner(rest$4.str, 1, rest$4.start, rest$4.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(rest$4.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 0, rest$4.start, rest$4.end));
        switch (_x) {
          case 43: {
            const _tmp$2 = rest$4.str;
            const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = rest$4.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            rest$5 = new _M0TPC16string10StringView(_tmp$2, _tmp$3, rest$4.end);
            break;
          }
          case 45: {
            const _tmp$4 = rest$4.str;
            const _bind$2 = _M0MPC16string6String29offset__of__nth__char_2einner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$5;
            if (_bind$2 === undefined) {
              _tmp$5 = rest$4.end;
            } else {
              const _Some = _bind$2;
              _tmp$5 = _Some;
            }
            const _x$2 = new _M0TPC16string10StringView(_tmp$4, _tmp$5, rest$4.end);
            exp_sign = -1;
            rest$5 = _x$2;
            break;
          }
          default: {
            rest$5 = rest$4;
          }
        }
      } else {
        rest$5 = rest$4;
      }
      _L$4: {
        _L$5: {
          if (_M0MPC16string6String24char__length__ge_2einner(rest$5.str, 1, rest$5.start, rest$5.end)) {
            const _x = _M0MPC16string6String16unsafe__char__at(rest$5.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$5.str, 0, rest$5.start, rest$5.end));
            if (_x >= 48 && _x <= 57) {
              const exp_limit = exp_sign > 0 ? (d.decimal_point < 311 ? 311 - d.decimal_point | 0 : 0) : d.decimal_point > -331 ? d.decimal_point + 331 | 0 : 0;
              let exp = 0;
              let rest$6;
              let _tmp$2 = rest$5;
              while (true) {
                const rest$7 = _tmp$2;
                let rest$8;
                _L$6: {
                  if (_M0MPC16string6String24char__length__ge_2einner(rest$7.str, 1, rest$7.start, rest$7.end)) {
                    const _x$2 = _M0MPC16string6String16unsafe__char__at(rest$7.str, _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 0, rest$7.start, rest$7.end));
                    if (_x$2 === 95) {
                      const _tmp$3 = rest$7.str;
                      const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 1, rest$7.start, rest$7.end);
                      let _tmp$4;
                      if (_bind === undefined) {
                        _tmp$4 = rest$7.end;
                      } else {
                        const _Some = _bind;
                        _tmp$4 = _Some;
                      }
                      const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, rest$7.end);
                      _tmp$2 = _x$3;
                      continue;
                    } else {
                      if (_x$2 >= 48 && _x$2 <= 57) {
                        const _tmp$3 = rest$7.str;
                        const _bind = _M0MPC16string6String29offset__of__nth__char_2einner(rest$7.str, 1, rest$7.start, rest$7.end);
                        let _tmp$4;
                        if (_bind === undefined) {
                          _tmp$4 = rest$7.end;
                        } else {
                          const _Some = _bind;
                          _tmp$4 = _Some;
                        }
                        const _x$3 = new _M0TPC16string10StringView(_tmp$3, _tmp$4, rest$7.end);
                        if (exp < exp_limit) {
                          exp = (Math.imul(exp, 10) | 0) + (_x$2 - 48 | 0) | 0;
                          if (exp > exp_limit) {
                            exp = exp_limit;
                          }
                        }
                        _tmp$2 = _x$3;
                        continue;
                      } else {
                        rest$8 = rest$7;
                        break _L$6;
                      }
                    }
                  } else {
                    rest$8 = rest$7;
                    break _L$6;
                  }
                }
                rest$6 = rest$8;
                break;
              }
              d.decimal_point = d.decimal_point + (Math.imul(exp_sign, exp) | 0) | 0;
              rest$3 = rest$6;
            } else {
              break _L$5;
            }
          } else {
            break _L$5;
          }
          break _L$4;
        }
        const _bind = _M0FPC28internal7strconv11syntax__errGlE();
        if (_bind.$tag === 1) {
          const _ok = _bind;
          rest$3 = _ok._0;
        } else {
          return _bind;
        }
      }
    }
    if (_M0MPC16string6String24char__length__eq_2einner(rest$3.str, 0, rest$3.start, rest$3.end)) {
      _M0MPC28internal7strconv7Decimal4trim(d);
      return new _M0DTPC16result6ResultGRPC28internal7strconv7DecimalRPC15error5ErrorE2Ok(d);
    } else {
      return _M0FPC28internal7strconv11syntax__errGlE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGlE();
  }
}
function _M0FPC28internal7strconv20parse__decimal__priv(str) {
  return _M0FPC28internal7strconv26parse__decimal__from__view(str);
}
function _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, negative) {
  const biased_exp = exponent - _M0FPC28internal7strconv12double__info.bias | 0;
  let bits = BigInt.asUintN(64, mantissa & BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)) - 1n));
  const exp_bits = BigInt.asUintN(64, BigInt(biased_exp & ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)));
  bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, exp_bits << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)));
  if (negative) {
    bits = BigInt.asUintN(64, bits | BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)) << BigInt(_M0FPC28internal7strconv12double__info.exponent_bits & 63)));
  }
  return bits;
}
function _M0MPC28internal7strconv7Decimal17should__round__up(self, d) {
  if (d < 0 || d >= self.digits_num) {
    return false;
  }
  let _tmp;
  const _tmp$2 = self.digits;
  $bound_check(_tmp$2, d);
  if (_tmp$2[d] === 5) {
    _tmp = (d + 1 | 0) === self.digits_num;
  } else {
    _tmp = false;
  }
  if (_tmp) {
    if (self.truncated) {
      return true;
    }
    let _tmp$3;
    if (d > 0) {
      const _tmp$4 = self.digits;
      const _tmp$5 = d - 1 | 0;
      $bound_check(_tmp$4, _tmp$5);
      _tmp$3 = (_tmp$4[_tmp$5] % 2 | 0) !== 0;
    } else {
      _tmp$3 = false;
    }
    return _tmp$3;
  }
  const _tmp$3 = self.digits;
  $bound_check(_tmp$3, d);
  return _tmp$3[d] >= 5;
}
function _M0MPC28internal7strconv7Decimal16rounded__integer(self) {
  if (self.decimal_point > 20) {
    return 18446744073709551615n;
  }
  let _tmp = 0n;
  let _tmp$2 = 0;
  while (true) {
    const n = _tmp;
    const i = _tmp$2;
    if (i < self.decimal_point && i < self.digits_num) {
      const _tmp$3 = BigInt.asUintN(64, n * 10n);
      const _tmp$4 = self.digits;
      $bound_check(_tmp$4, i);
      const _p = _tmp$4[i];
      _tmp = BigInt.asUintN(64, _tmp$3 + BigInt.asUintN(64, BigInt(_p)));
      _tmp$2 = i + 1 | 0;
      continue;
    } else {
      let n$2;
      let _tmp$3 = n;
      let _tmp$4 = i;
      while (true) {
        const n$3 = _tmp$3;
        const i$2 = _tmp$4;
        if (i$2 < self.decimal_point) {
          _tmp$3 = BigInt.asUintN(64, n$3 * 10n);
          _tmp$4 = i$2 + 1 | 0;
          continue;
        } else {
          n$2 = n$3;
          break;
        }
      }
      return _M0MPC28internal7strconv7Decimal17should__round__up(self, self.decimal_point) ? BigInt.asUintN(64, n$2 + 1n) : n$2;
    }
  }
}
function _M0MPC28internal7strconv7Decimal11new__digits(self, s) {
  $bound_check(_M0FPC28internal7strconv19left__shift__cheats, s);
  const new_digits = _M0FPC28internal7strconv19left__shift__cheats[s]._0;
  $bound_check(_M0FPC28internal7strconv19left__shift__cheats, s);
  const cheat_num = _M0FPC28internal7strconv19left__shift__cheats[s]._1;
  const _bind = cheat_num.length;
  let less;
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < _bind) {
      if (i >= self.digits_num) {
        less = true;
        break;
      }
      const d = cheat_num.charCodeAt(i) - 48 | 0;
      const _tmp$2 = self.digits;
      $bound_check(_tmp$2, i);
      if (_tmp$2[i] !== d) {
        const _tmp$3 = self.digits;
        $bound_check(_tmp$3, i);
        less = _tmp$3[i] < d;
        break;
      }
      _tmp = i + 1 | 0;
      continue;
    } else {
      less = false;
      break;
    }
  }
  return less ? new_digits - 1 | 0 : new_digits;
}
function _M0MPC28internal7strconv7Decimal11left__shift(self, s) {
  const new_digits = _M0MPC28internal7strconv7Decimal11new__digits(self, s);
  let read_index = self.digits_num;
  let write_index = self.digits_num + new_digits | 0;
  let acc = 0n;
  read_index = read_index - 1 | 0;
  while (true) {
    if (read_index >= 0) {
      const _tmp = self.digits;
      const _tmp$2 = read_index;
      $bound_check(_tmp, _tmp$2);
      const _p = _tmp[_tmp$2];
      const d = BigInt.asUintN(64, BigInt(_p));
      acc = BigInt.asUintN(64, acc + BigInt.asUintN(64, d << BigInt(s & 63)));
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, quo * 10n)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$3 = self.digits;
        const _tmp$4 = write_index;
        $bound_check(_tmp$3, _tmp$4);
        _tmp$3[_tmp$4] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      read_index = read_index - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asIntN(64, acc) > BigInt.asIntN(64, 0n)) {
      if (10n === 0n) {
        $panic();
      }
      const quo = BigInt.asUintN(64, BigInt.asIntN(64, acc) / BigInt.asIntN(64, 10n));
      const rem = Number(BigInt.asIntN(32, BigInt.asUintN(64, acc - BigInt.asUintN(64, 10n * quo)))) | 0;
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp = self.digits;
        const _tmp$2 = write_index;
        $bound_check(_tmp, _tmp$2);
        _tmp[_tmp$2] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      continue;
    } else {
      break;
    }
  }
  self.digits_num = self.digits_num + new_digits | 0;
  if (self.digits_num > self.digits.length) {
    self.digits_num = self.digits.length;
  }
  self.decimal_point = self.decimal_point + new_digits | 0;
  _M0MPC28internal7strconv7Decimal4trim(self);
}
function _M0MPC28internal7strconv7Decimal12right__shift(self, s) {
  let read_index = 0;
  let write_index = 0;
  let acc = 0n;
  while (true) {
    if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
      if (read_index >= self.digits_num) {
        while (true) {
          if (BigInt.asUintN(64, BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63))) === BigInt.asUintN(64, 0n)) {
            acc = BigInt.asUintN(64, acc * 10n);
            read_index = read_index + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break;
      }
      const _tmp = self.digits;
      const _tmp$2 = read_index;
      $bound_check(_tmp, _tmp$2);
      const d = _tmp[_tmp$2];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.decimal_point = self.decimal_point - (read_index - 1 | 0) | 0;
  const mask = BigInt.asUintN(64, BigInt.asUintN(64, 1n << BigInt(s & 63)) - 1n);
  while (true) {
    if (read_index < self.digits_num) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      const _tmp = self.digits;
      const _tmp$2 = write_index;
      $bound_check(_tmp, _tmp$2);
      _tmp[_tmp$2] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
      write_index = write_index + 1 | 0;
      acc = BigInt.asUintN(64, acc & mask);
      const _tmp$3 = self.digits;
      const _tmp$4 = read_index;
      $bound_check(_tmp$3, _tmp$4);
      const d = _tmp$3[_tmp$4];
      acc = BigInt.asUintN(64, BigInt.asUintN(64, acc * 10n) + BigInt.asUintN(64, BigInt(d)));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (BigInt.asUintN(64, acc) > BigInt.asUintN(64, 0n)) {
      const out = BigInt.asUintN(64, BigInt.asUintN(64, acc) >> BigInt(s & 63));
      if (write_index < self.digits.length) {
        const _tmp = self.digits;
        const _tmp$2 = write_index;
        $bound_check(_tmp, _tmp$2);
        _tmp[_tmp$2] = (Number(BigInt.asIntN(32, out)) | 0) & 255;
        write_index = write_index + 1 | 0;
      } else {
        if (BigInt.asUintN(64, out) > BigInt.asUintN(64, 0n)) {
          self.truncated = true;
        }
      }
      acc = BigInt.asUintN(64, acc & mask);
      acc = BigInt.asUintN(64, acc * 10n);
      continue;
    } else {
      break;
    }
  }
  self.digits_num = write_index;
  _M0MPC28internal7strconv7Decimal4trim(self);
}
function _M0MPC28internal7strconv7Decimal11shift__priv(self, s) {
  if (self.digits_num === 0) {
    return undefined;
  }
  let s$2 = s;
  if (s$2 > 0) {
    while (true) {
      if (s$2 > 59) {
        _M0MPC28internal7strconv7Decimal11left__shift(self, 59);
        s$2 = s$2 - 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC28internal7strconv7Decimal11left__shift(self, s$2);
  }
  if (s$2 < 0) {
    while (true) {
      if (s$2 < -59) {
        _M0MPC28internal7strconv7Decimal12right__shift(self, 59);
        s$2 = s$2 + 59 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC28internal7strconv7Decimal12right__shift(self, -s$2 | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC28internal7strconv7Decimal16to__double__priv(self) {
  let exponent = 0;
  let mantissa = 0n;
  if (self.digits_num === 0 || self.decimal_point < -330) {
    mantissa = 0n;
    exponent = _M0FPC28internal7strconv12double__info.bias;
    const bits = _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, self.negative);
    return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok($i64_reinterpret_f64(bits));
  }
  if (self.decimal_point > 310) {
    const _bind = _M0FPC28internal7strconv10range__errGuE();
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _ok._0;
    } else {
      return _bind;
    }
  }
  while (true) {
    if (self.decimal_point > 0) {
      let n = 0;
      if (self.decimal_point >= _M0FPC28internal7strconv6powtab.length) {
        n = 60;
      } else {
        const _p = self.decimal_point;
        $bound_check(_M0FPC28internal7strconv6powtab, _p);
        n = _M0FPC28internal7strconv6powtab[_p];
      }
      _M0MPC28internal7strconv7Decimal11shift__priv(self, -n | 0);
      exponent = exponent + n | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    let _tmp;
    if (self.decimal_point < 0) {
      _tmp = true;
    } else {
      let _tmp$2;
      if (self.decimal_point === 0) {
        const _tmp$3 = self.digits;
        $bound_check(_tmp$3, 0);
        _tmp$2 = _tmp$3[0] < 5;
      } else {
        _tmp$2 = false;
      }
      _tmp = _tmp$2;
    }
    if (_tmp) {
      let n = 0;
      if ((-self.decimal_point | 0) >= _M0FPC28internal7strconv6powtab.length) {
        n = 60;
      } else {
        const _p = -self.decimal_point | 0;
        $bound_check(_M0FPC28internal7strconv6powtab, _p);
        n = _M0FPC28internal7strconv6powtab[_p];
      }
      _M0MPC28internal7strconv7Decimal11shift__priv(self, n);
      exponent = exponent - n | 0;
      continue;
    } else {
      break;
    }
  }
  exponent = exponent - 1 | 0;
  if (exponent < (_M0FPC28internal7strconv12double__info.bias + 1 | 0)) {
    const n = (_M0FPC28internal7strconv12double__info.bias + 1 | 0) - exponent | 0;
    _M0MPC28internal7strconv7Decimal11shift__priv(self, -n | 0);
    exponent = exponent + n | 0;
  }
  if ((exponent - _M0FPC28internal7strconv12double__info.bias | 0) >= ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)) {
    const _bind = _M0FPC28internal7strconv10range__errGuE();
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _ok._0;
    } else {
      return _bind;
    }
  }
  _M0MPC28internal7strconv7Decimal11shift__priv(self, _M0FPC28internal7strconv12double__info.mantissa_bits + 1 | 0);
  mantissa = _M0MPC28internal7strconv7Decimal16rounded__integer(self);
  if (BigInt.asUintN(64, mantissa) === BigInt.asUintN(64, BigInt.asUintN(64, 2n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)))) {
    mantissa = BigInt.asUintN(64, BigInt.asIntN(64, mantissa) >> BigInt(1 & 63));
    exponent = exponent + 1 | 0;
    if ((exponent - _M0FPC28internal7strconv12double__info.bias | 0) >= ((1 << _M0FPC28internal7strconv12double__info.exponent_bits) - 1 | 0)) {
      const _bind = _M0FPC28internal7strconv10range__errGuE();
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _ok._0;
      } else {
        return _bind;
      }
    }
  }
  if (BigInt.asUintN(64, BigInt.asUintN(64, mantissa & BigInt.asUintN(64, 1n << BigInt(_M0FPC28internal7strconv12double__info.mantissa_bits & 63)))) === BigInt.asUintN(64, 0n)) {
    exponent = _M0FPC28internal7strconv12double__info.bias;
  }
  const bits = _M0FPC28internal7strconv14assemble__bits(mantissa, exponent, self.negative);
  return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok($i64_reinterpret_f64(bits));
}
function _M0FPC28internal7strconv17pow10__fast__path(exponent) {
  const _p = exponent & 31;
  $bound_check(_M0FPC28internal7strconv5table, _p);
  return _M0FPC28internal7strconv5table[_p];
}
function _M0MPC28internal7strconv6Number14is__fast__path(self) {
  return BigInt.asIntN(64, _M0FPC28internal7strconv25min__exponent__fast__path) <= BigInt.asIntN(64, self.exponent) && (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC28internal7strconv36max__exponent__disguised__fast__path) && (BigInt.asUintN(64, self.mantissa) <= BigInt.asUintN(64, _M0FPC28internal7strconv25max__mantissa__fast__path) && !self.many_digits));
}
function _M0MPC28internal7strconv6Number15try__fast__path(self) {
  if (_M0MPC28internal7strconv6Number14is__fast__path(self)) {
    let value;
    if (BigInt.asIntN(64, self.exponent) <= BigInt.asIntN(64, _M0FPC28internal7strconv25max__exponent__fast__path)) {
      const value$2 = $f64_convert_i64_u(BigInt.asUintN(64, self.mantissa));
      value = BigInt.asIntN(64, self.exponent) < BigInt.asIntN(64, 0n) ? value$2 / _M0FPC28internal7strconv17pow10__fast__path(-(Number(BigInt.asIntN(32, self.exponent)) | 0) | 0) : value$2 * _M0FPC28internal7strconv17pow10__fast__path(Number(BigInt.asIntN(32, self.exponent)) | 0);
    } else {
      const shift = BigInt.asUintN(64, self.exponent - _M0FPC28internal7strconv25max__exponent__fast__path);
      const _tmp = self.mantissa;
      const _p = Number(BigInt.asIntN(32, shift)) | 0;
      $bound_check(_M0FPC28internal7strconv10int__pow10, _p);
      const _bind = _M0FPC28internal7strconv12checked__mul(_tmp, _M0FPC28internal7strconv10int__pow10[_p]);
      let mantissa;
      if (_bind === undefined) {
        return _M0DTPC16option6OptionGdE4None__;
      } else {
        const _Some = _bind;
        mantissa = _Some;
      }
      if (BigInt.asUintN(64, mantissa) > BigInt.asUintN(64, _M0FPC28internal7strconv25max__mantissa__fast__path)) {
        return _M0DTPC16option6OptionGdE4None__;
      }
      value = $f64_convert_i64_u(BigInt.asUintN(64, mantissa)) * _M0FPC28internal7strconv17pow10__fast__path(Number(BigInt.asIntN(32, _M0FPC28internal7strconv25max__exponent__fast__path)) | 0);
    }
    if (self.negative) {
      value = -value;
    }
    return new _M0DTPC16option6OptionGdE4Some(value);
  } else {
    return _M0DTPC16option6OptionGdE4None__;
  }
}
function _M0FPC28internal7strconv13parse__double(str) {
  if ((str.end - str.start | 0) > 0) {
    if (_M0FPC28internal7strconv17check__underscore(str)) {
      const _bind = _M0FPC28internal7strconv13parse__number(str);
      let _bind$2;
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _bind$2 = _ok._0;
      } else {
        return _bind;
      }
      if (_bind$2 === undefined) {
        return _M0FPC28internal7strconv15parse__inf__nan(str);
      } else {
        const _Some = _bind$2;
        const _num = _Some;
        const _bind$3 = _M0MPC28internal7strconv6Number15try__fast__path(_num);
        if (_bind$3.$tag === 1) {
          const _Some$2 = _bind$3;
          const _value = _Some$2._0;
          return new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_value);
        } else {
          const _bind$4 = _M0FPC28internal7strconv20parse__decimal__priv(str);
          let _tmp;
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp = _ok._0;
          } else {
            return _bind$4;
          }
          return _M0MPC28internal7strconv7Decimal16to__double__priv(_tmp);
        }
      }
    } else {
      return _M0FPC28internal7strconv11syntax__errGdE();
    }
  } else {
    return _M0FPC28internal7strconv11syntax__errGdE();
  }
}
function _M0IPC14json15JsonDecodeErrorPB4Show6output(_x_638, _x_639) {
  const _JsonDecodeError = _x_638;
  const _$42$arg_640 = _JsonDecodeError._0;
  _x_639.method_table.method_0(_x_639.self, "JsonDecodeError(");
  const _$42$x0_641 = _$42$arg_640._0;
  const _$42$x1_642 = _$42$arg_640._1;
  _x_639.method_table.method_0(_x_639.self, "(");
  _M0MPB6Logger13write__objectGRPC14json8JsonPathE(_x_639, _$42$x0_641);
  _x_639.method_table.method_0(_x_639.self, ", ");
  _M0MPB6Logger13write__objectGsE(_x_639, _$42$x1_642);
  _x_639.method_table.method_0(_x_639.self, ")");
  _x_639.method_table.method_0(_x_639.self, ")");
}
function _M0FPC14json20offset__to__position(input, offset) {
  let _tmp = 0;
  let _tmp$2 = 1;
  let _tmp$3 = 0;
  while (true) {
    const i = _tmp;
    const line = _tmp$2;
    const column = _tmp$3;
    if (i < offset) {
      const _p = input.str.charCodeAt(input.start + i | 0);
      const _p$2 = 10;
      if (_p === _p$2) {
        _tmp = i + 1 | 0;
        _tmp$2 = line + 1 | 0;
        _tmp$3 = 0;
        continue;
      } else {
        _tmp = i + 1 | 0;
        _tmp$3 = column + 1 | 0;
        continue;
      }
    } else {
      return new _M0TPC14json8Position(line, column);
    }
  }
}
function _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, shift) {
  const offset = ctx.offset + shift | 0;
  const _p = _M0MPC16string10StringView9get__char(ctx.input, offset);
  const _p$2 = 65533;
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(new _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(_M0FPC14json20offset__to__position(ctx.input, offset), _p === -1 ? _p$2 : _p));
}
function _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, shift) {
  const offset = ctx.offset + shift | 0;
  const _p = _M0MPC16string10StringView9get__char(ctx.input, offset);
  const _p$2 = 65533;
  return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(new _M0DTPC15error5Error52moonbitlang_2fcore_2fjson_2eParseError_2eInvalidChar(_M0FPC14json20offset__to__position(ctx.input, offset), _p === -1 ? _p$2 : _p));
}
function _M0IPC14json10ParseErrorPB4Show6output(self, logger) {
  switch (self.$tag) {
    case 7: {
      const _InvalidChar = self;
      const _x = _InvalidChar._0;
      const _line = _x.line;
      const _column = _x.column;
      const _c = _InvalidChar._1;
      logger.method_table.method_0(logger.self, "Invalid character ");
      logger.method_table.method_0(logger.self, _M0MPC14char4Char14escape_2einner(_c, true));
      logger.method_table.method_0(logger.self, " at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column);
      return;
    }
    case 6: {
      logger.method_table.method_0(logger.self, "Unexpected end of file");
      return;
    }
    case 5: {
      const _InvalidNumber = self;
      const _x$2 = _InvalidNumber._0;
      const _line$2 = _x$2.line;
      const _column$2 = _x$2.column;
      const _s = _InvalidNumber._1;
      logger.method_table.method_0(logger.self, "Invalid number ");
      logger.method_table.method_0(logger.self, _s);
      logger.method_table.method_0(logger.self, " at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line$2);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column$2);
      return;
    }
    case 4: {
      const _InvalidIdentEscape = self;
      const _x$3 = _InvalidIdentEscape._0;
      const _line$3 = _x$3.line;
      const _column$3 = _x$3.column;
      logger.method_table.method_0(logger.self, "Invalid escape sequence in identifier at line ");
      _M0MPB6Logger13write__objectGiE(logger, _line$3);
      logger.method_table.method_0(logger.self, ", column ");
      _M0MPB6Logger13write__objectGiE(logger, _column$3);
      return;
    }
    default: {
      logger.method_table.method_0(logger.self, "Depth limit exceeded, please increase the max_nesting_depth parameter");
      return;
    }
  }
}
function _M0FPC14json13decode__errorGsE(path, msg) {
  return new _M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE3Err(new _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError({ _0: path, _1: msg }));
}
function _M0FPC14json13decode__errorGbE(path, msg) {
  return new _M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE3Err(new _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError({ _0: path, _1: msg }));
}
function _M0FPC14json13decode__errorGiE(path, msg) {
  return new _M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE3Err(new _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError({ _0: path, _1: msg }));
}
function _M0FPC14json13decode__errorGuE(path, msg) {
  return new _M0DTPC16result6ResultGuRPC14json15JsonDecodeErrorE3Err(new _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError({ _0: path, _1: msg }));
}
function _M0FPC14json13decode__errorGRPB5ArrayGsEE(path, msg) {
  return new _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE3Err(new _M0DTPC15error5Error61moonbitlang_2fcore_2fjson_2eJsonDecodeError_2eJsonDecodeError({ _0: path, _1: msg }));
}
function _M0MPC14json12ParseContext21lex__skip__whitespace(ctx) {
  const rest = _M0MPC16string10StringView12view_2einner(ctx.input, ctx.offset, ctx.end_offset);
  const _data = rest.str;
  const _start = rest.start;
  const _end = _start + (rest.end - rest.start | 0) | 0;
  let _cursor = _start;
  let accept_state = -1;
  let match_end = -1;
  _L: {
    if (_cursor < _end) {
      _L$2: {
        const _p = _cursor;
        const next_char = _data.charCodeAt(_p);
        _cursor = _cursor + 1 | 0;
        if (next_char < 13) {
          if (next_char >= 9 && next_char <= 10) {
            break _L$2;
          } else {
            break _L;
          }
        } else {
          if (next_char > 13) {
            if (next_char === 32) {
              break _L$2;
            } else {
              break _L;
            }
          } else {
            break _L$2;
          }
        }
      }
      while (true) {
        accept_state = 0;
        match_end = _cursor;
        if (_cursor < _end) {
          _L$3: {
            const _p = _cursor;
            const next_char = _data.charCodeAt(_p);
            _cursor = _cursor + 1 | 0;
            if (next_char < 13) {
              if (next_char >= 9 && next_char <= 10) {
                break _L$3;
              } else {
                break _L;
              }
            } else {
              if (next_char > 13) {
                if (next_char === 32) {
                  break _L$3;
                } else {
                  break _L;
                }
              } else {
                break _L$3;
              }
            }
          }
          continue;
        } else {
          break _L;
        }
      }
    } else {
      break _L;
    }
  }
  if (accept_state === 0) {
    const next = _M0MPC16string6String4view(_data, match_end, _end);
    ctx.offset = ctx.end_offset - (next.end - next.start | 0) | 0;
    return;
  } else {
    return;
  }
}
function _M0MPC14json12ParseContext4make(input, max_nesting_depth) {
  return new _M0TPC14json12ParseContext(0, input, input.end - input.start | 0, max_nesting_depth);
}
function _M0MPC14json12ParseContext19expect__ascii__char(ctx, c) {
  if (ctx.offset < ctx.end_offset) {
    const _p = ctx.input;
    const _p$2 = ctx.offset;
    const c1 = _p.str.charCodeAt(_p.start + _p$2 | 0);
    ctx.offset = ctx.offset + 1 | 0;
    return c !== c1 ? _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1) : new _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(undefined);
  } else {
    return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  }
}
function _M0MPC14json12ParseContext16lex__number__end(ctx, start, end) {
  const s = _M0MPC16string10StringView12view_2einner(ctx.input, start, end);
  if (!_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1120, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1120.length)) && (!_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1121, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1121.length)) && !_M0MPC16string10StringView8contains(s, new _M0TPC16string10StringView(_M0MPC14json12ParseContext16lex__number__endN7_2abindS1122, 0, _M0MPC14json12ParseContext16lex__number__endN7_2abindS1122.length)))) {
    let parsed_int;
    let _try_err;
    _L: {
      _L$2: {
        const _bind = _M0FPC28internal7strconv20parse__int64_2einner(s, 0);
        let _tmp;
        if (_bind.$tag === 1) {
          const _ok = _bind;
          _tmp = _ok._0;
        } else {
          const _err = _bind;
          _try_err = _err._0;
          break _L$2;
        }
        parsed_int = new _M0DTPC16result6ResultGlRPC15error5ErrorE2Ok(_tmp);
        break _L;
      }
      parsed_int = new _M0DTPC16result6ResultGlRPC15error5ErrorE3Err(_try_err);
    }
    _L$2: {
      if (parsed_int.$tag === 1) {
        const _Ok = parsed_int;
        const _i = _Ok._0;
        if (BigInt.asIntN(64, _i) <= BigInt.asIntN(64, 9007199254740991n) && BigInt.asIntN(64, _i) >= BigInt.asIntN(64, 18437736874454810625n)) {
          return { _0: $f64_convert_i64(BigInt.asIntN(64, _i)), _1: undefined };
        } else {
          break _L$2;
        }
      } else {
        break _L$2;
      }
    }
    _L$3: {
      if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
        const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
        if (_x === 45) {
          return { _0: _M0FPC16double13neg__infinity, _1: s };
        } else {
          break _L$3;
        }
      } else {
        break _L$3;
      }
    }
    return { _0: _M0FPC16double8infinity, _1: s };
  } else {
    let parsed_double;
    let _try_err;
    _L: {
      _L$2: {
        const _bind = _M0FPC28internal7strconv13parse__double(s);
        let _tmp;
        if (_bind.$tag === 1) {
          const _ok = _bind;
          _tmp = _ok._0;
        } else {
          const _err = _bind;
          _try_err = _err._0;
          break _L$2;
        }
        parsed_double = new _M0DTPC16result6ResultGdRPC15error5ErrorE2Ok(_tmp);
        break _L;
      }
      parsed_double = new _M0DTPC16result6ResultGdRPC15error5ErrorE3Err(_try_err);
    }
    if (parsed_double.$tag === 1) {
      const _Ok = parsed_double;
      const _d = _Ok._0;
      return { _0: _d, _1: undefined };
    } else {
      _L$2: {
        if (_M0MPC16string6String24char__length__ge_2einner(s.str, 1, s.start, s.end)) {
          const _x = _M0MPC16string6String16unsafe__char__at(s.str, _M0MPC16string6String29offset__of__nth__char_2einner(s.str, 0, s.start, s.end));
          if (_x === 45) {
            return { _0: _M0FPC16double13neg__infinity, _1: s };
          } else {
            break _L$2;
          }
        } else {
          break _L$2;
        }
      }
      return { _0: _M0FPC16double8infinity, _1: s };
    }
  }
}
function _M0MPC14json12ParseContext10read__char(ctx) {
  if (ctx.offset < ctx.end_offset) {
    const _p = ctx.input;
    const _p$2 = ctx.offset;
    const c1 = _p.str.charCodeAt(_p.start + _p$2 | 0);
    ctx.offset = ctx.offset + 1 | 0;
    if (c1 >= 55296 && c1 <= 56319) {
      if (ctx.offset < ctx.end_offset) {
        const _p$3 = ctx.input;
        const _p$4 = ctx.offset;
        const c2 = _p$3.str.charCodeAt(_p$3.start + _p$4 | 0);
        if (c2 >= 56320 && c2 <= 57343) {
          ctx.offset = ctx.offset + 1 | 0;
          const c3 = ((c1 << 10) + c2 | 0) - 56613888 | 0;
          return c3;
        }
      }
    }
    return c1;
  } else {
    return -1;
  }
}
function _M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start) {
  while (true) {
    const _bind = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind === -1) {
      return _M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset);
    } else {
      const _Some = _bind;
      const _c = _Some;
      if (_c >= 48 && _c <= 57) {
        continue;
      }
      ctx.offset = ctx.offset - 1 | 0;
      return _M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset);
    }
  }
}
function _M0MPC14json12ParseContext28lex__decimal__exponent__sign(ctx, start) {
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _c = _Some;
    if (_c >= 48 && _c <= 57) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start));
    }
    ctx.offset = ctx.offset - 1 | 0;
    return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
  }
}
function _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start) {
  _L: {
    const _bind = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind === -1) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
    } else {
      const _Some = _bind;
      const _x = _Some;
      switch (_x) {
        case 43: {
          break _L;
        }
        case 45: {
          break _L;
        }
        default: {
          if (_x >= 48 && _x <= 57) {
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext31lex__decimal__exponent__integer(ctx, start));
          }
          ctx.offset = ctx.offset - 1 | 0;
          return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
        }
      }
    }
  }
  const _bind = _M0MPC14json12ParseContext28lex__decimal__exponent__sign(ctx, start);
  let _tmp;
  if (_bind.$tag === 1) {
    const _ok = _bind;
    _tmp = _ok._0;
  } else {
    return _bind;
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp);
}
function _M0MPC14json12ParseContext22lex__decimal__fraction(ctx, start) {
  let _tmp;
  _L: while (true) {
    _L$2: {
      const _bind = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind === -1) {
        return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
      } else {
        const _Some = _bind;
        const _x = _Some;
        switch (_x) {
          case 101: {
            break _L$2;
          }
          case 69: {
            break _L$2;
          }
          default: {
            if (_x >= 48 && _x <= 57) {
              continue _L;
            }
            ctx.offset = ctx.offset - 1 | 0;
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
          }
        }
      }
    }
    const _bind = _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
    let _tmp$2;
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _tmp$2 = _ok._0;
    } else {
      return _bind;
    }
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$2);
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp);
}
function _M0MPC14json12ParseContext19lex__decimal__point(ctx, start) {
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _c = _Some;
    return _c >= 48 && _c <= 57 ? _M0MPC14json12ParseContext22lex__decimal__fraction(ctx, start) : _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
  }
}
function _M0MPC14json12ParseContext21lex__decimal__integer(ctx, start) {
  let _tmp;
  _L: while (true) {
    _L$2: {
      const _bind = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind === -1) {
        return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
      } else {
        const _Some = _bind;
        const _x = _Some;
        switch (_x) {
          case 46: {
            const _bind$2 = _M0MPC14json12ParseContext19lex__decimal__point(ctx, start);
            let _tmp$2;
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _tmp$2 = _ok._0;
            } else {
              return _bind$2;
            }
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$2);
          }
          case 101: {
            break _L$2;
          }
          case 69: {
            break _L$2;
          }
          default: {
            if (_x >= 48 && _x <= 57) {
              continue _L;
            }
            ctx.offset = ctx.offset - 1 | 0;
            return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
          }
        }
      }
    }
    const _bind = _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
    let _tmp$2;
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _tmp$2 = _ok._0;
    } else {
      return _bind;
    }
    return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp$2);
  }
  return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_tmp);
}
function _M0MPC14json12ParseContext16lex__hex__digits(ctx, n) {
  let _tmp;
  let _tmp$2 = 0;
  let _tmp$3 = 0;
  while (true) {
    const _ = _tmp$2;
    const r = _tmp$3;
    if (_ < n) {
      const _bind = _M0MPC14json12ParseContext10read__char(ctx);
      if (_bind === -1) {
        return new _M0DTPC16result6ResultGiRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
      } else {
        const _Some = _bind;
        const _c = _Some;
        if (_c >= 65) {
          const d = ((_c & ~32) - 65 | 0) + 10 | 0;
          if (d > 15) {
            const _bind$2 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _ok._0;
            } else {
              return _bind$2;
            }
          }
          _tmp$2 = _ + 1 | 0;
          _tmp$3 = r << 4 | d;
          continue;
        } else {
          if (_c >= 48) {
            const d = _c - 48 | 0;
            if (d > 9) {
              const _bind$2 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
              if (_bind$2.$tag === 1) {
                const _ok = _bind$2;
                _ok._0;
              } else {
                return _bind$2;
              }
            }
            _tmp$2 = _ + 1 | 0;
            _tmp$3 = r << 4 | d;
            continue;
          } else {
            const _bind$2 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _ok._0;
            } else {
              return _bind$2;
            }
          }
        }
      }
      _tmp$2 = _ + 1 | 0;
      continue;
    } else {
      _tmp = r;
      break;
    }
  }
  return new _M0DTPC16result6ResultGiRPC14json10ParseErrorE2Ok(_tmp);
}
function _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, end) {
  const ctx = _env._2;
  const start = _env._1;
  const buf = _env._0;
  if (start.val > 0 && end > start.val) {
    _M0IPB13StringBuilderPB6Logger11write__view(buf, _M0MPC16string10StringView11sub_2einner(ctx.input, start.val, end));
    return;
  } else {
    return;
  }
}
function _M0MPC14json12ParseContext11lex__string(ctx) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const start = new _M0TPB8MutLocalGiE(ctx.offset);
  const _env = { _0: buf, _1: start, _2: ctx };
  _L: while (true) {
    _L$2: {
      _L$3: {
        const _bind = _M0MPC14json12ParseContext10read__char(ctx);
        if (_bind === -1) {
          return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
        } else {
          const _Some = _bind;
          const _x = _Some;
          switch (_x) {
            case 34: {
              _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, ctx.offset - 1 | 0);
              break _L;
            }
            case 10: {
              break _L$3;
            }
            case 13: {
              break _L$3;
            }
            case 92: {
              _M0MPC14json12ParseContext11lex__stringN5flushS276(_env, ctx.offset - 1 | 0);
              const _bind$2 = _M0MPC14json12ParseContext10read__char(ctx);
              if (_bind$2 === -1) {
                return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
              } else {
                const _Some$2 = _bind$2;
                const _x$2 = _Some$2;
                switch (_x$2) {
                  case 98: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 8);
                    break;
                  }
                  case 102: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 12);
                    break;
                  }
                  case 110: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 10);
                    break;
                  }
                  case 114: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 13);
                    break;
                  }
                  case 116: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 9);
                    break;
                  }
                  case 34: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
                    break;
                  }
                  case 92: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 92);
                    break;
                  }
                  case 47: {
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, 47);
                    break;
                  }
                  case 117: {
                    const _bind$3 = _M0MPC14json12ParseContext16lex__hex__digits(ctx, 4);
                    let c;
                    if (_bind$3.$tag === 1) {
                      const _ok = _bind$3;
                      c = _ok._0;
                    } else {
                      return _bind$3;
                    }
                    _M0IPB13StringBuilderPB6Logger11write__char(buf, c);
                    break;
                  }
                  default: {
                    const _bind$4 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
                    if (_bind$4.$tag === 1) {
                      const _ok = _bind$4;
                      _ok._0;
                    } else {
                      return _bind$4;
                    }
                  }
                }
              }
              start.val = ctx.offset;
              break;
            }
            default: {
              if (_x < 32) {
                const _bind$3 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _ok._0;
                } else {
                  return _bind$3;
                }
              } else {
                continue _L;
              }
            }
          }
        }
        break _L$2;
      }
      const _bind = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _ok._0;
      } else {
        return _bind;
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGsRPC14json10ParseErrorE2Ok(buf.val);
}
function _M0MPC14json12ParseContext9lex__zero(ctx, start) {
  _L: {
    const _bind = _M0MPC14json12ParseContext10read__char(ctx);
    if (_bind === -1) {
      return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
    } else {
      const _Some = _bind;
      const _x = _Some;
      switch (_x) {
        case 46: {
          return _M0MPC14json12ParseContext19lex__decimal__point(ctx, start);
        }
        case 101: {
          break _L;
        }
        case 69: {
          break _L;
        }
        default: {
          if (_x >= 48 && _x <= 57) {
            ctx.offset = ctx.offset - 1 | 0;
            const _bind$2 = _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, 0);
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _ok._0;
            } else {
              return _bind$2;
            }
          }
          ctx.offset = ctx.offset - 1 | 0;
          return new _M0DTPC16result6ResultGUdORPC16string10StringViewERPC14json10ParseErrorE2Ok(_M0MPC14json12ParseContext16lex__number__end(ctx, start, ctx.offset));
        }
      }
    }
  }
  return _M0MPC14json12ParseContext22lex__decimal__exponent(ctx, start);
}
function _M0MPC14json12ParseContext10lex__value(ctx, allow_rbracket) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    if (_x === 123) {
      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6LBrace__);
    } else {
      if (_x === 91) {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8LBracket__);
      } else {
        if (_x === 93) {
          if (allow_rbracket) {
            return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8RBracket__);
          } else {
            return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
          }
        } else {
          if (_x === 110) {
            const _bind$2 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 117);
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _ok._0;
            } else {
              return _bind$2;
            }
            const _bind$3 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
            if (_bind$3.$tag === 1) {
              const _ok = _bind$3;
              _ok._0;
            } else {
              return _bind$3;
            }
            const _bind$4 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
            if (_bind$4.$tag === 1) {
              const _ok = _bind$4;
              _ok._0;
            } else {
              return _bind$4;
            }
            return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token4Null__);
          } else {
            if (_x === 116) {
              const _bind$2 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 114);
              if (_bind$2.$tag === 1) {
                const _ok = _bind$2;
                _ok._0;
              } else {
                return _bind$2;
              }
              const _bind$3 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 117);
              if (_bind$3.$tag === 1) {
                const _ok = _bind$3;
                _ok._0;
              } else {
                return _bind$3;
              }
              const _bind$4 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 101);
              if (_bind$4.$tag === 1) {
                const _ok = _bind$4;
                _ok._0;
              } else {
                return _bind$4;
              }
              return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token4True__);
            } else {
              if (_x === 102) {
                const _bind$2 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 97);
                if (_bind$2.$tag === 1) {
                  const _ok = _bind$2;
                  _ok._0;
                } else {
                  return _bind$2;
                }
                const _bind$3 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 108);
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _ok._0;
                } else {
                  return _bind$3;
                }
                const _bind$4 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 115);
                if (_bind$4.$tag === 1) {
                  const _ok = _bind$4;
                  _ok._0;
                } else {
                  return _bind$4;
                }
                const _bind$5 = _M0MPC14json12ParseContext19expect__ascii__char(ctx, 101);
                if (_bind$5.$tag === 1) {
                  const _ok = _bind$5;
                  _ok._0;
                } else {
                  return _bind$5;
                }
                return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5False__);
              } else {
                if (_x === 45) {
                  const _bind$2 = _M0MPC14json12ParseContext10read__char(ctx);
                  if (_bind$2 === -1) {
                    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
                  } else {
                    const _Some$2 = _bind$2;
                    const _x$2 = _Some$2;
                    if (_x$2 === 48) {
                      const _bind$3 = _M0MPC14json12ParseContext9lex__zero(ctx, ctx.offset - 2 | 0);
                      let _bind$4;
                      if (_bind$3.$tag === 1) {
                        const _ok = _bind$3;
                        _bind$4 = _ok._0;
                      } else {
                        return _bind$3;
                      }
                      const _n = _bind$4._0;
                      const _repr = _bind$4._1;
                      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                    } else {
                      if (_x$2 >= 49 && _x$2 <= 57) {
                        const _bind$3 = _M0MPC14json12ParseContext21lex__decimal__integer(ctx, ctx.offset - 2 | 0);
                        let _bind$4;
                        if (_bind$3.$tag === 1) {
                          const _ok = _bind$3;
                          _bind$4 = _ok._0;
                        } else {
                          return _bind$3;
                        }
                        const _n = _bind$4._0;
                        const _repr = _bind$4._1;
                        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                      }
                      return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
                    }
                  }
                } else {
                  if (_x === 48) {
                    const _bind$2 = _M0MPC14json12ParseContext9lex__zero(ctx, ctx.offset - 1 | 0);
                    let _bind$3;
                    if (_bind$2.$tag === 1) {
                      const _ok = _bind$2;
                      _bind$3 = _ok._0;
                    } else {
                      return _bind$2;
                    }
                    const _n = _bind$3._0;
                    const _repr = _bind$3._1;
                    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                  } else {
                    if (_x >= 49 && _x <= 57) {
                      const _bind$2 = _M0MPC14json12ParseContext21lex__decimal__integer(ctx, ctx.offset - 1 | 0);
                      let _bind$3;
                      if (_bind$2.$tag === 1) {
                        const _ok = _bind$2;
                        _bind$3 = _ok._0;
                      } else {
                        return _bind$2;
                      }
                      const _n = _bind$3._0;
                      const _repr = _bind$3._1;
                      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6Number(_n, _M0MPC16option6Option3mapGRPC16string10StringViewsE(_repr, (repr) => _M0MPC16string10StringView9to__owned(repr))));
                    } else {
                      if (_x === 34) {
                        const _bind$2 = _M0MPC14json12ParseContext11lex__string(ctx);
                        let s;
                        if (_bind$2.$tag === 1) {
                          const _ok = _bind$2;
                          s = _ok._0;
                        } else {
                          return _bind$2;
                        }
                        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
                      } else {
                        const _p = _x;
                        const shift = -(_p <= 65535 ? 1 : 2) | 0;
                        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, shift);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function _M0MPC14json12ParseContext24lex__after__array__value(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    switch (_x) {
      case 93: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token8RBracket__);
      }
      case 44: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5Comma__);
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext25lex__after__object__value(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    switch (_x) {
      case 125: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6RBrace__);
      }
      case 44: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token5Comma__);
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext26lex__after__property__name(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    if (_x === 58) {
      return new _M0DTPC16result6ResultGuRPC14json10ParseErrorE2Ok(undefined);
    } else {
      return _M0MPC14json12ParseContext21invalid__char_2einnerGuE(ctx, -1);
    }
  }
}
function _M0MPC14json12ParseContext19lex__property__name(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    switch (_x) {
      case 125: {
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(_M0DTPC14json5Token6RBrace__);
      }
      case 34: {
        const _bind$2 = _M0MPC14json12ParseContext11lex__string(ctx);
        let s;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          s = _ok._0;
        } else {
          return _bind$2;
        }
        return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
      }
      default: {
        return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
      }
    }
  }
}
function _M0MPC14json12ParseContext20lex__property__name2(ctx) {
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  const _bind = _M0MPC14json12ParseContext10read__char(ctx);
  if (_bind === -1) {
    return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE3Err(_M0DTPC15error5Error51moonbitlang_2fcore_2fjson_2eParseError_2eInvalidEof__);
  } else {
    const _Some = _bind;
    const _x = _Some;
    if (_x === 34) {
      const _bind$2 = _M0MPC14json12ParseContext11lex__string(ctx);
      let s;
      if (_bind$2.$tag === 1) {
        const _ok = _bind$2;
        s = _ok._0;
      } else {
        return _bind$2;
      }
      return new _M0DTPC16result6ResultGRPC14json5TokenRPC14json10ParseErrorE2Ok(new _M0DTPC14json5Token6String(s));
    } else {
      return _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, -1);
    }
  }
}
function _M0MPC14json12ParseContext12parse__value(ctx) {
  const _bind = _M0MPC14json12ParseContext10lex__value(ctx, false);
  let tok;
  if (_bind.$tag === 1) {
    const _ok = _bind;
    tok = _ok._0;
  } else {
    return _bind;
  }
  return _M0MPC14json12ParseContext13parse__value2(ctx, tok);
}
function _M0MPC14json12ParseContext13parse__value2(ctx, tok) {
  _L: {
    switch (tok.$tag) {
      case 0: {
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_M0FPB4null);
      }
      case 1: {
        const _p = true;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_p ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
      }
      case 2: {
        const _p$2 = false;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_p$2 ? _M0DTPB4Json4True__ : _M0DTPB4Json5False__);
      }
      case 3: {
        const _Number = tok;
        const _n = _Number._0;
        const _repr = _Number._1;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(new _M0DTPB4Json6Number(_n, _repr));
      }
      case 4: {
        const _String = tok;
        const _s = _String._0;
        return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(new _M0DTPB4Json6String(_s));
      }
      case 5: {
        return _M0MPC14json12ParseContext13parse__object(ctx);
      }
      case 7: {
        return _M0MPC14json12ParseContext12parse__array(ctx);
      }
      case 8: {
        break _L;
      }
      case 6: {
        break _L;
      }
      default: {
        break _L;
      }
    }
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_M0FPC15abort5abortGRPC16string10StringViewE("unreachable"));
}
function _M0MPC14json12ParseContext12parse__array(ctx) {
  if (ctx.remaining_available_depth <= 0) {
    return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__);
  }
  ctx.remaining_available_depth = ctx.remaining_available_depth - 1 | 0;
  const vec = [];
  let _tmp;
  const _bind = _M0MPC14json12ParseContext10lex__value(ctx, true);
  let _tmp$2;
  if (_bind.$tag === 1) {
    const _ok = _bind;
    _tmp$2 = _ok._0;
  } else {
    return _bind;
  }
  let _tmp$3 = _tmp$2;
  _L: while (true) {
    const x = _tmp$3;
    if (x.$tag === 8) {
      ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
      _tmp = new _M0DTPB4Json5Array(vec);
      break;
    } else {
      const _bind$2 = _M0MPC14json12ParseContext13parse__value2(ctx, x);
      let _tmp$4;
      if (_bind$2.$tag === 1) {
        const _ok = _bind$2;
        _tmp$4 = _ok._0;
      } else {
        return _bind$2;
      }
      _M0MPC15array5Array4pushGsE(vec, _tmp$4);
      const _bind$3 = _M0MPC14json12ParseContext24lex__after__array__value(ctx);
      let tok2;
      if (_bind$3.$tag === 1) {
        const _ok = _bind$3;
        tok2 = _ok._0;
      } else {
        return _bind$3;
      }
      switch (tok2.$tag) {
        case 9: {
          const _bind$4 = _M0MPC14json12ParseContext10lex__value(ctx, false);
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp$3 = _ok._0;
          } else {
            return _bind$4;
          }
          continue _L;
        }
        case 8: {
          ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
          _tmp = new _M0DTPB4Json5Array(vec);
          break _L;
        }
        default: {
          _M0FPC15abort5abortGuE("unreachable");
        }
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_tmp);
}
function _M0MPC14json12ParseContext13parse__object(ctx) {
  if (ctx.remaining_available_depth <= 0) {
    return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE3Err(_M0DTPC15error5Error59moonbitlang_2fcore_2fjson_2eParseError_2eDepthLimitExceeded__);
  }
  ctx.remaining_available_depth = ctx.remaining_available_depth - 1 | 0;
  const _bind = [];
  const map = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind, 0, 0), undefined);
  let _tmp;
  const _bind$2 = _M0MPC14json12ParseContext19lex__property__name(ctx);
  let _tmp$2;
  if (_bind$2.$tag === 1) {
    const _ok = _bind$2;
    _tmp$2 = _ok._0;
  } else {
    return _bind$2;
  }
  let _tmp$3 = _tmp$2;
  _L: while (true) {
    const x = _tmp$3;
    switch (x.$tag) {
      case 6: {
        ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
        _tmp = new _M0DTPB4Json6Object(map);
        break _L;
      }
      case 4: {
        const _String = x;
        const _name = _String._0;
        const _bind$3 = _M0MPC14json12ParseContext26lex__after__property__name(ctx);
        if (_bind$3.$tag === 1) {
          const _ok = _bind$3;
          _ok._0;
        } else {
          return _bind$3;
        }
        const _bind$4 = _M0MPC14json12ParseContext12parse__value(ctx);
        let _tmp$4;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _tmp$4 = _ok._0;
        } else {
          return _bind$4;
        }
        _M0MPB3Map3setGsRPB4JsonE(map, _name, _tmp$4);
        const _bind$5 = _M0MPC14json12ParseContext25lex__after__object__value(ctx);
        let _bind$6;
        if (_bind$5.$tag === 1) {
          const _ok = _bind$5;
          _bind$6 = _ok._0;
        } else {
          return _bind$5;
        }
        switch (_bind$6.$tag) {
          case 9: {
            const _bind$7 = _M0MPC14json12ParseContext20lex__property__name2(ctx);
            if (_bind$7.$tag === 1) {
              const _ok = _bind$7;
              _tmp$3 = _ok._0;
            } else {
              return _bind$7;
            }
            continue _L;
          }
          case 6: {
            ctx.remaining_available_depth = ctx.remaining_available_depth + 1 | 0;
            _tmp = new _M0DTPB4Json6Object(map);
            break _L;
          }
          default: {
            _M0FPC15abort5abortGuE("unreachable");
          }
        }
        break;
      }
      default: {
        _M0FPC15abort5abortGuE("unreachable");
      }
    }
    continue;
  }
  return new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(_tmp);
}
function _M0FPC14json13parse_2einner(input, max_nesting_depth) {
  const ctx = _M0MPC14json12ParseContext4make(input, max_nesting_depth);
  const _bind = _M0MPC14json12ParseContext12parse__value(ctx);
  let val;
  if (_bind.$tag === 1) {
    const _ok = _bind;
    val = _ok._0;
  } else {
    return _bind;
  }
  _M0MPC14json12ParseContext21lex__skip__whitespace(ctx);
  return ctx.offset >= ctx.end_offset ? new _M0DTPC16result6ResultGRPB4JsonRPC14json10ParseErrorE2Ok(val) : _M0MPC14json12ParseContext21invalid__char_2einnerGRPB4JsonE(ctx, 0);
}
function _M0FPC14json6escape(str, escape_slash) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(str.length);
  const _it = _M0MPC16string6String4iter(str);
  while (true) {
    const _bind = _M0MPB4Iter4nextGcE(_it);
    if (_bind === -1) {
      break;
    } else {
      const _Some = _bind;
      const _c = _Some;
      switch (_c) {
        case 34: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\"");
          break;
        }
        case 92: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\\\");
          break;
        }
        case 47: {
          if (escape_slash) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\/");
          } else {
            _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
          }
          break;
        }
        case 10: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\n");
          break;
        }
        case 13: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\r");
          break;
        }
        case 8: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\b");
          break;
        }
        case 9: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\t");
          break;
        }
        default: {
          const code = _c;
          if (code === 12) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\f");
          } else {
            if (code < 32) {
              _M0IPB13StringBuilderPB6Logger13write__string(buf, "\\u00");
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0MPC14byte4Byte7to__hex(code & 255));
            } else {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, _c);
            }
          }
        }
      }
      continue;
    }
  }
  return buf.val;
}
function _M0FPC14json11indent__str(level, indent) {
  if (indent === 0) {
    return "";
  } else {
    const spaces = Math.imul(indent, level) | 0;
    switch (spaces) {
      case 0: {
        return "\n";
      }
      case 1: {
        return "\n ";
      }
      case 2: {
        return "\n  ";
      }
      case 3: {
        return "\n   ";
      }
      case 4: {
        return "\n    ";
      }
      case 5: {
        return "\n     ";
      }
      case 6: {
        return "\n      ";
      }
      case 7: {
        return "\n       ";
      }
      case 8: {
        return "\n        ";
      }
      default: {
        return `\n${_M0MPC16string6String6repeat(" ", spaces)}`;
      }
    }
  }
}
function _M0MPC14json4Json17stringify_2einner(self, escape_slash, indent, replacer) {
  const buf = _M0MPB13StringBuilder21StringBuilder_2einner(0);
  const stack = [];
  let depth = 0;
  let _tmp = self;
  while (true) {
    const x = _tmp;
    if (x === undefined) {
      if (stack.length === 0) {
        break;
      } else {
        const _x = stack[stack.length - 1 | 0];
        if (_x.$tag === 0) {
          const _Array = _x;
          const _arr = _Array._0;
          const _i = _Array._1;
          if (_i < _arr.length) {
            const element = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(_arr, _i);
            _Array._1 = _i + 1 | 0;
            if (_i > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 44);
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            }
            _tmp = element;
            continue;
          } else {
            depth = depth - 1 | 0;
            _M0MPC15array5Array3popGRPC14json10WriteFrameE(stack);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 93);
            _tmp = undefined;
            continue;
          }
        } else {
          const _Object = _x;
          const _iterator = _Object._0;
          const _first = _Object._1;
          const _bind = _M0MPB4Iter4nextGRP411moonbitlang5async8internal9coroutine9CoroutineE(_iterator);
          if (_bind === undefined) {
            depth = depth - 1 | 0;
            _M0MPC15array5Array3popGRPC14json10WriteFrameE(stack);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 125);
            _tmp = undefined;
            continue;
          } else {
            const _Some = _bind;
            const _x$2 = _Some;
            const _k = _x$2._0;
            const _v = _x$2._1;
            let v2 = _v;
            if (replacer === undefined) {
            } else {
              const _Some$2 = replacer;
              const _replacer = _Some$2;
              const _func = _replacer.f;
              const _bind$2 = _func(_k, _v);
              if (_bind$2 === undefined) {
                _tmp = undefined;
                continue;
              } else {
                const _Some$3 = _bind$2;
                const _v$2 = _Some$3;
                v2 = _v$2;
              }
            }
            if (!_first) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 44);
              _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            }
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json6escape(_k, escape_slash));
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 58);
            if (indent > 0) {
              _M0IPB13StringBuilderPB6Logger11write__char(buf, 32);
            }
            _Object._1 = false;
            _tmp = v2;
            continue;
          }
        }
      }
    } else {
      const _Some = x;
      const _value = _Some;
      switch (_value.$tag) {
        case 6: {
          const _Object = _value;
          const _members = _Object._0;
          if (_members.size === 0) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "{}");
          } else {
            depth = depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 123);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0MPC15array5Array4pushGsE(stack, new _M0DTPC14json10WriteFrame6Object(_M0MPB3Map4iterGssE(_members), true));
          }
          break;
        }
        case 5: {
          const _Array = _value;
          const _arr = _Array._0;
          if (_arr.length === 0) {
            _M0IPB13StringBuilderPB6Logger13write__string(buf, "[]");
          } else {
            depth = depth + 1 | 0;
            _M0IPB13StringBuilderPB6Logger11write__char(buf, 91);
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json11indent__str(depth, indent));
            _M0MPC15array5Array4pushGsE(stack, new _M0DTPC14json10WriteFrame5Array(_arr, 0));
          }
          break;
        }
        case 4: {
          const _String = _value;
          const _s = _String._0;
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
          _M0IPB13StringBuilderPB6Logger13write__string(buf, _M0FPC14json6escape(_s, escape_slash));
          _M0IPB13StringBuilderPB6Logger11write__char(buf, 34);
          break;
        }
        case 3: {
          const _Number = _value;
          const _n = _Number._0;
          const _repr = _Number._1;
          if (_repr === undefined) {
            _M0MPB13StringBuilder13write__objectGdE(buf, _n);
          } else {
            const _Some$2 = _repr;
            const _r = _Some$2;
            _M0IPB13StringBuilderPB6Logger13write__string(buf, _r);
          }
          break;
        }
        case 1: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "true");
          break;
        }
        case 2: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "false");
          break;
        }
        default: {
          _M0IPB13StringBuilderPB6Logger13write__string(buf, "null");
        }
      }
      _tmp = undefined;
      continue;
    }
  }
  return buf.val;
}
function _M0IPC14json8JsonPathPB4Show6outputN11build__pathS184(path, logger) {
  switch (path.$tag) {
    case 0: {
      return;
    }
    case 1: {
      const _Key = path;
      const _parent = _Key._0;
      const _key = _Key._1;
      _M0IPC14json8JsonPathPB4Show6outputN11build__pathS184(_parent, logger);
      logger.method_table.method_3(logger.self, 47);
      if (!_M0MPC16string6String13contains__any(_key, new _M0TPC16string10StringView(_M0IPC14json8JsonPathPB4Show6outputN7_2abindS1456, 0, _M0IPC14json8JsonPathPB4Show6outputN7_2abindS1456.length))) {
        logger.method_table.method_0(logger.self, _key);
        return;
      }
      const _it = _M0MPC16string6String4iter(_key);
      while (true) {
        const _bind = _M0MPB4Iter4nextGcE(_it);
        if (_bind === -1) {
          return;
        } else {
          const _Some = _bind;
          const _ch = _Some;
          switch (_ch) {
            case 126: {
              logger.method_table.method_0(logger.self, "~0");
              break;
            }
            case 47: {
              logger.method_table.method_0(logger.self, "~1");
              break;
            }
            default: {
              logger.method_table.method_3(logger.self, _ch);
            }
          }
          continue;
        }
      }
    }
    default: {
      const _Index = path;
      const _parent$2 = _Index._0;
      const _index = _Index._1;
      _M0IPC14json8JsonPathPB4Show6outputN11build__pathS184(_parent$2, logger);
      logger.method_table.method_3(logger.self, 47);
      _M0MPB6Logger13write__objectGiE(logger, _index);
      return;
    }
  }
}
function _M0IPC14json8JsonPathPB4Show6output(self, logger) {
  _M0IPC14json8JsonPathPB4Show6outputN11build__pathS184(self, logger);
}
function _M0FPC14json18from__json_2einnerGsE(json, path) {
  return _M0IPC16string6StringPC14json8FromJson10from__json(json, path);
}
function _M0FPC14json18from__json_2einnerGbE(json, path) {
  return _M0IPC14bool4BoolPC14json8FromJson10from__json(json, path);
}
function _M0FPC14json18from__json_2einnerGiE(json, path) {
  return _M0IPC13int3IntPC14json8FromJson10from__json(json, path);
}
function _M0FPC14json18from__json_2einnerGRPB5ArrayGsEE(json, path) {
  return _M0IPC15array5ArrayPC14json8FromJson10from__jsonGsE(json, path);
}
function _M0FPC14json18from__json_2einnerGRPB3MapGssEE(json, path) {
  return _M0IPB3MapPC14json8FromJson10from__jsonGsE(json, path);
}
function _M0FPC14json18from__json_2einnerGRPB5ArrayGRPB4JsonEE(json, path) {
  return _M0IPC15array5ArrayPC14json8FromJson10from__jsonGRPB4JsonE(json, path);
}
function _M0FPC14json10from__jsonGsE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGsE(json, path);
}
function _M0FPC14json10from__jsonGbE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGbE(json, path);
}
function _M0FPC14json10from__jsonGiE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGiE(json, path);
}
function _M0FPC14json10from__jsonGRPB5ArrayGsEE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGRPB5ArrayGsEE(json, path);
}
function _M0FPC14json10from__jsonGRPB3MapGssEE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGRPB3MapGssEE(json, path);
}
function _M0FPC14json10from__jsonGRPB5ArrayGRPB4JsonEE(json, path$46$opt) {
  let path;
  if (path$46$opt === undefined) {
    path = _M0DTPC14json8JsonPath4Root__;
  } else {
    const _Some = path$46$opt;
    path = _Some;
  }
  return _M0FPC14json18from__json_2einnerGRPB5ArrayGRPB4JsonEE(json, path);
}
function _M0IPC14bool4BoolPC14json8FromJson10from__json(json, path) {
  switch (json.$tag) {
    case 1: {
      return new _M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE2Ok(true);
    }
    case 2: {
      return new _M0DTPC16result6ResultGbRPC14json15JsonDecodeErrorE2Ok(false);
    }
    default: {
      return _M0FPC14json13decode__errorGbE(path, "Bool::from_json: expected boolean");
    }
  }
}
function _M0IPC13int3IntPC14json8FromJson10from__json(json, path) {
  _L: {
    if (json.$tag === 3) {
      const _Number = json;
      const _n = _Number._0;
      if (_n !== _M0FPC16double8infinity) {
        if (_n !== _M0FPC16double13neg__infinity) {
          if (_n > 2147483647 || _n < -2147483648) {
            const _bind = _M0FPC14json13decode__errorGuE(path, "Int::from_json: overflow");
            if (_bind.$tag === 1) {
              const _ok = _bind;
              _ok._0;
            } else {
              return _bind;
            }
          }
          return new _M0DTPC16result6ResultGiRPC14json15JsonDecodeErrorE2Ok(_M0MPC16double6Double7to__int(_n));
        } else {
          break _L;
        }
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return _M0FPC14json13decode__errorGiE(path, "Int::from_json: expected number");
}
function _M0IPC16string6StringPC14json8FromJson10from__json(json, path) {
  if (json.$tag === 4) {
    const _String = json;
    const _a = _String._0;
    return new _M0DTPC16result6ResultGsRPC14json15JsonDecodeErrorE2Ok(_a);
  } else {
    return _M0FPC14json13decode__errorGsE(path, "String::from_json: expected string");
  }
}
function _M0IPC15array5ArrayPC14json8FromJson10from__jsonGsE(json, path) {
  if (json.$tag === 5) {
    const _Array = json;
    const _a = _Array._0;
    const _bind = new _M0DTPC14json8JsonPath5Index(path, 0);
    if (_bind.$tag === 2) {
      const _Index = _bind;
      let _p;
      _L: {
        let _p$2;
        _L$2: {
          if (_a.length === 0) {
            _p = [];
            break _L;
          }
          const _p$3 = new Array(_a.length);
          const _p$4 = _a.length;
          let _tmp = 0;
          while (true) {
            const _p$5 = _tmp;
            if (_p$5 < _p$4) {
              const _p$6 = _a[_p$5];
              _Index._1 = _p$5;
              const _bind$2 = _M0IPC16string6StringPC14json8FromJson10from__json(_p$6, _Index);
              let _tmp$2;
              if (_bind$2.$tag === 1) {
                const _ok = _bind$2;
                _tmp$2 = _ok._0;
              } else {
                const _err = _bind$2;
                _p$2 = _err._0;
                break _L$2;
              }
              _p$3[_p$5] = _tmp$2;
              _tmp = _p$5 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE2Ok(_p$3);
        }
        return new _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE3Err(_p$2);
      }
      return new _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE2Ok(_p);
    } else {
      return new _M0DTPC16result6ResultGRPB5ArrayGsERPC14json15JsonDecodeErrorE2Ok($panic());
    }
  } else {
    return _M0FPC14json13decode__errorGRPB5ArrayGsEE(path, "Array::from_json: expected array");
  }
}
function _M0IPC15array5ArrayPC14json8FromJson10from__jsonGRPB4JsonE(json, path) {
  if (json.$tag === 5) {
    const _Array = json;
    const _a = _Array._0;
    const _bind = new _M0DTPC14json8JsonPath5Index(path, 0);
    if (_bind.$tag === 2) {
      const _Index = _bind;
      let _p;
      _L: {
        let _p$2;
        _L$2: {
          if (_a.length === 0) {
            _p = [];
            break _L;
          }
          const _p$3 = new Array(_a.length);
          const _p$4 = _a.length;
          let _tmp = 0;
          while (true) {
            const _p$5 = _tmp;
            if (_p$5 < _p$4) {
              const _p$6 = _a[_p$5];
              _Index._1 = _p$5;
              const _bind$2 = new _M0DTPC16result6ResultGRPB4JsonRPC14json15JsonDecodeErrorE2Ok(_p$6);
              let _tmp$2;
              if (_bind$2.$tag === 1) {
                const _ok = _bind$2;
                _tmp$2 = _ok._0;
              } else {
                const _err = _bind$2;
                _p$2 = _err._0;
                break _L$2;
              }
              _p$3[_p$5] = _tmp$2;
              _tmp = _p$5 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          return new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE2Ok(_p$3);
        }
        return new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE3Err(_p$2);
      }
      return new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE2Ok(_p);
    } else {
      return new _M0DTPC16result6ResultGRPB5ArrayGRPB4JsonERPC14json15JsonDecodeErrorE2Ok($panic());
    }
  } else {
    return _M0FPC14json13decode__errorGRPB5ArrayGsEE(path, "Array::from_json: expected array");
  }
}
function _M0IPB3MapPC14json8FromJson10from__jsonGsE(json, path) {
  if (json.$tag === 6) {
    const _Object = json;
    const _obj = _Object._0;
    const _bind = [];
    const res = _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind, 0, 0), undefined);
    const _bind$2 = new _M0DTPC14json8JsonPath3Key(path, "");
    if (_bind$2.$tag === 1) {
      const _Key = _bind$2;
      const _it = _M0MPB3Map5iter2GssE(_obj);
      while (true) {
        const _bind$3 = _M0MPB5Iter24nextGssE(_it);
        if (_bind$3 === undefined) {
          break;
        } else {
          const _Some = _bind$3;
          const _x = _Some;
          const _k = _x._0;
          const _v = _x._1;
          _Key._1 = _k;
          const _bind$4 = _M0IPC16string6StringPC14json8FromJson10from__json(_v, _Key);
          let _tmp;
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp = _ok._0;
          } else {
            return _bind$4;
          }
          _M0MPB3Map3setGssE(res, _k, _tmp);
          continue;
        }
      }
      return new _M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE2Ok(res);
    } else {
      return new _M0DTPC16result6ResultGRPB3MapGssERPC14json15JsonDecodeErrorE2Ok($panic());
    }
  } else {
    return _M0FPC14json13decode__errorGsE(path, "Map::from_json: expected object");
  }
}
function _M0MPC13ref3Ref3RefGRP310Haoxincode8moonbash7website8AppStateE(x) {
  return new _M0TPC13ref3RefGRP310Haoxincode8moonbash7website8AppStateE(x);
}
function _M0FPC15deque10new__dequeGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity) {
  return new _M0TPC15deque5DequeGRP411moonbitlang5async8internal9coroutine9CoroutineE(new Array(capacity), 0, 0);
}
function _M0MPC15deque5Deque9as__viewsGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  if (self.len !== 0) {
    const _buf = self.buf;
    const _head = self.head;
    const _len = self.len;
    const cap = _buf.length;
    const head_len = cap - _head | 0;
    if (head_len >= _len) {
      const _tmp = _M0MPB18UninitializedArray11sub_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(_buf, _head, _head + _len | 0);
      const _bind = [];
      return { _0: _tmp, _1: new _M0TPB9ArrayViewGRP411moonbitlang5async8internal9coroutine9CoroutineE(_bind, 0, 0) };
    } else {
      return { _0: _M0MPB18UninitializedArray11sub_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(_buf, _head, cap), _1: _M0MPB18UninitializedArray11sub_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(_buf, 0, _len - head_len | 0) };
    }
  } else {
    const _bind = [];
    const _tmp = new _M0TPB9ArrayViewGRP411moonbitlang5async8internal9coroutine9CoroutineE(_bind, 0, 0);
    const _bind$2 = [];
    return { _0: _tmp, _1: new _M0TPB9ArrayViewGRP411moonbitlang5async8internal9coroutine9CoroutineE(_bind$2, 0, 0) };
  }
}
function _M0MPC15deque5Deque16unsafe__blit__toGRP411moonbitlang5async8internal9coroutine9CoroutineE(self, dst, dst_offset) {
  if (self.len !== 0) {
    const _bind = _M0MPC15deque5Deque9as__viewsGRP411moonbitlang5async8internal9coroutine9CoroutineE(self);
    const _front = _bind._0;
    const _back = _bind._1;
    _M0MPB18UninitializedArray12unsafe__blitGRP411moonbitlang5async8internal9coroutine9CoroutineE(dst, dst_offset, self.buf, _front.start, _front.end - _front.start | 0);
    _M0MPB18UninitializedArray12unsafe__blitGRP411moonbitlang5async8internal9coroutine9CoroutineE(dst, dst_offset + (_front.end - _front.start | 0) | 0, self.buf, _back.start, _back.end - _back.start | 0);
    return;
  } else {
    return;
  }
}
function _M0MPC15deque5Deque7reallocGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  const _p = self.buf;
  const old_cap = _p.length;
  const new_cap = old_cap === 0 ? 8 : Math.imul(old_cap, 2) | 0;
  const new_buf = new Array(new_cap);
  _M0MPC15deque5Deque16unsafe__blit__toGRP411moonbitlang5async8internal9coroutine9CoroutineE(self, new_buf, 0);
  self.head = 0;
  self.buf = new_buf;
}
function _M0MPC15deque5Deque10push__backGRP411moonbitlang5async8internal9coroutine9CoroutineE(self, value) {
  const _tmp = self.len;
  const _p = self.buf;
  if (_tmp === _p.length) {
    _M0MPC15deque5Deque7reallocGRP411moonbitlang5async8internal9coroutine9CoroutineE(self);
  }
  const _p$2 = self.buf;
  const cap = _p$2.length;
  const write_idx = (self.head + self.len | 0) % cap | 0;
  const _tmp$2 = self.buf;
  $bound_check(_tmp$2, write_idx);
  _tmp$2[write_idx] = value;
  self.len = self.len + 1 | 0;
}
function _M0MPC15deque5Deque10pop__frontGRP411moonbitlang5async8internal9coroutine9CoroutineE(self) {
  if (self.len > 0) {
    const _tmp = self.buf;
    const _tmp$2 = self.head;
    $bound_check(_tmp, _tmp$2);
    const value = _tmp[_tmp$2];
    const _tmp$3 = self.buf;
    const _tmp$4 = self.head;
    $bound_check(_tmp$3, _tmp$4);
    _tmp$3[_tmp$4] = null;
    const _p = self.buf;
    const cap = _p.length;
    self.head = (self.head + 1 | 0) % cap | 0;
    self.len = self.len - 1 | 0;
    return value;
  } else {
    return undefined;
  }
}
function _M0MPC15deque5Deque11new_2einnerGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity) {
  return _M0FPC15deque10new__dequeGRP411moonbitlang5async8internal9coroutine9CoroutineE(capacity);
}
function _M0FP411moonbitlang5async8internal9coroutine18current__coroutine() {
  const _p = _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro;
  if (_p === undefined) {
    return $panic();
  } else {
    const _p$2 = _p;
    return _p$2;
  }
}
function _M0FP411moonbitlang5async8internal9coroutine29has__immediately__ready__task() {
  const _p = _M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later;
  return !(_p.len === 0);
}
function _M0FP411moonbitlang5async8internal9coroutine14no__more__work() {
  if (_M0FP411moonbitlang5async8internal9coroutine9scheduler.blocking === 0) {
    const _p = _M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later;
    return _p.len === 0;
  } else {
    return false;
  }
}
function _M0FP411moonbitlang5async8internal9coroutine10reschedule() {
  const _p = _M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later;
  const n = _p.len;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < n) {
      const _bind = _M0MPC15deque5Deque10pop__frontGRP411moonbitlang5async8internal9coroutine9CoroutineE(_M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later);
      if (_bind === undefined) {
        return;
      } else {
        const _Some = _bind;
        const _coro = _Some;
        _coro.ready = false;
        const _bind$2 = _coro.state;
        if (_bind$2.$tag === 3) {
          const _Suspend = _bind$2;
          const _ok_cont = _Suspend._0;
          const _err_cont = _Suspend._1;
          _coro.state = _M0DTP411moonbitlang5async8internal9coroutine5State7Running__;
          const last_coro = _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro;
          _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro = _coro;
          if (_coro.cancelled && !_coro.shielded) {
            _err_cont(_M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled__);
          } else {
            _ok_cont(undefined);
          }
          _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro = last_coro;
        }
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      return;
    }
  }
}
function _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(self) {
  if (!self.ready) {
    self.ready = true;
    _M0MPC15deque5Deque10push__backGRP411moonbitlang5async8internal9coroutine9CoroutineE(_M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later, self);
    return;
  } else {
    return;
  }
}
function _M0FP411moonbitlang5async8internal9coroutine20is__being__cancelled() {
  const coro = _M0FP411moonbitlang5async8internal9coroutine18current__coroutine();
  return coro.cancelled && !coro.shielded;
}
function _M0MP411moonbitlang5async8internal9coroutine9Coroutine6cancel(self) {
  self.cancelled = true;
  if (!self.shielded) {
    _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(self);
    return;
  } else {
    return;
  }
}
function _M0FP411moonbitlang5async8internal9coroutine7suspendN16_2aasync__driverS161(_state) {
  if (_state.$tag === 0) {
    const _$42$defer_try$47$66 = _state;
    const _defer = _$42$defer_try$47$66._1;
    const _err = _$42$defer_try$47$66._0;
    _defer();
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE3Err(_err);
  } else {
    const _State_1 = _state;
    const _defer = _State_1._1;
    const _cont_param = _State_1._0;
    _defer();
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(_cont_param);
  }
}
function _M0FP411moonbitlang5async8internal9coroutine7suspendN8_2adeferS65() {
  _M0FP411moonbitlang5async8internal9coroutine9scheduler.blocking = _M0FP411moonbitlang5async8internal9coroutine9scheduler.blocking - 1 | 0;
}
function _M0FP411moonbitlang5async8internal9coroutine7suspend(_cont, _err_cont) {
  const _bind = _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro;
  if (_bind === undefined) {
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok($panic());
  } else {
    const _Some = _bind;
    const _coro = _Some;
    if (_coro.cancelled && !_coro.shielded) {
      return new _M0DTPC16result6ResultGOuRPC15error5ErrorE3Err(_M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled__);
    }
    _M0FP411moonbitlang5async8internal9coroutine9scheduler.blocking = _M0FP411moonbitlang5async8internal9coroutine9scheduler.blocking + 1 | 0;
    const ok_cont = (_cont_param) => {
      let _err;
      _L: {
        const _bind$2 = _M0FP411moonbitlang5async8internal9coroutine7suspendN16_2aasync__driverS161(new _M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State8State__1(_cont_param, _M0FP411moonbitlang5async8internal9coroutine7suspendN8_2adeferS65));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$2 = _bind$2;
          _err = _err$2._0;
          break _L;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some$2 = _bind$3;
          const _payload = _Some$2;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err);
    };
    const err_cont = (_cont_param) => {
      let _err;
      _L: {
        const _bind$2 = _M0FP411moonbitlang5async8internal9coroutine7suspendN16_2aasync__driverS161(new _M0DTP411moonbitlang5async8internal9coroutine55_24moonbitlang_2fasync_2finternal_2fcoroutine_2esuspendL5State18_2adefer__try_2f66(_cont_param, _M0FP411moonbitlang5async8internal9coroutine7suspendN8_2adeferS65));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$2 = _bind$2;
          _err = _err$2._0;
          break _L;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some$2 = _bind$3;
          const _payload = _Some$2;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err);
    };
    const _bind$2 = _coro.state;
    if (_bind$2.$tag === 2) {
      _coro.state = new _M0DTP411moonbitlang5async8internal9coroutine5State7Suspend(ok_cont, err_cont);
    } else {
      $panic();
    }
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
  }
}
function _M0FP411moonbitlang5async8internal9coroutine5spawnN7_2acontS185(_param) {}
function _M0FP411moonbitlang5async8internal9coroutine5spawnN16_2aasync__driverS186(_state) {
  let _tmp = _state;
  _L: while (true) {
    const _state$2 = _tmp;
    switch (_state$2.$tag) {
      case 0: {
        const _State_0 = _state$2;
        const coro = _State_0._1;
        const _it = _M0MPC13set3Set4iterGRP411moonbitlang5async8internal9coroutine9CoroutineE(coro.downstream);
        while (true) {
          const _bind = _M0MPB4Iter4nextGRP411moonbitlang5async8internal9coroutine9CoroutineE(_it);
          if (_bind === undefined) {
            break;
          } else {
            const _Some = _bind;
            const _coro = _Some;
            _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(_coro);
            continue;
          }
        }
        return _M0MPC13set3Set5clearGRP411moonbitlang5async8internal9coroutine9CoroutineE(coro.downstream);
      }
      case 1: {
        const _$42$try$47$78 = _state$2;
        const coro$2 = _$42$try$47$78._1;
        const _try_err = _$42$try$47$78._0;
        coro$2.state = new _M0DTP411moonbitlang5async8internal9coroutine5State4Fail(_try_err);
        _tmp = new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__0(undefined, coro$2);
        continue _L;
      }
      default: {
        const _State_2 = _state$2;
        const coro$3 = _State_2._1;
        coro$3.state = _M0DTP411moonbitlang5async8internal9coroutine5State4Done__;
        _tmp = new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__0(undefined, coro$3);
        continue _L;
      }
    }
  }
}
function _M0FP411moonbitlang5async8internal9coroutine5spawn(f) {
  _M0FP411moonbitlang5async8internal9coroutine9scheduler.coro_id = _M0FP411moonbitlang5async8internal9coroutine9scheduler.coro_id + 1 | 0;
  const _bind = _M0DTP411moonbitlang5async8internal9coroutine5State7Running__;
  const _bind$2 = _M0MPC13set3Set3newGRP411moonbitlang5async8internal9coroutine9CoroutineE(undefined);
  const _bind$3 = _M0FP411moonbitlang5async8internal9coroutine9scheduler.coro_id;
  const coro = new _M0TP411moonbitlang5async8internal9coroutine9Coroutine(_bind$3, _bind, true, false, true, _bind$2);
  const run = (_discard_) => {
    coro.shielded = false;
    let _err;
    _L: {
      _L$2: {
        const _bind$4 = f((_cont_param) => {
          const _bind$5 = _M0FP411moonbitlang5async8internal9coroutine5spawnN16_2aasync__driverS186(new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__2(_cont_param, coro));
          if (_bind$5 === -1) {
            return;
          } else {
            const _Some = _bind$5;
            const _payload = _Some;
            _M0FP411moonbitlang5async8internal9coroutine5spawnN7_2acontS185(_payload);
            return;
          }
        }, (_cont_param) => {
          const _bind$5 = _M0FP411moonbitlang5async8internal9coroutine5spawnN16_2aasync__driverS186(new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State11_2atry_2f78(_cont_param, coro));
          if (_bind$5 === -1) {
            return;
          } else {
            const _Some = _bind$5;
            const _payload = _Some;
            _M0FP411moonbitlang5async8internal9coroutine5spawnN7_2acontS185(_payload);
            return;
          }
        });
        let _bind$5;
        if (_bind$4.$tag === 1) {
          const _ok = _bind$4;
          _bind$5 = _ok._0;
        } else {
          const _err$2 = _bind$4;
          _err = _err$2._0;
          break _L$2;
        }
        if (_bind$5 === -1) {
        } else {
          const _Some = _bind$5;
          const _payload = _Some;
          _M0FP411moonbitlang5async8internal9coroutine5spawnN16_2aasync__driverS186(new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State8State__2(_payload, coro));
        }
        break _L;
      }
      _M0FP411moonbitlang5async8internal9coroutine5spawnN16_2aasync__driverS186(new _M0DTP411moonbitlang5async8internal9coroutine79_24moonbitlang_2fasync_2finternal_2fcoroutine_2espawn_2erun_2f17_2elambda_2f184L5State11_2atry_2f78(_err, coro));
    }
  };
  coro.state = new _M0DTP411moonbitlang5async8internal9coroutine5State7Suspend(run, (_discard_) => {
  });
  _M0MPC15deque5Deque10push__backGRP411moonbitlang5async8internal9coroutine9CoroutineE(_M0FP411moonbitlang5async8internal9coroutine9scheduler.run_later, coro);
  return coro;
}
function _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerN16_2aasync__driverS235GuE(_state) {
  let _tmp = _state;
  while (true) {
    const _state$2 = _tmp;
    if (_state$2.$tag === 0) {
      const _$42$defer_try$47$138 = _state$2;
      const _defer = _$42$defer_try$47$138._1;
      const _err = _$42$defer_try$47$138._0;
      _defer();
      return new _M0DTPC16result6ResultGOuRPC15error5ErrorE3Err(_err);
    } else {
      const _State_1 = _state$2;
      const _defer = _State_1._3;
      const coro = _State_1._2;
      const resume_on_cancel = _State_1._1;
      const _cont_param = _State_1._0;
      if (!resume_on_cancel && coro.cancelled) {
        _tmp = new _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE19_2adefer__try_2f138(_M0DTPC15error5Error66moonbitlang_2fasync_2finternal_2fcoroutine_2eCancelled_2eCancelled__, _defer);
        continue;
      }
      _defer();
      return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(_cont_param);
    }
  }
}
function _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerGuE(f, resume_on_cancel, _cont, _err_cont) {
  const _bind = _M0FP411moonbitlang5async8internal9coroutine9scheduler.curr_coro;
  if (_bind === undefined) {
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok($panic());
  } else {
    const _Some = _bind;
    const _coro = _Some;
    if (_coro.shielded) {
      return f(_cont, _err_cont);
    } else {
      _coro.shielded = true;
      const _defer = () => {
        _coro.shielded = false;
      };
      let _err;
      _L: {
        const _bind$2 = f((_cont_param) => {
          let _err$2;
          _L$2: {
            const _bind$3 = _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerN16_2aasync__driverS235GuE(new _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE8State__1(_cont_param, resume_on_cancel, _coro, _defer));
            let _bind$4;
            if (_bind$3.$tag === 1) {
              const _ok = _bind$3;
              _bind$4 = _ok._0;
            } else {
              const _err$3 = _bind$3;
              _err$2 = _err$3._0;
              break _L$2;
            }
            if (_bind$4 === -1) {
              return;
            } else {
              const _Some$2 = _bind$4;
              const _payload = _Some$2;
              _cont(_payload);
              return;
            }
          }
          _err_cont(_err$2);
        }, (_cont_param) => {
          let _err$2;
          _L$2: {
            const _bind$3 = _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerN16_2aasync__driverS235GuE(new _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE19_2adefer__try_2f138(_cont_param, _defer));
            let _bind$4;
            if (_bind$3.$tag === 1) {
              const _ok = _bind$3;
              _bind$4 = _ok._0;
            } else {
              const _err$3 = _bind$3;
              _err$2 = _err$3._0;
              break _L$2;
            }
            if (_bind$4 === -1) {
              return;
            } else {
              const _Some$2 = _bind$4;
              const _payload = _Some$2;
              _cont(_payload);
              return;
            }
          }
          _err_cont(_err$2);
        });
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$2 = _bind$2;
          _err = _err$2._0;
          break _L;
        }
        if (_bind$3 === -1) {
          return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
        } else {
          const _Some$2 = _bind$3;
          const _payload = _Some$2;
          return _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerN16_2aasync__driverS235GuE(new _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE8State__1(_payload, resume_on_cancel, _coro, _defer));
        }
      }
      return _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerN16_2aasync__driverS235GuE(new _M0DTP411moonbitlang5async8internal9coroutine77_24moonbitlang_2fasync_2finternal_2fcoroutine_2eprotect__from__cancel_2einnerL5StateGuE19_2adefer__try_2f138(_err, _defer));
    }
  }
}
function _M0FP411moonbitlang5async8internal11event__loop10reschedule() {
  if (!_M0FP411moonbitlang5async8internal9coroutine14no__more__work()) {
    _M0FP411moonbitlang5async8internal9coroutine10reschedule();
    if (_M0FP411moonbitlang5async8internal9coroutine29has__immediately__ready__task()) {
      _M0FP411moonbitlang5async8internal11event__loop12set__timeout(0, _M0FP411moonbitlang5async8internal11event__loop10reschedule);
      return;
    } else {
      return;
    }
  } else {
    return;
  }
}
function _M0MP411moonbitlang5async8internal11event__loop5Timer3new(duration, f) {
  return _M0FP411moonbitlang5async8internal11event__loop12set__timeout(duration, () => {
    f();
    _M0FP411moonbitlang5async8internal11event__loop10reschedule();
  });
}
function _M0FP211moonbitlang5async5sleepN16_2aasync__driverS555(_state) {
  if (_state.$tag === 0) {
    const _$42$defer_try$47$160 = _state;
    const _defer = _$42$defer_try$47$160._1;
    const _err = _$42$defer_try$47$160._0;
    _defer();
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE3Err(_err);
  } else {
    const _State_1 = _state;
    const _defer = _State_1._1;
    const _cont_param = _State_1._0;
    _defer();
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(_cont_param);
  }
}
function _M0FP211moonbitlang5async5sleep(duration, _cont, _err_cont) {
  const coro = _M0FP411moonbitlang5async8internal9coroutine18current__coroutine();
  const timer = _M0MP411moonbitlang5async8internal11event__loop5Timer3new(duration, () => {
    _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(coro);
  });
  const _defer = () => {
    _M0MP411moonbitlang5async8internal11event__loop5Timer6cancel(timer);
  };
  let _err;
  _L: {
    const _bind = _M0FP411moonbitlang5async8internal9coroutine7suspend((_cont_param) => {
      let _err$2;
      _L$2: {
        const _bind$2 = _M0FP211moonbitlang5async5sleepN16_2aasync__driverS555(new _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State8State__1(_cont_param, _defer));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$3 = _bind$2;
          _err$2 = _err$3._0;
          break _L$2;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some = _bind$3;
          const _payload = _Some;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err$2);
    }, (_cont_param) => {
      let _err$2;
      _L$2: {
        const _bind$2 = _M0FP211moonbitlang5async5sleepN16_2aasync__driverS555(new _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State19_2adefer__try_2f160(_cont_param, _defer));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$3 = _bind$2;
          _err$2 = _err$3._0;
          break _L$2;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some = _bind$3;
          const _payload = _Some;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err$2);
    });
    let _bind$2;
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _bind$2 = _ok._0;
    } else {
      const _err$2 = _bind;
      _err = _err$2._0;
      break _L;
    }
    if (_bind$2 === -1) {
      return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
    } else {
      const _Some = _bind$2;
      const _payload = _Some;
      return _M0FP211moonbitlang5async5sleepN16_2aasync__driverS555(new _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State8State__1(_payload, _defer));
    }
  }
  return _M0FP211moonbitlang5async5sleepN16_2aasync__driverS555(new _M0DTP211moonbitlang5async30_24moonbitlang_2fasync_2esleepL5State19_2adefer__try_2f160(_err, _defer));
}
function _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(_state) {
  let _tmp = _state;
  _L: while (true) {
    const _state$2 = _tmp;
    switch (_state$2.$tag) {
      case 0: {
        const _$42$defer_try$47$83 = _state$2;
        const _defer = _$42$defer_try$47$83._1;
        const _err = _$42$defer_try$47$83._0;
        _defer();
        return new _M0DTPC16result6ResultGOsRPC15error5ErrorE3Err(_err);
      }
      case 1: {
        const _State_1 = _state$2;
        const _defer$2 = _State_1._2;
        const waiter = _State_1._1;
        const _bind = waiter.err;
        let _defer_result;
        if (_bind === undefined) {
          const _p = waiter.ret;
          if (_p === undefined) {
            _defer_result = $panic();
          } else {
            const _p$2 = _p;
            _defer_result = _p$2;
          }
        } else {
          const _Some = _bind;
          const _err$2 = _Some;
          _tmp = new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83(_err$2, _defer$2);
          continue _L;
        }
        _defer$2();
        return new _M0DTPC16result6ResultGOsRPC15error5ErrorE2Ok(_defer_result);
      }
      default: {
        const _$42$try$47$84 = _state$2;
        const _defer$3 = _$42$try$47$84._2;
        const controller = _$42$try$47$84._1;
        const _try_err = _$42$try$47$84._0;
        _M0MP311moonbitlang5async9js__async15AbortController5abort(controller);
        _tmp = new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83(_try_err, _defer$3);
        continue _L;
      }
    }
  }
}
function _M0MP311moonbitlang5async9js__async7Promise4waitGsE(promise, abort_controller, _cont, _err_cont) {
  const waiter = new _M0TP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL6WaiterGsE(_M0FP411moonbitlang5async8internal9coroutine18current__coroutine(), undefined, undefined);
  const resolve = (value) => {
    waiter.ret = value;
    const _bind = waiter.coro;
    if (_bind === undefined) {
      return;
    } else {
      const _Some = _bind;
      const _coro = _Some;
      _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(_coro);
      _M0FP411moonbitlang5async8internal11event__loop10reschedule();
      return;
    }
  };
  const reject = (err) => {
    waiter.err = new _M0DTPC15error5Error51moonbitlang_2fasync_2fjs__async_2eJsError_2eJsError(err);
    const _bind = waiter.coro;
    if (_bind === undefined) {
      return;
    } else {
      const _Some = _bind;
      const _coro = _Some;
      _M0MP411moonbitlang5async8internal9coroutine9Coroutine4wake(_coro);
      _M0FP411moonbitlang5async8internal11event__loop10reschedule();
      return;
    }
  };
  _M0MP311moonbitlang5async9js__async7JsValue4then(promise, resolve, reject);
  const _defer = () => {
    waiter.coro = undefined;
  };
  if (abort_controller.$tag === 1) {
    const _Some = abort_controller;
    const _controller = _Some._0;
    let _err;
    _L: {
      const _bind = _M0FP411moonbitlang5async8internal9coroutine7suspend((_cont_param) => {
        let _err$2;
        _L$2: {
          const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1(_cont_param, waiter, _defer));
          let _bind$3;
          if (_bind$2.$tag === 1) {
            const _ok = _bind$2;
            _bind$3 = _ok._0;
          } else {
            const _err$3 = _bind$2;
            _err$2 = _err$3._0;
            break _L$2;
          }
          if (_bind$3 === undefined) {
            return;
          } else {
            const _Some$2 = _bind$3;
            const _payload = _Some$2;
            _cont(_payload);
            return;
          }
        }
        _err_cont(_err$2);
      }, (_cont_param) => {
        let _err$2;
        _L$2: {
          const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE11_2atry_2f84(_cont_param, _controller, _defer));
          let _bind$3;
          if (_bind$2.$tag === 1) {
            const _ok = _bind$2;
            _bind$3 = _ok._0;
          } else {
            const _err$3 = _bind$2;
            _err$2 = _err$3._0;
            break _L$2;
          }
          if (_bind$3 === undefined) {
            return;
          } else {
            const _Some$2 = _bind$3;
            const _payload = _Some$2;
            _cont(_payload);
            return;
          }
        }
        _err_cont(_err$2);
      });
      let _bind$2;
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _bind$2 = _ok._0;
      } else {
        const _err$2 = _bind;
        _err = _err$2._0;
        break _L;
      }
      if (_bind$2 === -1) {
        return new _M0DTPC16result6ResultGOsRPC15error5ErrorE2Ok(undefined);
      } else {
        const _Some$2 = _bind$2;
        const _payload = _Some$2;
        return _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1(_payload, waiter, _defer));
      }
    }
    return _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE11_2atry_2f84(_err, _controller, _defer));
  } else {
    let _err;
    _L: {
      const _bind = _M0FP411moonbitlang5async8internal9coroutine29protect__from__cancel_2einnerGuE(_M0FP411moonbitlang5async8internal9coroutine7suspend, false, (_cont_param) => {
        let _err$2;
        _L$2: {
          const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1(_cont_param, waiter, _defer));
          let _bind$3;
          if (_bind$2.$tag === 1) {
            const _ok = _bind$2;
            _bind$3 = _ok._0;
          } else {
            const _err$3 = _bind$2;
            _err$2 = _err$3._0;
            break _L$2;
          }
          if (_bind$3 === undefined) {
            return;
          } else {
            const _Some = _bind$3;
            const _payload = _Some;
            _cont(_payload);
            return;
          }
        }
        _err_cont(_err$2);
      }, (_cont_param) => {
        let _err$2;
        _L$2: {
          const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83(_cont_param, _defer));
          let _bind$3;
          if (_bind$2.$tag === 1) {
            const _ok = _bind$2;
            _bind$3 = _ok._0;
          } else {
            const _err$3 = _bind$2;
            _err$2 = _err$3._0;
            break _L$2;
          }
          if (_bind$3 === undefined) {
            return;
          } else {
            const _Some = _bind$3;
            const _payload = _Some;
            _cont(_payload);
            return;
          }
        }
        _err_cont(_err$2);
      });
      let _bind$2;
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _bind$2 = _ok._0;
      } else {
        const _err$2 = _bind;
        _err = _err$2._0;
        break _L;
      }
      if (_bind$2 === -1) {
        return new _M0DTPC16result6ResultGOsRPC15error5ErrorE2Ok(undefined);
      } else {
        const _Some = _bind$2;
        const _payload = _Some;
        return _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE8State__1(_payload, waiter, _defer));
      }
    }
    return _M0MP311moonbitlang5async9js__async7Promise4waitN16_2aasync__driverS151GsE(new _M0DTP311moonbitlang5async9js__async54_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3awaitL5StateGsE18_2adefer__try_2f83(_err, _defer));
  }
}
function _M0MP311moonbitlang5async9js__async7Promise11from__asyncN16_2aasync__driverS286GuE(_state) {
  if (_state.$tag === 0) {
    const _$42$try$47$130 = _state;
    const reject = _$42$try$47$130._1;
    const _try_err = _$42$try$47$130._0;
    let err;
    _L: {
      if (_try_err.$tag === 2) {
        if (_M0FP411moonbitlang5async8internal9coroutine20is__being__cancelled()) {
          return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(reject(_M0MP311moonbitlang5async9js__async7JsValue12abort__error()));
        } else {
          err = _try_err;
          break _L;
        }
      } else {
        err = _try_err;
        break _L;
      }
    }
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(reject(_M0IPC15error5ErrorPB4Show10to__string(err)));
  } else {
    const _State_1 = _state;
    const resolve = _State_1._1;
    const _cont_param = _State_1._0;
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(resolve(_cont_param));
  }
}
function _M0MP311moonbitlang5async9js__async7Promise11from__asyncGuE(f, abort_signal) {
  const promise = _M0MP311moonbitlang5async9js__async7JsValue12new__promise((resolve, reject) => {
    const coro = _M0FP411moonbitlang5async8internal9coroutine5spawn((_cont, _err_cont) => {
      let _err;
      _L: {
        const _bind = f((_cont_param) => {
          let _err$2;
          _L$2: {
            const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise11from__asyncN16_2aasync__driverS286GuE(new _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE8State__1(_cont_param, resolve));
            let _bind$3;
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _bind$3 = _ok._0;
            } else {
              const _err$3 = _bind$2;
              _err$2 = _err$3._0;
              break _L$2;
            }
            if (_bind$3 === -1) {
              return;
            } else {
              const _Some = _bind$3;
              const _payload = _Some;
              _cont(_payload);
              return;
            }
          }
          _err_cont(_err$2);
        }, (_cont_param) => {
          let _err$2;
          _L$2: {
            const _bind$2 = _M0MP311moonbitlang5async9js__async7Promise11from__asyncN16_2aasync__driverS286GuE(new _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE12_2atry_2f130(_cont_param, reject));
            let _bind$3;
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _bind$3 = _ok._0;
            } else {
              const _err$3 = _bind$2;
              _err$2 = _err$3._0;
              break _L$2;
            }
            if (_bind$3 === -1) {
              return;
            } else {
              const _Some = _bind$3;
              const _payload = _Some;
              _cont(_payload);
              return;
            }
          }
          _err_cont(_err$2);
        });
        let _bind$2;
        if (_bind.$tag === 1) {
          const _ok = _bind;
          _bind$2 = _ok._0;
        } else {
          const _err$2 = _bind;
          _err = _err$2._0;
          break _L;
        }
        if (_bind$2 === -1) {
          return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
        } else {
          const _Some = _bind$2;
          const _payload = _Some;
          return _M0MP311moonbitlang5async9js__async7Promise11from__asyncN16_2aasync__driverS286GuE(new _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE8State__1(_payload, resolve));
        }
      }
      return _M0MP311moonbitlang5async9js__async7Promise11from__asyncN16_2aasync__driverS286GuE(new _M0DTP311moonbitlang5async9js__async85_40moonbitlang_2fasync_2fjs__async_2ePromise_3a_3afrom__async_2elambda_2elambda_2f283L5StateGuE12_2atry_2f130(_err, reject));
    });
    if (abort_signal.$tag === 1) {
      const _Some = abort_signal;
      const _signal = _Some._0;
      _M0MP311moonbitlang5async9js__async11AbortSignal9on__abort(_signal, () => {
        _M0MP411moonbitlang5async8internal9coroutine9Coroutine6cancel(coro);
      });
      return;
    } else {
      return;
    }
  });
  _M0FP411moonbitlang5async8internal9coroutine10reschedule();
  return promise;
}
function _M0IP311moonbitlang5async9js__async7JsErrorPB4Show6output(self, logger) {
  const _JsError = self;
  const _value = _JsError._0;
  logger.method_table.method_0(logger.self, _M0MP311moonbitlang5async9js__async7JsValue10to__string(_value));
}
function _M0MP24tiye9dom_2dffi12LocalStorage9get__item(self, key) {
  const item = _M0MP24tiye9dom_2dffi12LocalStorage13js__get__item(self, key);
  return _M0MP24tiye9dom_2dffi9JsObscure7is__nil(item) ? undefined : item;
}
function _M0MP24tiye9dom_2dffi8Document20get__element__by__id(self, id) {
  const e = _M0FP24tiye9dom_2dffi24js__get__element__by__id(self, id);
  return _M0MP24tiye9dom_2dffi9JsObscure7is__nil(e) ? _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4None__ : new _M0DTPC16option6OptionGRP24tiye9dom_2dffi7ElementE4Some(e);
}
function _M0FP24tiye9dom_2dffi30document__get__element__by__id(id) {
  return _M0MP24tiye9dom_2dffi8Document20get__element__by__id(_M0MP24tiye9dom_2dffi6Window8document(_M0FP24tiye9dom_2dffi6window()), id);
}
function _M0FP310Haoxincode8moonbash7website6append(parent, child) {
  _M0MP24tiye9dom_2dffi7Element13append__child(parent, _M0MP24tiye9dom_2dffi7Element21reinterpret__as__node(child));
}
function _M0FP310Haoxincode8moonbash7website13dom__document() {
  return _M0MP24tiye9dom_2dffi6Window8document(_M0FP24tiye9dom_2dffi6window());
}
function _M0FP310Haoxincode8moonbash7website23create__element_2einner(tag, class_name, text) {
  const element = _M0MP24tiye9dom_2dffi8Document15create__element(_M0FP310Haoxincode8moonbash7website13dom__document(), tag);
  const _p = "";
  if (!(class_name === _p)) {
    _M0MP24tiye9dom_2dffi7Element14set__attribute(element, "class", class_name);
  }
  const _p$2 = "";
  if (!(text === _p$2)) {
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(element, text);
  }
  return element;
}
function _M0FP310Haoxincode8moonbash7website21append__block_2einner(dom, text, tone) {
  if (text === "") {
    return undefined;
  }
  const block = _M0FP310Haoxincode8moonbash7website23create__element_2einner("pre", `moonbash-line moonbash-line-${tone}`, "");
  const normalized = _M0MPC16string10StringView9to__owned(_M0MPC16string6String9trim__end(text, undefined));
  if (normalized === "") {
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(block, text);
  } else {
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(block, normalized);
  }
  _M0FP310Haoxincode8moonbash7website6append(dom.output, block);
  _M0FP310Haoxincode8moonbash7website27element__scroll__to__bottom(dom.output);
}
function _M0FP310Haoxincode8moonbash7website19availability__total(plan) {
  let count = 0;
  const _bind = plan.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const step = plan[_];
      if (step.kind === "availability") {
        count = count + 1 | 0;
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return count;
}
function _M0FP310Haoxincode8moonbash7website13current__mode(app) {
  return _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(app.val.demo_modes, app.val.current_mode_idx);
}
function _M0FP310Haoxincode8moonbash7website12smoke__total(plan) {
  let count = 0;
  const _bind = plan.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const step = plan[_];
      if (step.kind === "smoke") {
        count = count + 1 | 0;
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return count;
}
function _M0FP310Haoxincode8moonbash7website18append__mode__hint(app) {
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  const plan = mode.steps;
  if (plan.length === 0) {
    return undefined;
  }
  const _p = mode.intro;
  const _p$2 = "";
  if (!(_p === _p$2)) {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, mode.intro, "hint");
  }
  if (mode.key === "verification") {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, `${mode.title}\n${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website19availability__total(plan))} registry checks + ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website12smoke__total(plan))} smoke tests are ready. Use the panel above or type demo to run them.`, "hint");
    return;
  } else {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, `${mode.title}\n${mode.summary}\nUse the tabs above or type showcase to run the mission script.`, "hint");
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website10build__dom() {
  const _bind = _M0FP24tiye9dom_2dffi30document__get__element__by__id("app");
  let root;
  if (_bind.$tag === 1) {
    const _Some = _bind;
    root = _Some._0;
  } else {
    _M0FP310Haoxincode8moonbash7website16throw__js__error("missing #app mount point");
    root = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "", "");
  }
  _M0MP24tiye9dom_2dffi7Element16set__inner__html(root, "");
  const shell = _M0FP310Haoxincode8moonbash7website23create__element_2einner("main", "moonbash-shell", "");
  _M0FP310Haoxincode8moonbash7website6append(root, shell);
  const header = _M0FP310Haoxincode8moonbash7website23create__element_2einner("header", "moonbash-header", "");
  _M0FP310Haoxincode8moonbash7website6append(shell, header);
  const title_wrap = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-title", "");
  const badge = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-badge", "MoonBit Frontend");
  const heading = _M0FP310Haoxincode8moonbash7website23create__element_2einner("h1", "moonbash-heading", "moonbash");
  const subtitle = _M0FP310Haoxincode8moonbash7website23create__element_2einner("p", "moonbash-subtitle", "A browser terminal recreating justbash.dev with MoonBash running fully in memory.");
  _M0FP310Haoxincode8moonbash7website6append(title_wrap, badge);
  _M0FP310Haoxincode8moonbash7website6append(title_wrap, heading);
  _M0FP310Haoxincode8moonbash7website6append(title_wrap, subtitle);
  _M0FP310Haoxincode8moonbash7website6append(header, title_wrap);
  const meta = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-meta", "");
  const status = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-status", "MoonBit -> JS • Browser Runtime • In-memory FS");
  const nav = _M0FP310Haoxincode8moonbash7website23create__element_2einner("nav", "moonbash-nav", "");
  const github = _M0FP310Haoxincode8moonbash7website23create__element_2einner("a", "moonbash-link", "GitHub");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(github, "target", "_blank");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(github, "rel", "noreferrer");
  const docs = _M0FP310Haoxincode8moonbash7website23create__element_2einner("a", "moonbash-link", "Docs");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(docs, "target", "_blank");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(docs, "rel", "noreferrer");
  _M0FP310Haoxincode8moonbash7website6append(nav, github);
  _M0FP310Haoxincode8moonbash7website6append(nav, docs);
  _M0FP310Haoxincode8moonbash7website6append(meta, status);
  _M0FP310Haoxincode8moonbash7website6append(meta, nav);
  _M0FP310Haoxincode8moonbash7website6append(header, meta);
  const demo_panel = _M0FP310Haoxincode8moonbash7website23create__element_2einner("section", "moonbash-demo", "");
  _M0FP310Haoxincode8moonbash7website6append(shell, demo_panel);
  const tabs = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-tabs", "");
  const verification_tab = _M0FP310Haoxincode8moonbash7website23create__element_2einner("button", "moonbash-demo-tab is-active", "Verification");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(verification_tab, "type", "button");
  _M0MP24tiye9dom_2dffi7Element20set__data__attribute(verification_tab, "mode", "verification");
  const showcase_tab = _M0FP310Haoxincode8moonbash7website23create__element_2einner("button", "moonbash-demo-tab", "Showcase");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(showcase_tab, "type", "button");
  _M0MP24tiye9dom_2dffi7Element20set__data__attribute(showcase_tab, "mode", "showcase");
  _M0FP310Haoxincode8moonbash7website6append(tabs, verification_tab);
  _M0FP310Haoxincode8moonbash7website6append(tabs, showcase_tab);
  _M0FP310Haoxincode8moonbash7website6append(demo_panel, tabs);
  const demo_info = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-info", "");
  const title_row = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-title-row", "");
  const demo_title = _M0FP310Haoxincode8moonbash7website23create__element_2einner("h2", "moonbash-demo-title", "");
  const demo_state = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-demo-state", "");
  _M0FP310Haoxincode8moonbash7website6append(title_row, demo_title);
  _M0FP310Haoxincode8moonbash7website6append(title_row, demo_state);
  const demo_summary = _M0FP310Haoxincode8moonbash7website23create__element_2einner("p", "moonbash-demo-summary", "");
  const demo_meta = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-meta", "");
  const demo_progress = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-demo-progress", "");
  const demo_last = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-demo-last", "");
  _M0FP310Haoxincode8moonbash7website6append(demo_meta, demo_progress);
  _M0FP310Haoxincode8moonbash7website6append(demo_meta, demo_last);
  _M0FP310Haoxincode8moonbash7website6append(demo_info, title_row);
  _M0FP310Haoxincode8moonbash7website6append(demo_info, demo_summary);
  _M0FP310Haoxincode8moonbash7website6append(demo_info, demo_meta);
  const demo_actions = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-actions", "");
  const run_button = _M0FP310Haoxincode8moonbash7website23create__element_2einner("button", "moonbash-demo-button moonbash-demo-button-primary", "Run");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(run_button, "type", "button");
  const replay_button = _M0FP310Haoxincode8moonbash7website23create__element_2einner("button", "moonbash-demo-button moonbash-demo-button-ghost", "Replay");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(replay_button, "type", "button");
  const stop_button = _M0FP310Haoxincode8moonbash7website23create__element_2einner("button", "moonbash-demo-button moonbash-demo-button-ghost", "Stop");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(stop_button, "type", "button");
  _M0FP310Haoxincode8moonbash7website6append(demo_actions, run_button);
  _M0FP310Haoxincode8moonbash7website6append(demo_actions, replay_button);
  _M0FP310Haoxincode8moonbash7website6append(demo_actions, stop_button);
  const demo_bar = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-bar", "");
  const demo_bar_fill = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-demo-bar-fill", "");
  _M0FP310Haoxincode8moonbash7website6append(demo_bar, demo_bar_fill);
  _M0FP310Haoxincode8moonbash7website6append(demo_panel, demo_info);
  _M0FP310Haoxincode8moonbash7website6append(demo_panel, demo_actions);
  _M0FP310Haoxincode8moonbash7website6append(demo_panel, demo_bar);
  const viewport = _M0FP310Haoxincode8moonbash7website23create__element_2einner("section", "moonbash-viewport", "");
  _M0FP310Haoxincode8moonbash7website6append(shell, viewport);
  const output = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-output", "");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(output, "role", "log");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(output, "aria-live", "polite");
  _M0FP310Haoxincode8moonbash7website6append(viewport, output);
  const input_row = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-input-row", "");
  const location = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-location", "");
  const prompt = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-prompt", "$");
  const input_element = _M0FP310Haoxincode8moonbash7website23create__element_2einner("input", "moonbash-input", "");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "type", "text");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "autocomplete", "off");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "autocapitalize", "off");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "autocorrect", "off");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "spellcheck", "false");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(input_element, "aria-label", "MoonBash command input");
  _M0FP310Haoxincode8moonbash7website6append(input_row, location);
  _M0FP310Haoxincode8moonbash7website6append(input_row, prompt);
  _M0FP310Haoxincode8moonbash7website6append(input_row, input_element);
  _M0FP310Haoxincode8moonbash7website6append(viewport, input_row);
  return new _M0TP310Haoxincode8moonbash7website7DomRefs(shell, demo_title, github, docs, output, input_row, _M0MP24tiye9dom_2dffi7Element37reinterpret__as__html__input__element(input_element), location, demo_panel, tabs, verification_tab, showcase_tab, demo_state, demo_summary, demo_progress, demo_last, demo_bar_fill, run_button, replay_button, stop_button);
}
function _M0FP310Haoxincode8moonbash7website20create__banner__step(group, label, text) {
  return new _M0TP310Haoxincode8moonbash7website8DemoStep("banner", group, label, text, "", undefined, [], [], 80);
}
function _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner(group, label, command, expect_stdout_includes, delay_ms) {
  return new _M0TP310Haoxincode8moonbash7website8DemoStep("command", group, label, "", command, _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einnerN6constrS591, expect_stdout_includes, [], delay_ms);
}
function _M0FP310Haoxincode8moonbash7website21build__showcase__plan() {
  return [_M0FP310Haoxincode8moonbash7website20create__banner__step("阶段一", "核心启动", "阶段一：核心启动\n先确认这份中文任务数据已经被真实装载进浏览器内存文件系统。"), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段一", "数据集巡检", "find /demo -maxdepth 2 | sort", ["/demo/data", "/demo/logs", "/demo/src", "/demo/notes"], 180), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段一", "核心启动完成", "核心能力已就绪：路径解析、虚拟文件系统和命令分发都在浏览器里真实运行。"), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段二", "文本排障", "阶段二：文本排障\n像值班排障一样，用 grep、head、tail 快速定位中文日志里的异常。"), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段二", "错误聚焦", "grep -n ERROR /demo/logs/app.log | head -5", ["4:2026-04-18T09:00:04Z ERROR 接口: 上游超时", "6:2026-04-18T09:00:06Z ERROR Worker: 载荷解析失败"], 180), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段二", "最近事件窗口", "tail -3 /demo/logs/app.log", ["ERROR Worker: 载荷解析失败", "INFO Worker: 重试后恢复"], 180), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段二", "文本排障完成", "文本处理链路已验证：日志过滤、截取和输出都是真实命令结果。"), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段三", "数据分析", "阶段三：数据分析\n用 jq 和 awk 直接处理中文业务数据，看这套浏览器 shell 能不能真的干活。"), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段三", "专业版用户数", "cat /demo/data/users.json | jq '.users | map(select(.plan==\"专业版\")) | length'", ["3"], 180), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段三", "营收汇总", "awk -F, 'NR>1 { sum += $3 } END { print sum }' /demo/data/revenue.csv", ["8270"], 180), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段三", "数据分析完成", "数据工作流已验证：jq 和 awk 处理的是中文数据集，不是伪造输出。"), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段四", "文件系统巡检", "阶段四：文件系统巡检\n继续浏览代码快照和说明文档，确认浏览器里的虚拟项目结构可探索。"), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段四", "源码统计", "find /demo/src -name '*.mbt' | wc -l", ["5"], 180), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段四", "目录体积", "du /demo/src", ["/demo/src"], 180), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段四", "文件系统巡检完成", "文件系统工作流已验证：浏览器 shell 正在遍历、统计并读取真实虚拟文件。"), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段五", "浏览器证明", "阶段五：浏览器证明\n最后用一条中文流水线收尾，证明这不是摆设终端，而是可执行的浏览器 shell。"), _M0FP310Haoxincode8moonbash7website30create__showcase__step_2einner("阶段五", "中文终端流水线", "printf '月壤终端浏览器任务流\\n' | cut -c1-10", ["月壤终端浏览器任务流"], 180), _M0FP310Haoxincode8moonbash7website20create__banner__step("阶段五", "任务完成", "浏览器任务流完成。MoonBash 刚刚在这个标签页里跑完了一整套中文真实工作流。")];
}
function _M0FP310Haoxincode8moonbash7website12shell__quote(value) {
  return `'${value}'`;
}
function _M0FP310Haoxincode8moonbash7website26create__availability__step(name, group) {
  return new _M0TP310Haoxincode8moonbash7website8DemoStep("availability", group, name, "", `command -v ${_M0FP310Haoxincode8moonbash7website12shell__quote(name)} >/dev/null && printf 'verified %s\\n' ${_M0FP310Haoxincode8moonbash7website12shell__quote(name)}`, _M0FP310Haoxincode8moonbash7website26create__availability__stepN6constrS592, [`verified ${name}`], [], 35);
}
function _M0FP310Haoxincode8moonbash7website25build__verification__plan(config) {
  const website_commands = ["about", "install", "github"];
  const steps = [];
  const _bind = config.command_names;
  const _bind$2 = _bind.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind$2) {
      const name = _bind[_];
      _M0MPC15array5Array4pushGsE(steps, _M0FP310Haoxincode8moonbash7website26create__availability__step(name, "MoonBash"));
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$3 = website_commands.length;
  let _tmp$2 = 0;
  while (true) {
    const _ = _tmp$2;
    if (_ < _bind$3) {
      const name = website_commands[_];
      _M0MPC15array5Array4pushGsE(steps, _M0FP310Haoxincode8moonbash7website26create__availability__step(name, "Website"));
      _tmp$2 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "filesystem seed", "", "mkdir -p /tmp/moonbash-demo/docs && printf 'alpha\\nbeta\\nalpha\\n' > /tmp/moonbash-demo/docs/data.txt && ls /tmp/moonbash-demo/docs", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS593, ["data.txt"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "grep finds beta", "", "grep -n beta /tmp/moonbash-demo/docs/data.txt", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS594, ["2:beta"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "sed prints second line", "", "sed -n '2p' /tmp/moonbash-demo/docs/data.txt", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS595, ["beta"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "awk counts lines", "", "awk 'END { print NR }' /tmp/moonbash-demo/docs/data.txt", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS596, ["3"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "sort and uniq collapse values", "", "sort /tmp/moonbash-demo/docs/data.txt | uniq | paste -sd ',' -", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS597, ["alpha,beta"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "find locates demo file", "", "find /tmp/moonbash-demo -type f | wc -l", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS598, ["1"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "jq reads package version", "", "cat /home/user/package.json | jq -r '.version'", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS599, [config.version], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "head reads README", "", "head -1 /home/user/README.md", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS600, ["# MoonBash"], [], 140));
  _M0MPC15array5Array4pushGsE(steps, new _M0TP310Haoxincode8moonbash7website8DemoStep("smoke", "Smoke", "text transform pipeline", "", "printf 'moonbash\\n' | tr a-z A-Z | cut -c1-8", _M0FP310Haoxincode8moonbash7website25build__verification__planN6constrS601, ["MOONBASH"], [], 140));
  return steps;
}
function _M0FP310Haoxincode8moonbash7website18build__demo__modes(config) {
  return [new _M0TP310Haoxincode8moonbash7website8DemoMode("verification", config.verification_title, "Registry checks plus smoke tests for command availability and baseline behavior.", "", config.verification_auto_start, config.verification_initial_delay_ms, _M0FP310Haoxincode8moonbash7website25build__verification__plan(config)), new _M0TP310Haoxincode8moonbash7website8DemoMode("showcase", config.showcase_title, "任务式中文工作流演示：日志排障、JSON 分析、CSV 汇总、文件系统巡检，全都在浏览器里真实执行。", config.showcase_intro, false, 700, _M0FP310Haoxincode8moonbash7website21build__showcase__plan())];
}
function _M0FP310Haoxincode8moonbash7website20command__step__total(steps) {
  let total = 0;
  const _bind = steps.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const step = steps[_];
      const _p = step.kind;
      const _p$2 = "banner";
      if (!(_p === _p$2)) {
        total = total + 1 | 0;
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return total;
}
function _M0FP310Haoxincode8moonbash7website20create__shell__state(config) {
  return new _M0TP310Haoxincode8moonbash7website10ShellState(_M0FP310Haoxincode8moonbash7website21create__bash__runtime(_M0FP310Haoxincode8moonbash7website26get__runtime__config__json()), config.cwd, config.env);
}
function _M0FP310Haoxincode8moonbash7website17find__mode__index(modes, key) {
  const _bind = modes.length;
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < _bind) {
      if (_M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(modes, i).key === key) {
        return i;
      }
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return 0;
}
function _M0FP310Haoxincode8moonbash7website13load__history() {
  const storage = _M0MP24tiye9dom_2dffi6Window14local__storage(_M0FP24tiye9dom_2dffi6window());
  const _bind = _M0MP24tiye9dom_2dffi12LocalStorage9get__item(storage, "moonbash-website-history");
  if (_bind === undefined) {
    return [];
  } else {
    const _Some = _bind;
    const _raw = _Some;
    let _try_err;
    _L: {
      const _bind$2 = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(_raw, 0, _raw.length), 1024);
      let parsed;
      if (_bind$2.$tag === 1) {
        const _ok = _bind$2;
        parsed = _ok._0;
      } else {
        const _err = _bind$2;
        _try_err = _err._0;
        break _L;
      }
      const _bind$3 = _M0FPC14json10from__jsonGRPB5ArrayGsEE(parsed, undefined);
      if (_bind$3.$tag === 1) {
        const _ok = _bind$3;
        return _ok._0;
      } else {
        const _err = _bind$3;
        _try_err = _err._0;
        break _L;
      }
    }
    return [];
  }
}
function _M0FP310Haoxincode8moonbash7website16make__app__state(config, dom) {
  const modes = _M0FP310Haoxincode8moonbash7website18build__demo__modes(config);
  const mode_idx = _M0FP310Haoxincode8moonbash7website17find__mode__index(modes, config.default_mode);
  const mode = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(modes, mode_idx);
  const plan = mode.steps;
  return new _M0TP310Haoxincode8moonbash7website8AppState(config, dom, modes, mode_idx, _M0FP310Haoxincode8moonbash7website20create__shell__state(config), _M0FP310Haoxincode8moonbash7website13load__history(), _M0FP310Haoxincode8moonbash7website13load__history().length, "", false, false, 0, 0, 0, 0, plan.length === 0 ? "disabled" : "idle", plan.length === 0 ? "No verification plan configured." : mode.key === "verification" ? `${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website19availability__total(plan))} registry checks + ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website12smoke__total(plan))} smoke tests ready.` : `Mission playlist ready with ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website20command__step__total(plan))} executable steps.`);
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGsE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGbE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGbE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGiE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGiE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB5ArrayGsEE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGRPB5ArrayGsEE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB3MapGssEE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGRPB3MapGssEE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB5ArrayGRPB4JsonEE(value, default_) {
  if (value === undefined) {
    return default_;
  } else {
    const _Some = value;
    const _json = _Some;
    let _try_err;
    _L: {
      const _bind = _M0FPC14json10from__jsonGRPB5ArrayGRPB4JsonEE(_json, undefined);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        return _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L;
      }
    }
    return default_;
  }
}
function _M0FP310Haoxincode8moonbash7website23json__object__or__empty(json) {
  if (json.$tag === 6) {
    const _Object = json;
    return _Object._0;
  } else {
    const _bind = [];
    return _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind, 0, 0), undefined);
  }
}
function _M0FP310Haoxincode8moonbash7website22parse__website__config(json_text) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_text, 0, json_text.length), 1024);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        parsed = _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _bind = [];
    const _p = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind, 0, 0), undefined);
    parsed = new _M0DTPB4Json6Object(_p);
  }
  const obj = _M0FP310Haoxincode8moonbash7website23json__object__or__empty(parsed);
  const _tmp = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "version"), "0.1.0");
  const _tmp$2 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "githubUrl"), "");
  const _tmp$3 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "docsUrl"), "");
  const _tmp$4 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "welcomeText"), "");
  const _tmp$5 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "showcaseIntro"), "");
  const _tmp$6 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "initialCommand"), "");
  const _tmp$7 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "verificationTitle"), "Real Browser Verification");
  const _tmp$8 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "showcaseTitle"), "Agent Mission / Browser Ops Console");
  const _tmp$9 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "defaultMode"), "verification");
  const _tmp$10 = _M0FP310Haoxincode8moonbash7website16decode__json__orGbE(_M0MPB3Map3getGsRPB4JsonE(obj, "verificationAutoStart"), false);
  const _tmp$11 = _M0FP310Haoxincode8moonbash7website16decode__json__orGiE(_M0MPB3Map3getGsRPB4JsonE(obj, "verificationInitialDelayMs"), 900);
  const _tmp$12 = _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB5ArrayGsEE(_M0MPB3Map3getGsRPB4JsonE(obj, "commandNames"), []);
  const _tmp$13 = _M0MPB3Map3getGsRPB4JsonE(obj, "env");
  const _bind = [];
  return new _M0TP310Haoxincode8moonbash7website13WebsiteConfig(_tmp, _tmp$2, _tmp$3, _tmp$4, _tmp$5, _tmp$6, _tmp$7, _tmp$8, _tmp$9, _tmp$10, _tmp$11, _tmp$12, _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB3MapGssEE(_tmp$13, _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind, 0, 0), undefined)), _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "cwd"), "/home/user"));
}
function _M0FP310Haoxincode8moonbash7website20find__word__boundary(value, cursor) {
  let start = cursor;
  while (true) {
    let _tmp;
    if (start > 0) {
      const _tmp$2 = start - 1 | 0;
      $bound_check(value, _tmp$2);
      _tmp = value.charCodeAt(_tmp$2) !== 32;
    } else {
      _tmp = false;
    }
    if (_tmp) {
      start = start - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return start;
}
function _M0FP310Haoxincode8moonbash7website19parse__dir__entries(json_text) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_text, 0, json_text.length), 1024);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        parsed = _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _p = [];
    parsed = new _M0DTPB4Json5Array(_p);
  }
  const items = _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB5ArrayGRPB4JsonEE(parsed, []);
  const entries = [];
  const _bind = items.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const item = items[_];
      const obj = _M0FP310Haoxincode8moonbash7website23json__object__or__empty(item);
      _M0MPC15array5Array4pushGsE(entries, new _M0TP310Haoxincode8moonbash7website8DirEntry(_M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "name"), ""), _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "type"), "")));
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return entries;
}
function _M0FP310Haoxincode8moonbash7website24list__current__directory(app) {
  const entries = _M0FP310Haoxincode8moonbash7website19parse__dir__entries(_M0MP310Haoxincode8moonbash7website11BashRuntime13readdir__json(app.val.shell.bash, app.val.shell.cwd));
  const names = [];
  const _bind = entries.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const entry = entries[_];
      if (entry.type_ === "directory") {
        _M0MPC15array5Array4pushGsE(names, `${entry.name}/`);
      } else {
        _M0MPC15array5Array4pushGsE(names, entry.name);
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return names;
}
function _M0FP310Haoxincode8moonbash7website17apply__completion(app) {
  const value = _M0MP24tiye9dom_2dffi16HtmlInputElement5value(app.val.dom.input);
  const cursor = _M0FP310Haoxincode8moonbash7website29html__input__selection__start(app.val.dom.input);
  const start = _M0FP310Haoxincode8moonbash7website20find__word__boundary(value, cursor);
  const prefix = _M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, start, cursor));
  if (prefix === "") {
    return undefined;
  }
  let candidates;
  if (_M0MPC16string10StringView9to__owned(_M0MPC16string6String4trim(_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, start)), undefined)) === "") {
    const names = [];
    const _bind = app.val.config.command_names;
    const _bind$2 = _bind.length;
    let _tmp = 0;
    while (true) {
      const _ = _tmp;
      if (_ < _bind$2) {
        const name = _bind[_];
        _M0MPC15array5Array4pushGsE(names, name);
        _tmp = _ + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    _M0MPC15array5Array4pushGsE(names, "about");
    _M0MPC15array5Array4pushGsE(names, "install");
    _M0MPC15array5Array4pushGsE(names, "github");
    _M0MPC15array5Array4pushGsE(names, "clear");
    _M0MPC15array5Array4pushGsE(names, "demo");
    _M0MPC15array5Array4pushGsE(names, "verify");
    _M0MPC15array5Array4pushGsE(names, "showcase");
    candidates = names;
  } else {
    candidates = _M0FP310Haoxincode8moonbash7website24list__current__directory(app);
  }
  const matches = [];
  const _bind = candidates.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind) {
      const candidate = candidates[_];
      const _tmp$2 = _M0FP310Haoxincode8moonbash7website17string__lowercase(candidate);
      const _bind$2 = _M0FP310Haoxincode8moonbash7website17string__lowercase(prefix);
      if (_M0MPC16string6String11has__prefix(_tmp$2, new _M0TPC16string10StringView(_bind$2, 0, _bind$2.length))) {
        _M0MPC15array5Array4pushGsE(matches, candidate);
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (matches.length === 0) {
    return undefined;
  }
  if (matches.length === 1) {
    const completion = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(matches, 0);
    const next_value = `${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, 0, start))}${completion}${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(value, cursor, undefined))}`;
    _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, next_value);
    const next_cursor = start + completion.length | 0;
    _M0FP310Haoxincode8moonbash7website34html__input__set__selection__range(app.val.dom.input, next_cursor, next_cursor);
    return undefined;
  }
  _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, _M0MPC15array5Array4joinGsE(matches, new _M0TPC16string10StringView(_M0FP310Haoxincode8moonbash7website17apply__completionN7_2abindS357, 0, _M0FP310Haoxincode8moonbash7website17apply__completionN7_2abindS357.length)), "hint");
}
function _M0FP310Haoxincode8moonbash7website15append__command(dom, cwd, command) {
  const line = _M0FP310Haoxincode8moonbash7website23create__element_2einner("div", "moonbash-command", "");
  const cwd_text = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-command-cwd", cwd);
  const prompt = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-command-prompt", "$");
  const command_text = _M0FP310Haoxincode8moonbash7website23create__element_2einner("span", "moonbash-command-text", command);
  _M0FP310Haoxincode8moonbash7website6append(line, cwd_text);
  _M0FP310Haoxincode8moonbash7website6append(line, prompt);
  _M0FP310Haoxincode8moonbash7website6append(line, command_text);
  _M0FP310Haoxincode8moonbash7website6append(dom.output, line);
  _M0FP310Haoxincode8moonbash7website27element__scroll__to__bottom(dom.output);
}
function _M0FP310Haoxincode8moonbash7website19apply__exec__result(app, result) {
  app.val.shell.env = result.env;
  const _bind = _M0MPB3Map3getGssE(result.env, "PWD");
  if (_bind === undefined) {
  } else {
    const _Some = _bind;
    const _pwd = _Some;
    const _p = "";
    if (!(_pwd === _p)) {
      app.val.shell.cwd = _pwd;
    }
  }
  const _p = result.stdout;
  const _p$2 = "";
  if (!(_p === _p$2)) {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, result.stdout, "stdout");
  }
  const _p$3 = result.stderr;
  const _p$4 = "";
  if (!(_p$3 === _p$4)) {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, result.stderr, "stderr");
  }
  if (result.stdout === "" && (result.stderr === "" && result.exit_code !== 0)) {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, `[exit ${_M0IPC13int3IntPB4Show10to__string(result.exit_code)}]`, "hint");
    return;
  } else {
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website14collapse__home(path, home) {
  if (path === home) {
    return "~";
  } else {
    const _bind = `${home}/`;
    if (_M0MPC16string6String11has__prefix(path, new _M0TPC16string10StringView(_bind, 0, _bind.length))) {
      return `~${_M0MPC16string10StringView9to__owned(_M0MPC16string6String12view_2einner(path, home.length, undefined))}`;
    } else {
      return path;
    }
  }
}
function _M0FP310Haoxincode8moonbash7website19encode__string__map(values) {
  const _bind = [];
  const payload = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind, 0, 0), undefined);
  const _it = _M0MPB3Map5iter2GssE(values);
  while (true) {
    const _bind$2 = _M0MPB5Iter24nextGssE(_it);
    if (_bind$2 === undefined) {
      break;
    } else {
      const _Some = _bind$2;
      const _x = _Some;
      const _key = _x._0;
      const _value = _x._1;
      _M0MPB3Map3setGsRPB4JsonE(payload, _key, new _M0DTPB4Json6String(_value));
      continue;
    }
  }
  return _M0MPC14json4Json17stringify_2einner(new _M0DTPB4Json6Object(payload), false, 0, undefined);
}
function _M0FP310Haoxincode8moonbash7website19parse__exec__result(json_text) {
  let parsed;
  let _try_err;
  _L: {
    _L$2: {
      const _bind = _M0FPC14json13parse_2einner(new _M0TPC16string10StringView(json_text, 0, json_text.length), 1024);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        parsed = _ok._0;
      } else {
        const _err = _bind;
        _try_err = _err._0;
        break _L$2;
      }
      break _L;
    }
    const _bind = [];
    const _p = _M0MPB3Map3MapGsRPB4JsonE(new _M0TPB9ArrayViewGUsRPB4JsonEE(_bind, 0, 0), undefined);
    parsed = new _M0DTPB4Json6Object(_p);
  }
  const obj = _M0FP310Haoxincode8moonbash7website23json__object__or__empty(parsed);
  const _tmp = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "stdout"), "");
  const _tmp$2 = _M0FP310Haoxincode8moonbash7website16decode__json__orGsE(_M0MPB3Map3getGsRPB4JsonE(obj, "stderr"), "");
  const _tmp$3 = _M0FP310Haoxincode8moonbash7website16decode__json__orGiE(_M0MPB3Map3getGsRPB4JsonE(obj, "exitCode"), 1);
  const _tmp$4 = _M0MPB3Map3getGsRPB4JsonE(obj, "env");
  const _bind = [];
  return new _M0TP310Haoxincode8moonbash7website10ExecResult(_tmp, _tmp$2, _tmp$3, _M0FP310Haoxincode8moonbash7website16decode__json__orGRPB3MapGssEE(_tmp$4, _M0MPB3Map3MapGssE(new _M0TPB9ArrayViewGUssEE(_bind, 0, 0), undefined)));
}
function _M0FP310Haoxincode8moonbash7website24stringify__string__array(values) {
  const _p = new Array(values.length);
  const _p$2 = values.length;
  let _tmp = 0;
  while (true) {
    const _p$3 = _tmp;
    if (_p$3 < _p$2) {
      const _p$4 = values[_p$3];
      _p[_p$3] = new _M0DTPB4Json6String(_p$4);
      _tmp = _p$3 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const items = _p;
  return _M0MPC14json4Json17stringify_2einner(new _M0DTPB4Json5Array(items), false, 0, undefined);
}
function _M0FP310Haoxincode8moonbash7website13save__history(history) {
  const storage = _M0MP24tiye9dom_2dffi6Window14local__storage(_M0FP24tiye9dom_2dffi6window());
  const trimmed = [];
  const start = history.length > 100 ? history.length - 100 | 0 : 0;
  const _bind = history.length;
  let _tmp = start;
  while (true) {
    const i = _tmp;
    if (i < _bind) {
      _M0MPC15array5Array4pushGsE(trimmed, _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(history, i));
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  _M0MP24tiye9dom_2dffi12LocalStorage9set__item(storage, "moonbash-website-history", _M0FP310Haoxincode8moonbash7website24stringify__string__array(trimmed));
}
function _M0FP310Haoxincode8moonbash7website23persist__history__entry(app, command) {
  _M0MPC15array5Array4pushGsE(app.val.history, command);
  if (app.val.history.length > 100) {
    const trimmed = [];
    const start = app.val.history.length - 100 | 0;
    const _bind = app.val.history.length;
    let _tmp = start;
    while (true) {
      const i = _tmp;
      if (i < _bind) {
        _M0MPC15array5Array4pushGsE(trimmed, _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(app.val.history, i));
        _tmp = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    app.val.history = trimmed;
  }
  app.val.history_index = app.val.history.length;
  _M0FP310Haoxincode8moonbash7website13save__history(app.val.history);
}
function _M0FP310Haoxincode8moonbash7website13render__intro(app) {
  _M0MP24tiye9dom_2dffi7Element16set__inner__html(app.val.dom.output, "");
  const _p = app.val.config.welcome_text;
  const _p$2 = "";
  if (!(_p === _p$2)) {
    _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, app.val.config.welcome_text, "intro");
    return;
  } else {
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website21set__button__disabled(element, disabled) {
  if (disabled) {
    _M0MP24tiye9dom_2dffi7Element14set__attribute(element, "disabled", "disabled");
    return;
  } else {
    _M0MP24tiye9dom_2dffi7Element17remove__attribute(element, "disabled");
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website20set__input__disabled(input_row, input, disabled) {
  if (disabled) {
    _M0MP24tiye9dom_2dffi7Element14set__attribute(input_row, "class", "moonbash-input-row is-busy");
    _M0FP310Haoxincode8moonbash7website26html__input__set__disabled(input, true);
    return;
  } else {
    _M0MP24tiye9dom_2dffi7Element14set__attribute(input_row, "class", "moonbash-input-row");
    _M0FP310Haoxincode8moonbash7website26html__input__set__disabled(input, false);
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website10update__ui(app) {
  const dom = app.val.dom;
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  const plan = mode.steps;
  const total = _M0FP310Haoxincode8moonbash7website20command__step__total(plan);
  const _bind = app.val.verification_status;
  let status_label;
  switch (_bind) {
    case "running": {
      status_label = "Running";
      break;
    }
    case "passed": {
      status_label = "Passed";
      break;
    }
    case "failed": {
      status_label = "Failed";
      break;
    }
    case "stopped": {
      status_label = "Stopped";
      break;
    }
    case "disabled": {
      status_label = "Disabled";
      break;
    }
    default: {
      status_label = "Idle";
    }
  }
  _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.location, _M0FP310Haoxincode8moonbash7website14collapse__home(app.val.shell.cwd, app.val.config.cwd));
  _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.title, mode.title);
  _M0MP24tiye9dom_2dffi7Element20set__data__attribute(dom.demo_panel, "state", app.val.verification_status);
  _M0MP24tiye9dom_2dffi7Element20set__data__attribute(dom.tabs, "mode", mode.key);
  _M0MP24tiye9dom_2dffi7Element14set__attribute(dom.verification_tab, "class", mode.key === "verification" ? "moonbash-demo-tab is-active" : "moonbash-demo-tab");
  _M0MP24tiye9dom_2dffi7Element14set__attribute(dom.showcase_tab, "class", mode.key === "showcase" ? "moonbash-demo-tab is-active" : "moonbash-demo-tab");
  _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_state, status_label);
  if (total === 0) {
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_summary, "No verification plan is configured for this demo.");
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_progress, "0 checks");
    _M0MP24tiye9dom_2dffi19CSSStyleDeclaration13set__property(_M0MP24tiye9dom_2dffi4Node5style(_M0MP24tiye9dom_2dffi7Element21reinterpret__as__node(dom.demo_bar_fill)), "transform", "scaleX(0)");
  } else {
    if (mode.key === "verification") {
      const avail = _M0FP310Haoxincode8moonbash7website19availability__total(plan);
      const smoke = _M0FP310Haoxincode8moonbash7website12smoke__total(plan);
      _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_summary, `${_M0IPC13int3IntPB4Show10to__string(avail)} registry checks + ${_M0IPC13int3IntPB4Show10to__string(smoke)} smoke tests. Every step is executed through real MoonBash calls in this browser.`);
    } else {
      _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_summary, mode.summary);
    }
    _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_progress, `${_M0IPC13int3IntPB4Show10to__string(app.val.verification_completed)}/${_M0IPC13int3IntPB4Show10to__string(total)} steps • ${_M0IPC13int3IntPB4Show10to__string(app.val.verification_passed)} passed • ${_M0IPC13int3IntPB4Show10to__string(app.val.verification_failed)} failed`);
    const ratio = total === 0 ? 0 : (app.val.verification_completed + 0) / (total + 0);
    _M0MP24tiye9dom_2dffi19CSSStyleDeclaration13set__property(_M0MP24tiye9dom_2dffi4Node5style(_M0MP24tiye9dom_2dffi7Element21reinterpret__as__node(dom.demo_bar_fill)), "transform", `scaleX(${_M0IPC16double6DoublePB4Show10to__string(ratio)})`);
  }
  _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.demo_last, app.val.verification_last_message);
  _M0FP310Haoxincode8moonbash7website20set__input__disabled(dom.input_row, dom.input, app.val.command_running || app.val.verification_running);
  _M0FP310Haoxincode8moonbash7website21set__button__disabled(dom.run_button, app.val.verification_running || total === 0);
  _M0FP310Haoxincode8moonbash7website21set__button__disabled(dom.replay_button, app.val.verification_running || total === 0);
  _M0FP310Haoxincode8moonbash7website21set__button__disabled(dom.stop_button, !app.val.verification_running);
}
function _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einnerN16_2aasync__driverS467(_state) {
  let _tmp = _state;
  while (true) {
    const _state$2 = _tmp;
    if (_state$2.$tag === 0) {
      const _State_0 = _state$2;
      const after_done = _State_0._2;
      const app = _State_0._1;
      const _cont_param = _State_0._0;
      const result = _M0FP310Haoxincode8moonbash7website19parse__exec__result(_cont_param);
      _M0FP310Haoxincode8moonbash7website19apply__exec__result(app, result);
      app.val.command_running = false;
      _M0FP310Haoxincode8moonbash7website10update__ui(app);
      _M0FP310Haoxincode8moonbash7website18html__input__focus(app.val.dom.input);
      if (after_done === undefined) {
        return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
      } else {
        const _Some = after_done;
        const _f = _Some;
        return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(_f(result));
      }
    } else {
      const _$42$try$47$418 = _state$2;
      const after_done = _$42$try$47$418._2;
      const app = _$42$try$47$418._1;
      const _try_err = _$42$try$47$418._0;
      _tmp = new _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State8State__0(`{\"stdout\":\"\",\"stderr\":\"${_M0IPC15error5ErrorPB4Show10to__string(_try_err)}\",\"exitCode\":1,\"env\":{}}`, app, after_done);
      continue;
    }
  }
}
function _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einner(app, command, record_history, after_done, _cont, _err_cont) {
  const trimmed = _M0MPC16string10StringView9to__owned(_M0MPC16string6String4trim(command, undefined));
  if (trimmed === "" || app.val.command_running) {
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
  }
  _M0FP310Haoxincode8moonbash7website15append__command(app.val.dom, _M0FP310Haoxincode8moonbash7website14collapse__home(app.val.shell.cwd, app.val.config.cwd), trimmed);
  if (record_history) {
    _M0FP310Haoxincode8moonbash7website23persist__history__entry(app, trimmed);
  }
  if (trimmed === "clear") {
    _M0FP310Haoxincode8moonbash7website13render__intro(app);
    _M0FP310Haoxincode8moonbash7website18append__mode__hint(app);
    _M0FP310Haoxincode8moonbash7website10update__ui(app);
    _M0FP310Haoxincode8moonbash7website27element__scroll__to__bottom(app.val.dom.output);
    return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
  }
  app.val.command_running = true;
  _M0FP310Haoxincode8moonbash7website10update__ui(app);
  const env_json = _M0FP310Haoxincode8moonbash7website19encode__string__map(app.val.shell.env);
  let _err;
  _L: {
    const _bind = _M0MP311moonbitlang5async9js__async7Promise4waitGsE(_M0MP310Haoxincode8moonbash7website11BashRuntime10exec__json(app.val.shell.bash, trimmed, app.val.shell.cwd, env_json), _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None__, (_cont_param) => {
      let _err$2;
      _L$2: {
        const _bind$2 = _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einnerN16_2aasync__driverS467(new _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State8State__0(_cont_param, app, after_done));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$3 = _bind$2;
          _err$2 = _err$3._0;
          break _L$2;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some = _bind$3;
          const _payload = _Some;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err$2);
    }, (_cont_param) => {
      let _err$2;
      _L$2: {
        const _bind$2 = _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einnerN16_2aasync__driverS467(new _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State12_2atry_2f418(_cont_param, app, after_done));
        let _bind$3;
        if (_bind$2.$tag === 1) {
          const _ok = _bind$2;
          _bind$3 = _ok._0;
        } else {
          const _err$3 = _bind$2;
          _err$2 = _err$3._0;
          break _L$2;
        }
        if (_bind$3 === -1) {
          return;
        } else {
          const _Some = _bind$3;
          const _payload = _Some;
          _cont(_payload);
          return;
        }
      }
      _err_cont(_err$2);
    });
    let _bind$2;
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _bind$2 = _ok._0;
    } else {
      const _err$2 = _bind;
      _err = _err$2._0;
      break _L;
    }
    if (_bind$2 === undefined) {
      return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
    } else {
      const _Some = _bind$2;
      const _payload = _Some;
      return _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einnerN16_2aasync__driverS467(new _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State8State__0(_payload, app, after_done));
    }
  }
  return _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einnerN16_2aasync__driverS467(new _M0DTP310Haoxincode8moonbash7website71_24Haoxincode_2fmoonbash_2fwebsite_2erun__shell__command__async_2einnerL5State12_2atry_2f418(_err, app, after_done));
}
function _M0FP310Haoxincode8moonbash7website17spawn__background(task) {
  _M0MP311moonbitlang5async9js__async7Promise11from__asyncGuE(task, _M0DTPC16option6OptionGRP311moonbitlang5async9js__async11AbortSignalE4None__);
}
function _M0FP310Haoxincode8moonbash7website27run__shell__command_2einner(app, command, record_history, after_done) {
  _M0FP310Haoxincode8moonbash7website17spawn__background((_cont, _err_cont) => _M0FP310Haoxincode8moonbash7website34run__shell__command__async_2einner(app, command, record_history, after_done, _cont, _err_cont));
}
function _M0FP310Haoxincode8moonbash7website19run__shell__command(app, command, record_history$46$opt, after_done$46$opt) {
  const record_history = record_history$46$opt === -1 ? false : record_history$46$opt;
  let after_done;
  if (after_done$46$opt.$tag === 1) {
    const _Some = after_done$46$opt;
    after_done = _Some._0;
  } else {
    after_done = undefined;
  }
  _M0FP310Haoxincode8moonbash7website27run__shell__command_2einner(app, command, record_history, after_done);
}
function _M0FP310Haoxincode8moonbash7website21reset__shell__runtime(app) {
  app.val.shell = _M0FP310Haoxincode8moonbash7website20create__shell__state(app.val.config);
}
function _M0FP310Haoxincode8moonbash7website14evaluate__step(step, result) {
  const diagnostics = [];
  const _bind = step.expect_exit_code;
  if (_bind === undefined) {
  } else {
    const _Some = _bind;
    const _expected = _Some;
    if (result.exit_code !== _expected) {
      _M0MPC15array5Array4pushGsE(diagnostics, `expected exit ${_M0IPC13int3IntPB4Show10to__string(_expected)}, got ${_M0IPC13int3IntPB4Show10to__string(result.exit_code)}`);
    }
  }
  const _bind$2 = step.expect_stdout_includes;
  const _bind$3 = _bind$2.length;
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < _bind$3) {
      const needle = _bind$2[_];
      if (!_M0MPC16string6String8contains(result.stdout, new _M0TPC16string10StringView(needle, 0, needle.length))) {
        _M0MPC15array5Array4pushGsE(diagnostics, `stdout missing '${needle}'`);
      }
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const _bind$4 = step.expect_stderr_includes;
  const _bind$5 = _bind$4.length;
  let _tmp$2 = 0;
  while (true) {
    const _ = _tmp$2;
    if (_ < _bind$5) {
      const needle = _bind$4[_];
      if (!_M0MPC16string6String8contains(result.stderr, new _M0TPC16string10StringView(needle, 0, needle.length))) {
        _M0MPC15array5Array4pushGsE(diagnostics, `stderr missing '${needle}'`);
      }
      _tmp$2 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const ok = diagnostics.length === 0;
  const verb = step.kind === "availability" ? "registered" : "passed";
  const joined = _M0MPC15array5Array4joinGsE(diagnostics, new _M0TPC16string10StringView(_M0FP310Haoxincode8moonbash7website14evaluate__stepN7_2abindS446, 0, _M0FP310Haoxincode8moonbash7website14evaluate__stepN7_2abindS446.length));
  const message = ok ? `✓ [${step.group}] ${step.label} ${verb}` : `✗ [${step.group}] ${step.label} — ${joined}`;
  return { _0: ok, _1: message };
}
function _M0FP310Haoxincode8moonbash7website24run__verification__asyncN16_2aasync__driverS501(_state) {
  let _tmp = _state;
  _L: while (true) {
    const _state$2 = _tmp;
    switch (_state$2.$tag) {
      case 0: {
        const _State_0 = _state$2;
        const steps = _State_0._3;
        const run_id = _State_0._2;
        const app = _State_0._1;
        if (run_id !== app.val.verification_run_id) {
          return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
        }
        app.val.verification_running = false;
        app.val.verification_status = app.val.verification_failed > 0 ? "failed" : "passed";
        app.val.verification_last_message = app.val.verification_failed > 0 ? `Completed with ${_M0IPC13int3IntPB4Show10to__string(app.val.verification_failed)} failures out of ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website20command__step__total(steps))} steps.` : `Completed ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website20command__step__total(steps))} real steps with no failures.`;
        _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, app.val.verification_last_message, app.val.verification_failed > 0 ? "stderr" : "success");
        return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(_M0FP310Haoxincode8moonbash7website10update__ui(app));
      }
      case 1: {
        const _$42$for_1 = _state$2;
        const _err_cont = _$42$for_1._7;
        const _cont = _$42$for_1._6;
        const _bind = _$42$for_1._5;
        const completed_commands = _$42$for_1._4;
        const steps$2 = _$42$for_1._3;
        const run_id$2 = _$42$for_1._2;
        const app$2 = _$42$for_1._1;
        const i = _$42$for_1._0;
        if (i < _bind) {
          if (run_id$2 !== app$2.val.verification_run_id) {
            return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
          }
          const step = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(steps$2, i);
          const delay_ms = step.delay_ms < 0 ? 0 : step.delay_ms;
          if (delay_ms > 0) {
            const _bind$2 = _M0FP211moonbitlang5async5sleep(delay_ms, (_cont_param) => {
              let _err;
              _L$2: {
                const _bind$3 = _M0FP310Haoxincode8moonbash7website24run__verification__asyncN16_2aasync__driverS501(new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__5(_cont_param, app$2, run_id$2, steps$2, completed_commands, i, step, _bind, _cont, _err_cont));
                let _bind$4;
                if (_bind$3.$tag === 1) {
                  const _ok = _bind$3;
                  _bind$4 = _ok._0;
                } else {
                  const _err$2 = _bind$3;
                  _err = _err$2._0;
                  break _L$2;
                }
                if (_bind$4 === -1) {
                  return;
                } else {
                  const _Some = _bind$4;
                  const _payload = _Some;
                  _cont(_payload);
                  return;
                }
              }
              _err_cont(_err);
            }, _err_cont);
            let _bind$3;
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              _bind$3 = _ok._0;
            } else {
              return _bind$2;
            }
            if (_bind$3 === -1) {
              return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
            } else {
              const _Some = _bind$3;
              const _payload = _Some;
              _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__5(_payload, app$2, run_id$2, steps$2, completed_commands, i, step, _bind, _cont, _err_cont);
              continue _L;
            }
          } else {
            _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__5(undefined, app$2, run_id$2, steps$2, completed_commands, i, step, _bind, _cont, _err_cont);
            continue _L;
          }
        } else {
          _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__0(undefined, app$2, run_id$2, steps$2);
          continue _L;
        }
      }
      case 2: {
        const _$42$continue$47$447 = _state$2;
        const _err_cont$2 = _$42$continue$47$447._7;
        const _cont$2 = _$42$continue$47$447._6;
        const _bind$2 = _$42$continue$47$447._5;
        const i$2 = _$42$continue$47$447._4;
        const completed_commands$2 = _$42$continue$47$447._3;
        const steps$3 = _$42$continue$47$447._2;
        const run_id$3 = _$42$continue$47$447._1;
        const app$3 = _$42$continue$47$447._0;
        _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State9_2afor__1(i$2 + 1 | 0, app$3, run_id$3, steps$3, completed_commands$2, _bind$2, _cont$2, _err_cont$2);
        continue _L;
      }
      case 3: {
        const _State_3 = _state$2;
        const _err_cont$3 = _State_3._9;
        const _cont$3 = _State_3._8;
        const _bind$3 = _State_3._7;
        const step = _State_3._6;
        const i$3 = _State_3._5;
        const completed_commands$3 = _State_3._4;
        const steps$4 = _State_3._3;
        const run_id$4 = _State_3._2;
        const app$4 = _State_3._1;
        const _cont_param = _State_3._0;
        const result = _M0FP310Haoxincode8moonbash7website19parse__exec__result(_cont_param);
        _M0FP310Haoxincode8moonbash7website19apply__exec__result(app$4, result);
        app$4.val.command_running = false;
        const _bind$4 = _M0FP310Haoxincode8moonbash7website14evaluate__step(step, result);
        const _ok = _bind$4._0;
        const _message = _bind$4._1;
        completed_commands$3.val = completed_commands$3.val + 1 | 0;
        app$4.val.verification_completed = completed_commands$3.val;
        if (_ok) {
          const _bind$5 = app$4.val;
          _bind$5.verification_passed = _bind$5.verification_passed + 1 | 0;
        } else {
          const _bind$5 = app$4.val;
          _bind$5.verification_failed = _bind$5.verification_failed + 1 | 0;
        }
        app$4.val.verification_last_message = _message;
        _M0FP310Haoxincode8moonbash7website21append__block_2einner(app$4.val.dom, _message, _ok ? "success" : "stderr");
        _M0FP310Haoxincode8moonbash7website10update__ui(app$4);
        _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State17_2acontinue_2f447(app$4, run_id$4, steps$4, completed_commands$3, i$3, _bind$3, _cont$3, _err_cont$3);
        continue _L;
      }
      case 4: {
        const _$42$try$47$456 = _state$2;
        const _err_cont$4 = _$42$try$47$456._9;
        const _cont$4 = _$42$try$47$456._8;
        const _bind$5 = _$42$try$47$456._7;
        const step$2 = _$42$try$47$456._6;
        const i$4 = _$42$try$47$456._5;
        const completed_commands$4 = _$42$try$47$456._4;
        const steps$5 = _$42$try$47$456._3;
        const run_id$5 = _$42$try$47$456._2;
        const app$5 = _$42$try$47$456._1;
        const _try_err = _$42$try$47$456._0;
        _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__3(`{\"stdout\":\"\",\"stderr\":\"${_M0IPC15error5ErrorPB4Show10to__string(_try_err)}\",\"exitCode\":1,\"env\":{}}`, app$5, run_id$5, steps$5, completed_commands$4, i$4, step$2, _bind$5, _cont$4, _err_cont$4);
        continue _L;
      }
      default: {
        const _State_5 = _state$2;
        const _err_cont$5 = _State_5._9;
        const _cont$5 = _State_5._8;
        const _bind$6 = _State_5._7;
        const step$3 = _State_5._6;
        const i$5 = _State_5._5;
        const completed_commands$5 = _State_5._4;
        const steps$6 = _State_5._3;
        const run_id$6 = _State_5._2;
        const app$6 = _State_5._1;
        if (run_id$6 !== app$6.val.verification_run_id) {
          return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(undefined);
        }
        if (step$3.kind === "banner") {
          const _p = step$3.text;
          const _p$2 = "";
          if (!(_p === _p$2)) {
            _M0FP310Haoxincode8moonbash7website21append__block_2einner(app$6.val.dom, step$3.text, "hint");
          }
          const _tmp$2 = app$6.val;
          let _tmp$3;
          const _p$3 = step$3.label;
          const _p$4 = "";
          if (!(_p$3 === _p$4)) {
            _tmp$3 = step$3.label;
          } else {
            _tmp$3 = step$3.group;
          }
          _tmp$2.verification_last_message = _tmp$3;
          _M0FP310Haoxincode8moonbash7website10update__ui(app$6);
          _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State17_2acontinue_2f447(app$6, run_id$6, steps$6, completed_commands$5, i$5, _bind$6, _cont$5, _err_cont$5);
          continue _L;
        }
        const env_json = _M0FP310Haoxincode8moonbash7website19encode__string__map(app$6.val.shell.env);
        _M0FP310Haoxincode8moonbash7website15append__command(app$6.val.dom, _M0FP310Haoxincode8moonbash7website14collapse__home(app$6.val.shell.cwd, app$6.val.config.cwd), step$3.command);
        app$6.val.command_running = true;
        _M0FP310Haoxincode8moonbash7website10update__ui(app$6);
        let _err;
        _L$2: {
          const _bind$7 = _M0MP311moonbitlang5async9js__async7Promise4waitGsE(_M0MP310Haoxincode8moonbash7website11BashRuntime10exec__json(app$6.val.shell.bash, step$3.command, app$6.val.shell.cwd, env_json), _M0DTPC16option6OptionGRP311moonbitlang5async9js__async15AbortControllerE4None__, (_cont_param$2) => {
            let _err$2;
            _L$3: {
              const _bind$8 = _M0FP310Haoxincode8moonbash7website24run__verification__asyncN16_2aasync__driverS501(new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__3(_cont_param$2, app$6, run_id$6, steps$6, completed_commands$5, i$5, step$3, _bind$6, _cont$5, _err_cont$5));
              let _bind$9;
              if (_bind$8.$tag === 1) {
                const _ok$2 = _bind$8;
                _bind$9 = _ok$2._0;
              } else {
                const _err$3 = _bind$8;
                _err$2 = _err$3._0;
                break _L$3;
              }
              if (_bind$9 === -1) {
                return;
              } else {
                const _Some = _bind$9;
                const _payload = _Some;
                _cont$5(_payload);
                return;
              }
            }
            _err_cont$5(_err$2);
          }, (_cont_param$2) => {
            let _err$2;
            _L$3: {
              const _bind$8 = _M0FP310Haoxincode8moonbash7website24run__verification__asyncN16_2aasync__driverS501(new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State12_2atry_2f456(_cont_param$2, app$6, run_id$6, steps$6, completed_commands$5, i$5, step$3, _bind$6, _cont$5, _err_cont$5));
              let _bind$9;
              if (_bind$8.$tag === 1) {
                const _ok$2 = _bind$8;
                _bind$9 = _ok$2._0;
              } else {
                const _err$3 = _bind$8;
                _err$2 = _err$3._0;
                break _L$3;
              }
              if (_bind$9 === -1) {
                return;
              } else {
                const _Some = _bind$9;
                const _payload = _Some;
                _cont$5(_payload);
                return;
              }
            }
            _err_cont$5(_err$2);
          });
          let _bind$8;
          if (_bind$7.$tag === 1) {
            const _ok$2 = _bind$7;
            _bind$8 = _ok$2._0;
          } else {
            const _err$2 = _bind$7;
            _err = _err$2._0;
            break _L$2;
          }
          if (_bind$8 === undefined) {
            return new _M0DTPC16result6ResultGOuRPC15error5ErrorE2Ok(-1);
          } else {
            const _Some = _bind$8;
            const _payload = _Some;
            _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State8State__3(_payload, app$6, run_id$6, steps$6, completed_commands$5, i$5, step$3, _bind$6, _cont$5, _err_cont$5);
            continue _L;
          }
        }
        _tmp = new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State12_2atry_2f456(_err, app$6, run_id$6, steps$6, completed_commands$5, i$5, step$3, _bind$6, _cont$5, _err_cont$5);
        continue _L;
      }
    }
  }
}
function _M0FP310Haoxincode8moonbash7website24run__verification__async(app, run_id, _cont, _err_cont) {
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  const steps = mode.steps;
  const completed_commands = new _M0TPB8MutLocalGiE(0);
  const _bind = steps.length;
  return _M0FP310Haoxincode8moonbash7website24run__verification__asyncN16_2aasync__driverS501(new _M0DTP310Haoxincode8moonbash7website61_24Haoxincode_2fmoonbash_2fwebsite_2erun__verification__asyncL5State9_2afor__1(0, app, run_id, steps, completed_commands, _bind, _cont, _err_cont));
}
function _M0FP310Haoxincode8moonbash7website19start__verification(app) {
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  const steps = mode.steps;
  if (app.val.verification_running || steps.length === 0) {
    return undefined;
  }
  const _bind = app.val;
  _bind.verification_run_id = _bind.verification_run_id + 1 | 0;
  const run_id = app.val.verification_run_id;
  app.val.verification_running = true;
  app.val.verification_status = "running";
  app.val.verification_completed = 0;
  app.val.verification_passed = 0;
  app.val.verification_failed = 0;
  app.val.verification_last_message = `Starting ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website20command__step__total(steps))} real steps...`;
  _M0FP310Haoxincode8moonbash7website21reset__shell__runtime(app);
  _M0FP310Haoxincode8moonbash7website13render__intro(app);
  _M0FP310Haoxincode8moonbash7website18append__mode__hint(app);
  _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
  _M0FP310Haoxincode8moonbash7website10update__ui(app);
  _M0FP310Haoxincode8moonbash7website17spawn__background((_cont, _err_cont) => _M0FP310Haoxincode8moonbash7website24run__verification__async(app, run_id, _cont, _err_cont));
}
function _M0FP310Haoxincode8moonbash7website18stop__verification(app, reason) {
  if (!app.val.verification_running) {
    return undefined;
  }
  const _bind = app.val;
  _bind.verification_run_id = _bind.verification_run_id + 1 | 0;
  app.val.verification_running = false;
  app.val.verification_status = "stopped";
  app.val.verification_last_message = reason;
  _M0FP310Haoxincode8moonbash7website21append__block_2einner(app.val.dom, reason, "hint");
  _M0FP310Haoxincode8moonbash7website10update__ui(app);
}
function _M0FP310Haoxincode8moonbash7website12switch__mode(app, key) {
  const next_idx = _M0FP310Haoxincode8moonbash7website17find__mode__index(app.val.demo_modes, key);
  if (next_idx === app.val.current_mode_idx) {
    return undefined;
  }
  if (app.val.verification_running) {
    _M0FP310Haoxincode8moonbash7website18stop__verification(app, `Switched demo mode to ${key}.`);
  }
  app.val.current_mode_idx = next_idx;
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  const plan = mode.steps;
  app.val.verification_completed = 0;
  app.val.verification_passed = 0;
  app.val.verification_failed = 0;
  app.val.verification_status = plan.length === 0 ? "disabled" : "idle";
  app.val.verification_last_message = plan.length === 0 ? "No verification plan configured." : mode.key === "verification" ? `${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website19availability__total(plan))} registry checks + ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website12smoke__total(plan))} smoke tests ready.` : `Mission playlist ready with ${_M0IPC13int3IntPB4Show10to__string(_M0FP310Haoxincode8moonbash7website20command__step__total(plan))} executable steps.`;
  _M0FP310Haoxincode8moonbash7website13render__intro(app);
  _M0FP310Haoxincode8moonbash7website18append__mode__hint(app);
  _M0FP310Haoxincode8moonbash7website10update__ui(app);
}
function _M0FP310Haoxincode8moonbash7website13handle__enter(app) {
  const command = _M0MP24tiye9dom_2dffi16HtmlInputElement5value(app.val.dom.input);
  const trimmed = _M0MPC16string10StringView9to__owned(_M0MPC16string6String4trim(command, undefined));
  if (trimmed === "") {
    return undefined;
  }
  if (trimmed === "demo") {
    _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
    _M0FP310Haoxincode8moonbash7website19start__verification(app);
    return undefined;
  }
  if (trimmed === "verify") {
    _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
    _M0FP310Haoxincode8moonbash7website12switch__mode(app, "verification");
    _M0FP310Haoxincode8moonbash7website19start__verification(app);
    return undefined;
  }
  if (trimmed === "showcase") {
    _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
    _M0FP310Haoxincode8moonbash7website12switch__mode(app, "showcase");
    _M0FP310Haoxincode8moonbash7website19start__verification(app);
    return undefined;
  }
  if (trimmed === "demo stop" || (trimmed === "verify stop" || trimmed === "showcase stop")) {
    _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
    _M0FP310Haoxincode8moonbash7website18stop__verification(app, "Verification stopped from terminal command.");
    return undefined;
  }
  _M0FP310Haoxincode8moonbash7website19run__shell__command(app, trimmed, _M0FP310Haoxincode8moonbash7website13handle__enterN6constrS602, _M0DTPC16option6OptionGOWRP310Haoxincode8moonbash7website10ExecResultEuE4None__);
  _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, "");
  app.val.draft_command = "";
  app.val.history_index = app.val.history.length;
}
function _M0FP310Haoxincode8moonbash7website18register__handlers(app) {
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.run_button, (_event) => {
    _M0FP310Haoxincode8moonbash7website19start__verification(app);
  });
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.replay_button, (_event) => {
    _M0FP310Haoxincode8moonbash7website19start__verification(app);
  });
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.stop_button, (_event) => {
    _M0FP310Haoxincode8moonbash7website18stop__verification(app, "Verification stopped from controls.");
  });
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.verification_tab, (_event) => {
    _M0FP310Haoxincode8moonbash7website12switch__mode(app, "verification");
  });
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.showcase_tab, (_event) => {
    _M0FP310Haoxincode8moonbash7website12switch__mode(app, "showcase");
  });
  _M0MP24tiye9dom_2dffi7Element12set__onclick(app.val.dom.shell, (_event) => {
    if (!app.val.command_running) {
      _M0FP310Haoxincode8moonbash7website18html__input__focus(app.val.dom.input);
      return;
    } else {
      return;
    }
  });
  _M0MP24tiye9dom_2dffi16HtmlInputElement14set__onkeydown(app.val.dom.input, (event) => {
    const key = _M0MP24tiye9dom_2dffi13KeyboardEvent3key(event);
    if (key === "Tab") {
      _M0MP24tiye9dom_2dffi13KeyboardEvent16prevent__default(event);
      _M0FP310Haoxincode8moonbash7website17apply__completion(app);
      return undefined;
    }
    if (key === "ArrowUp") {
      _M0MP24tiye9dom_2dffi13KeyboardEvent16prevent__default(event);
      if (app.val.history_index === app.val.history.length) {
        app.val.draft_command = _M0MP24tiye9dom_2dffi16HtmlInputElement5value(app.val.dom.input);
      }
      if (app.val.history_index > 0) {
        const _bind = app.val;
        _bind.history_index = _bind.history_index - 1 | 0;
        const command = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(app.val.history, app.val.history_index);
        _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, command);
        const cursor = command.length;
        _M0FP310Haoxincode8moonbash7website34html__input__set__selection__range(app.val.dom.input, cursor, cursor);
      }
      return undefined;
    }
    if (key === "ArrowDown") {
      _M0MP24tiye9dom_2dffi13KeyboardEvent16prevent__default(event);
      if (app.val.history_index < (app.val.history.length - 1 | 0)) {
        const _bind = app.val;
        _bind.history_index = _bind.history_index + 1 | 0;
        const command = _M0MPC15array5Array2atGRP310Haoxincode8moonbash7website8DemoModeE(app.val.history, app.val.history_index);
        _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, command);
      } else {
        app.val.history_index = app.val.history.length;
        _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(app.val.dom.input, app.val.draft_command);
      }
      const cursor = _M0MP24tiye9dom_2dffi16HtmlInputElement5value(app.val.dom.input).length;
      _M0FP310Haoxincode8moonbash7website34html__input__set__selection__range(app.val.dom.input, cursor, cursor);
      return undefined;
    }
    if (key === "Enter") {
      _M0MP24tiye9dom_2dffi13KeyboardEvent16prevent__default(event);
      _M0FP310Haoxincode8moonbash7website13handle__enter(app);
      return;
    } else {
      return;
    }
  });
}
function _M0FP310Haoxincode8moonbash7website17mount__demo__impl() {
  const config = _M0FP310Haoxincode8moonbash7website22parse__website__config(_M0FP310Haoxincode8moonbash7website26get__runtime__config__json());
  const dom = _M0FP310Haoxincode8moonbash7website10build__dom();
  const app = _M0MPC13ref3Ref3RefGRP310Haoxincode8moonbash7website8AppStateE(_M0FP310Haoxincode8moonbash7website16make__app__state(config, dom));
  _M0MP24tiye9dom_2dffi7Element16set__inner__text(dom.title, config.verification_title);
  _M0MP24tiye9dom_2dffi7Element14set__attribute(dom.github_link, "href", config.github_url);
  _M0MP24tiye9dom_2dffi7Element14set__attribute(dom.docs_link, "href", config.docs_url);
  _M0FP310Haoxincode8moonbash7website18register__handlers(app);
  _M0FP310Haoxincode8moonbash7website13render__intro(app);
  _M0FP310Haoxincode8moonbash7website18append__mode__hint(app);
  _M0MP24tiye9dom_2dffi16HtmlInputElement10set__value(dom.input, config.initial_command);
  _M0FP310Haoxincode8moonbash7website10update__ui(app);
  _M0FP310Haoxincode8moonbash7website18html__input__focus(dom.input);
  _M0FP310Haoxincode8moonbash7website27element__scroll__to__bottom(dom.output);
  const mode = _M0FP310Haoxincode8moonbash7website13current__mode(app);
  let _tmp;
  if (mode.autoplay) {
    const _p = mode.steps;
    _tmp = !(_p.length === 0);
  } else {
    _tmp = false;
  }
  if (_tmp) {
    const delay_ms = mode.initial_delay_ms < 0 ? 0 : mode.initial_delay_ms;
    _M0FP24tiye9dom_2dffi12set__timeout(() => {
      _M0FP310Haoxincode8moonbash7website19start__verification(app);
    }, delay_ms + 0 | 0);
    return;
  } else {
    return;
  }
}
function _M0FP310Haoxincode8moonbash7website11mount__demo() {
  _M0FP310Haoxincode8moonbash7website17mount__demo__impl();
}
export { _M0FP310Haoxincode8moonbash7website11mount__demo as mount_demo }
